/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/skillmacros/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	$(function(){
		var common=__webpack_require__(2);
		var login=__webpack_require__(1);
		var calcData=__webpack_require__(4);
		var training=__webpack_require__(3);
		var search=__webpack_require__(10);
		var skillIconUrl=__webpack_require__(7);
		var cData=calcData[cname];
		var skillList=[];
		login.init();
		// common.init();
		var detail={
			el:$(".m-macro"),
			init:function(){
				var _this=this;
				this.el.find(".applyBtn").click(function(){
					if(!isLogined){
						login.show();
						return;
					}
					serverPop.show();
				})
				this.addContent();
				this.el.find(".evaluateBtn").click(function(){
					if(!isLogined){
						login.show();
						return;
					}
					if($(this).hasClass("hasEvaluated")){
						return;
					}
					evaluatePop.show();
				})
				// this.el.find(".zanBtn").click(function(){
				// 	_this.addZan();
				// })
				this.el.find(".starBtn").click(function(){
					_this.addCollect();
				})
				this.el.find(".voteBtn").click(function(){
					var index=$(this).parent().index();
					_this.vote(index);
				})
				this.appendTag();
				this.addShare();
				this.initVote();
				// $(".macroInfo").niceScroll();
			},
			initVote:function(){
				for(var i=0;i<6;i++){
					$(".voteBtn").parent().eq(i).find(".num").html(toupiao["vote"+(i+1)]);
				}
			},
			vote:function(index){
				toupiao["vote"+(index+1)]++;
				var toupiaoStr=JSON.stringify(toupiao);
				$.getJSON("/skillmacros/updateToupiaoStrById.json?targetId="+macrosId+"&toupiaoStr="+toupiaoStr,function(msg){
					$(".voteBtn-"+(index+1)).parent().find(".num").html(toupiao["vote"+(index+1)]);
				})			
			},
			addShare:function(){
				var share = null;
			    nie.use(["nie.util.shareV5"],function(){
			        share = nie.util.share({
			            fat:".shareCnt",
			            type:1,
			            defShow:[23,22,2,1,4],
			            title:shareObj.title+shareObj.content,
			            url:shareObj.url,
			            img:shareObj.img,
			            content:null,
			            product:"ty"
			        }); 
			        $(".shareCnt .morebtn").remove();
			        $(".shareCnt .NIE-share-txt").remove();
			        $(".shareCnt").attr("style","");
			    });
			},
			addZan:function(){
				var _this=this;
				if(!isLogined){
					login.show();
					return;
				}
				$.getJSON("/skillmacros/addSkillmacrosPraise.json?id="+macrosId,function(msg){
					if(msg.resCode==11){
						login.show();
						return;
					}
					if(msg.resCode!=0){
						common.showCommonPop(msg.resReason);
						return;
					}
					var num=parseInt(_this.el.find(".zanNum").html());
					_this.el.find(".zanNum").html(num+1);
				})
			},
			addCollect:function(){
				var _this=this;
				if(!isLogined){
					login.show();
					return;
				}
				if(isCollect){
					$.getJSON("/skillmacros/deleteByCollectId.json?id="+macrosId,function(msg){
						if(msg.resCode==11){
							login.show();
							return;
						}
						if(msg.resCode!=0){
							common.showCommonPop(msg.resReason);
							return;
						}
						var num=parseInt(_this.el.find(".collectNum").html());
						_this.el.find(".collectNum").html(num-1);
						isCollect=false;
					})
				}else{
					$.getJSON("/skillmacros/addSkillmacrosCollection.json?id="+macrosId,function(msg){
						if(msg.resCode==11){
							login.show();
							return;
						}
						if(msg.resCode!=0){
							common.showCommonPop(msg.resReason);
							return;
						}
						var num=parseInt(_this.el.find(".collectNum").html());
						_this.el.find(".collectNum").html(num+1);
						isCollect=true;
					})
				}
				
			},
			addContent:function(){
				if(macrosContent!=null){
					var html="";
					for(var i=0;i<macrosContent.macroList.length;i++){
						if(macrosContent.macroList[i]=="") continue;
						var img=skillIconUrl.getUrl(macrosContent.macroList[i]);					
						if(img!=""){
							html+="<img src='"+img+"' width='40' height='40'>"
						}
						html+=macrosContent.macroList[i];
						html+="<br>";
					}
					this.el.find(".macroInfo").html(html);
				}
				//添加分数
				tuijian=common.toDecimal(tuijian);
				$(".applyCnt .num").html(tuijian+"分");
				if(tuijian=="0.0"){
					$(".applyCnt .num").html("暂无");
				}
				var starCount=tuijian/2;
				var floor=Math.floor(starCount);
				var ceil=Math.round(starCount);
				var html='';
				for(var i=0;i<floor;i++){
					this.el.find(".starCnt").append('<i class="star"></i>');
				}
				if(ceil>floor){
					this.el.find(".starCnt").append('<i class="star star-half"></i>');
				}
			},
			appendTag:function(){
				if(tag!=null){
					if(tag.type==0){
						this.el.find(".titleCnt").append('<span class="u-tags u-tags-pvp">PVP</span>');
						this.el.find(".tagCnt").append('<span class="u-tags u-tags-pvp">PVP</span>');
					}else{
						this.el.find(".titleCnt").append('<span class="u-tags u-tags-pve">PVE</span>');
						this.el.find(".tagCnt").append('<span class="u-tags u-tags-pve">PVE</span>');
					}
					for(var i in tag.list){
						this.el.find(".tagCnt").append('<span class="u-tags u-tags-pvp">'+tag.list[i]+'</span>');
					}
				}
			}
		}
		
		var evaluatePop={
			el:$(".m-evaluatePop"),
			evaluate:0,
			recommend:0,
			init:function(){
				var _this=this;
				this.el.find(".closeBtn").click(function(){
					_this.el.hide();
				})
				this.el.find(".submitBtn").click(function(){
					_this.submit();
				})
				this.el.find(".star").click(function(){
					var index=$(this).index();
					_this.refreshRecommend(index);
					_this.recommend=index+1;
				})
	
			},
			refreshRecommend:function(index){
				for(var i=0;i<=index;i++){
					this.el.find(".star").eq(i).addClass("active");
				}
				for(i=index+1;i<5;i++){
					this.el.find(".star").eq(i).removeClass("active");
				}
			},
			submit:function(){
				if(this.recommend==0){
					common.showCommonPop("您还未做任何评价，期待您的点评");
					return;
				}
				$.getJSON("/skillmacros/updateTuijianById.json?targetId="+macrosId+"&tuijian="+this.recommend,function(msg){
					if(msg.resCode==11){
						return;
					}
					if(msg.resCode!=0){
						common.showCommonPop(msg.resReason);
						return;
					}
					$(".m-macro .evaluateBtn").addClass("hasEvaluated").html("已评价").attr("title","您已提交宝贵的评价，感谢您对技能宏库的支持！");
				})
				this.el.hide();
				
			},
			show:function(){
				this.el.show();
			},
			hide:function(){
				this.el.hide();
			}
		}
	
		var serverPop={
			el:$(".m-serverPop"),
			buckNameServers:null,
			servers:null,
			selectedBuckName:null,
			selectedServer:null,
			allRoleList:[],
			init:function(){
				var _this=this;
				this.el.find(".closeBtn").click(function(){
					_this.hide();
				})
				this.el.find(".serverConfirmBtn").click(function(){
					_this.hide();
					rolesPop.show();
				})
				this.el.click(function(e){
					if($(e.target).hasClass("areaBtn")){
						_this.el.find(".areaBtn").removeClass("active");
						$(e.target).addClass("active");
						_this.selectedBuckName=$(e.target).html();
						_this.refreshServers();
					}
					if($(e.target).hasClass("serverBtn")){
						_this.el.find(".serverBtn").removeClass("active");
						$(e.target).addClass("active");
						_this.selectedServer=$(e.target).attr("data-id");
					}
				})
				this.getRoleList();			
			},
			getRoleList:function(){
				var _this=this;
				$.getJSON("/app/rolebind/rolelistForWeb.json?bindStatus=-1&limit=100&offset=0",function(msg){
					if(msg.resCode==0){
						_this.allRoleList=msg.data;
						_this.getServerList();
					}				
				})
			},
			getServerList:function(){
				var _this=this;
				// if(window.location.hostname=="hd.tianyu.163.com"){
				// 	_this.buckNameServers={"开天辟地":{"10009":"星茸花语","10001":"梦回苏澜"},"云垂盛世":{"10031":"浮生若梦","10060":"烟雨沧澜"}};
				// 	_this.servers={"servers":{"10001":"梦回苏澜","10009":"星茸花语","10031":"浮生若梦","10060":"烟雨沧澜"}};
				// 	_this.refreshBuckName();
				// }else{
					$.getJSON("/rank/getServerInfo.json?callback=?",function(msg){
						// msg=rootmsg;
						_this.buckNameServers=msg.data.buckNameServers;
						_this.servers=msg.data.servers;
						_this.refreshBuckName();
					})
				// }		
			},
			displayAllServers:function(){
				var html='';
				for(var i in this.servers){
					html+='<a href="javascript:;" class="serverBtn" data-id="'+i+'">'+this.servers[i]+'</a>';
				}
				this.el.find(".serverCnt").html(html);
			},
			refreshBuckName:function(){
				var html='';
				for(var i in this.buckNameServers){
					html+='<a href="javascript:;" class="areaBtn">'+i+'</a>';
				}
				this.el.find(".areaCnt").html(html);
				this.el.find(".areaBtn").eq(0).click();
	
				if(i==undefined){
					this.displayAllServers();
				}
				
			},
			refreshServers:function(){
				var html='';
				var serverMap=this.buckNameServers[this.selectedBuckName];
				for(var i in serverMap){
					html+='<a href="javascript:;" class="serverBtn" data-id="'+i+'">'+serverMap[i]+'</a>';
				}
				this.el.find(".serverCnt").html(html);
			},
			show:function(){
				this.el.show();
			},
			hide:function(){
				this.el.hide();
			}
		}
	
		var rolesPop={
			el:$(".m-rolesPop"),
			roleList:[],
			selsectedGbid:"",
			init:function(){
				var _this=this;
				this.el.find(".closeBtn").click(function(){
					_this.hide();
				})
				this.el.find(".backBtn").click(function(){
					serverPop.show();
					_this.hide();
				})
				this.el.find(".confirmBtn").click(function(){
					_this.applyMacros();
					// _this.hide();
				})
				this.el.on("click",".roleBtn",function(e){
					_this.el.find(".roleBtn").removeClass("active");
					$(this).addClass("active");
					_this.selsectedGbid=$(this).attr("data-gbId");
				})
			},
			getRoleList:function(){
				var allRoleList=serverPop.allRoleList;
				var selectedServer=serverPop.selectedServer;
				this.roleList=[];
				for(var i in allRoleList){
					if(allRoleList[i].server==selectedServer&&allRoleList[i].school==macroSchool){
						this.roleList.push(allRoleList[i]);
					}
				}
				if(this.roleList.length==0){
					common.showCommonPop("该服务器下没有此宏对应的职业角色，请重新选择服务器或前往游戏创建角色");
					return;
				}
				var source   = $("#roleItem-template").html();
				var template = Handlebars.compile(source);
				var html    = template({list:this.roleList});
				$(".rolesCnt").html(html);
				this.el.show();
			},
			applyMacros:function(){
				var _this=this;
				if(this.selsectedGbid==""){
					common.showCommonPop("请选择角色信息！");
					return;
				}
				$.getJSON("/skillmacros/addSkillmacrosApply.json?gbId="+this.selsectedGbid+"&targetId="+macrosId,function(msg){
					if(msg.resCode==2){
						common.showCommonPop("请保持游戏角色在线，重新应用该宏！");
						return;
					}
					if(msg.resCode==3){
						common.showCommonPop("宏库已满暂时无法新增宏！");
						return;
					}
					if(msg.resCode!=0){
						common.showCommonPop("应用失败");
						return;
					}
					common.showCommonPop("恭喜，宏应用成功<br>请前往游戏体验宏效果！");
					var num=parseInt($(".zanNum").html());
					$(".zanNum").html(num+1);
					_this.hide();
				})
			},
			show:function(){
				this.selsectedGbid="";
				this.getRoleList();			
			},
			hide:function(){
				this.el.hide();
			}
		}
	
		detail.init();
		evaluatePop.init();
		serverPop.init();
		rolesPop.init();
	
	})


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var login={
		el:$(".m-loginPop"),
		init:function(){
			// var cssFile = getAbsoluteUrl(require('!file!autoprefixer?{browsers: "> 1%"}!less!../css/login.css'));
			// var urs = new URS({
	        //     newCDN: 1,
	        //     version: 3,
	        //     product : 'd21', //【必须】使用的产品ID，如urs
	        //     promark : 'dNvgFOK', //【必须】【申请】申请的组件ID，被分派ID
	        //     host : 'hd.tianyu.163.com',
	        //     productKey: '1bc7680eee080ce2026757eca30d0e53',
	        //     includeBox: 'login',
	        //     needanimation: 0,
	        //     cssDomain: cssFile.replace(/[^\/]+?$/, '').replace('http://','https://'),
	        //     cssFiles: cssFile.match(/([^\/]+?)$/)[1],
	        //     placeholder : { account: '网易通行证' },
	        //     needRegAgreeNoChecked: 1,
	        //     needRegAgreeMbNoChecked: 1,
	        //     needClause: 1,
	        //     clause: 0
	        // });
	
	        // urs.logincb = urs.regcb = function (urs) {
	        //     window.location.reload();
	        // };
	
	        nie.define('login', function() {
	            var Login = nie.require('nie.util.login2');
	            window.Login = Login
	            var example = Login.create({
	                holder: '#login',
	                success: function (params) {
	                    window.location.reload();
	                }
	            });
	        })
	
	        var self=this;
	        this.el.find(".closeBtn").click(function(){
	            self.close();
	        })
	
	        $(".logoutBtn").attr("href","http://reg.163.com/Logout.jsp?username="+urs+"&url=" + window.location.href);
		    $(".loginBtn").click(function(){
	            self.show();
	        })
	    },
	    close:function(){
	        this.el.fadeOut();
	    },
	    show:function(){
	        this.el.fadeIn();
	    }
	}
	
	function getAbsoluteUrl (url) {
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	
	module.exports = login;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	var common={
		commonPopEl:$(".m-commonPop"),
		commonCallback:null,
		confirmPopEl:$(".m-commonPop"),
		sideEl:$(".m-side"),
		init:function(){
			var _this=this;
			this.commonPopEl.find(".confirmBtn").click(function(){
				_this.commonPopEl.hide();
				if(_this.commonCallback){
					_this.commonCallback();
				}
			})
			this.sideEl.find(".switchBtn").click(function(){
				if(_this.sideEl.hasClass("close")){
					_this.sideEl.removeClass("close");
				}else{
					_this.sideEl.addClass("close");
				}
				
			})
			$(".m-side-close").click(function(){
				_this.sideEl.removeClass("close");
			})
		},
		getQueryString:function(name){
			var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		    var r = window.location.search.substr(1).match(reg);
		    if(r!=null)return  unescape(r[2]); return null;
		},
		showCommonPop:function(info){
			this.commonPopEl.find(".info").html(info);
			this.commonPopEl.show();
		},
		toDecimal:function(x) {  
	        var f = parseFloat(x);  
	        if (isNaN(f)) {  
	            return false;  
	        }  
	        var f = Math.round(x*100)/100;  
	        var s = f.toString();  
	        var rs = s.indexOf('.');  
	        if (rs < 0) {  
	            rs = s.length;  
	            s += '.';  
	        }  
	        while (s.length <= rs + 1) {  
	            s += '0';  
	        }  
	        return s;  
	    } 
	}
	
	Handlebars.registerHelper('date', function(timestamp) {
		var date=new Date(timestamp);
		return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
	});
	
	Handlebars.registerHelper('tuijianFormat', function(tuijian) {
		if(tuijian==0){
			return "暂无";
		}
	
		return common.toDecimal(tuijian)+"分";
	});
	
	Handlebars.registerHelper('tag', function(tagStr) {
		if(tagStr==""||tagStr==null){
			return "";
		}
		var tagObj=JSON.parse(tagStr);
		if(tagObj.type==0){
			return "PVP";
		}else{
			return "PVE";
		}
	});
	
	Handlebars.registerHelper('starFormat', function(tuijian) {
		if(tuijian==0){
			return "暂无";
		}
		tuijian=common.toDecimal(tuijian);
		var starCount=tuijian/2;
		var floor=Math.floor(starCount);
		var ceil=Math.round(starCount);
		var html='';
		for(var i=0;i<floor;i++){
			html+='<i class="star"></i>';
		}
		if(ceil>floor){
			html+='<i class="star half"></i>';
		}
		return html;
	});
	
	module.exports=common;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var calcData=__webpack_require__(4);
	var cData=calcData[cname];
	var skillList;
	var sortList;
	var skillSort={
		"3":[1101,1104,1105,1103,1112,1102,1115,1111,1113,1116,1106,1114],
		"4":[1201,1203,1206,1205,1204,1202,1213,1212,1216,1211,1214,1215],
		"5":[1301,1304,1313,1303,1315,1316,1302,1314,1311,1312,1305,1306],
		"6":[1501,1503,1516,1504,1502,1513,1505,1512,1511,1514,1506,1515],
		"7":[1401,1402,1406,1411,1405,1413,1412,1414,1416,1404,1403,1415],
		"8":[1602,1603,1615,1604,1606,1611,1601,1614,1616,1605,1613,1612],
		"9":[1701,1711,1705,1716,1713,1702,1714,1715,1703,1712,1704,1706],
		"10":[1901,1902,1904,1905,1907,1906,1908,1903,1909,1910,1911,1912],
		"11":[2110,2114,2115,2116,2117,2118,2119,2121,2124,2125,2127,2129]
	}
	var training={
		trainingList:[],
		cSkillEnhances:[],
		line:{
			49: '凝神',
			59: '破虚',
			69: '忘情',
			79: '出凡'
		},
		renderSkill:function(data){		
			var _this=this;
			skillList=[]
			for(var i=0;i<data.length;i++){
				var name=data[i].name;
				data[i].skillInfo=this.getSkillInfoByName(name);
				if(data[i].skillInfo!=null){
					skillList.push(data[i]);
				}			
			}
			console.log(skillList,'skillList')
			sortList=[];
			for(i=0;i<skillSort[macroSchool].length;i++){
				for(var j=0;j<skillList.length;j++){
					if(skillSort[macroSchool][i]==skillList[j].skillId){
						sortList.push(skillList[j]);
					}
				}
			}
			console.log(sortList)
			var source   = $("#skillItem-template").html();
			var template = Handlebars.compile(source);
			var html    = template({list:sortList});
			$(".skillList").html(html);
			$(".skillBtn").click(function(){
				var index=$(this).index();
				_this.renderTraining(index);
			})
			$(".skillBtn").eq(0).click();
			$(".skillBtn").hover(function(){
				_this.showTips($(this));
			},function(){
				_this.hideTips($(this));
			})
			$(".ticonCnt").delegate(".tico","mouseover",function(){
				var part=$(this).data("part");
				_this.showTrainingTips(part);
			})
			$(".ticonCnt").delegate(".tico","mouseout",function(){
				_this.hideTrainingTips();
			})
		},
		showTrainingTips:function(part){
			part+="";
			var posArray=part.split("");
			var y=parseInt(posArray[0])-1;
			var x=parseInt(posArray[1])-1;
			var trainingInfo=this.trainingList[x][y];
			var cSkillEnhanceInfo=this.getEnhance(part);
			var enhancePoint;
			if(cSkillEnhanceInfo==null){
				$(".m-trainingTips .level").html(0+"/"+trainingInfo.effect.length);
				console.log(trainingInfo.require.books)
				$(".m-trainingTips .name").html(trainingInfo.require.books);
			}else{
				$(".m-trainingTips .level").html(cSkillEnhanceInfo.enhancePoint+"/"+trainingInfo.effect.length);
				$(".m-trainingTips .name").html(cSkillEnhanceInfo.name);
			}
			
			var htmlstr="";
			for(var i=0;i<trainingInfo.effect.length;i++){
				var style="";
				if(cSkillEnhanceInfo!=null&&cSkillEnhanceInfo.enhancePoint-1==i){
					style="active";
				}
				htmlstr+='<p class="'+style+'">\
	                <span class="trainingLevel">'+(i+1)+'级修炼：</span>\
	                <span class="requireSkillLevel">修炼所需技能等级：'+trainingInfo.effect[i].layer+'</span><br>\
	                <span class="addition">'+trainingInfo.effect[i].value+'</span>\
	            </p>';
			}
			$(".m-trainingTips .main").html(htmlstr);
			$(".m-trainingTips .require").html("所需境界："+this.line[trainingInfo.require.line]);
			this.setTipsPos($(".m-trainingTips"),$(".tico[data-part="+part+"]"));
			$(".m-trainingTips").show();
		},
		getEnhance:function(part){
			for(var i=0;i<this.cSkillEnhances.length;i++){
				if(this.cSkillEnhances[i].part==part){
					return this.cSkillEnhances[i];
				}
			}	
			return null;
		},
		hideTrainingTips:function(){
			$(".m-trainingTips").hide();
		},
		showTips:function($this){
			var skillName=$this.data("name");
			var skill=this.getSkillInfoByName(skillName);
			if(!skill) return;
			$(".m-skillTips .name").html(skillName);
			$(".m-skillTips .skillIcon").attr("src",skill.skillImage);
			$(".m-skillTips .skillProperty").empty();
			for(var i=0;i<skill.skillProperty.length;i++){
				$(".m-skillTips .skillProperty").append("<span>"+skill.skillProperty[i]+"</span>");
			}
			$(".m-skillTips .main").html(skill.skillDescribe.main);
			var staticStr="";
			for(i=0;i<skill.skillDescribe.static.length;i++){
				staticStr+="· "+skill.skillDescribe.static[i]+"<br>";
			}
			$(".m-skillTips .static").html(staticStr);
			this.setTipsPos($(".m-skillTips"),$this);
			$(".m-skillTips").show();
		},
		setTipsPos:function($tips,$skillIcon){
			var x=$skillIcon.offset().left+$skillIcon.width()+10;
			var y=$skillIcon.offset().top-$tips.outerHeight()-10;
			y=y<0?0:y;
			if(x+$tips.outerWidth()>1105){
				x=$skillIcon.offset().left-$tips.outerWidth()-10;
			}
			$tips.css({left:x,top:y});
		},
		hideTips:function($this){
			$(".m-skillTips").hide();
		},
		renderTraining:function(index){
			var skill=sortList[index];
			if(skill.cSkillEnhances==undefined){
				skill.cSkillEnhances=[];
			}
			//配的数据
			var training=skill.skillInfo.skillDescribe.training;
			var enhanceList=[];
			for(var i=0;i<training.length;i++){
				for(var j=0;j<training[i].length;j++){
					var part=parseInt((j+1)+""+(i+1));
					if(training[i][j].effect!=undefined){
						enhanceList.push({enhancePoint:0,part:part,limit:training[i][j].effect.length})
					}
				}
			}
	
			for(i=0;i<enhanceList.length;i++){
				var tempEnhance=enhanceList[i];
				for(j=0;j<skill.cSkillEnhances.length;j++){
					if(parseInt(skill.cSkillEnhances[j].part)==parseInt(tempEnhance.part)){
						tempEnhance.enhancePoint=skill.cSkillEnhances[j].enhancePoint;
					}
				}
			}
			//算点
			var trainingCountObj={
				t1:0,
				t2:0,
				t3:0
			}
			for(i=0;i<skill.cSkillEnhances.length;i++){
				var pos=skill.cSkillEnhances[i].part+"";
				var pos2=pos.substr(1,1);
				if(pos2=="1"||pos2=="2"){
					trainingCountObj.t1+=skill.cSkillEnhances[i].enhancePoint;
				}
				if(pos2=="3"){
					trainingCountObj.t2+=skill.cSkillEnhances[i].enhancePoint;
				}
				if(pos2=="4"||pos2=="5"){
					trainingCountObj.t3+=skill.cSkillEnhances[i].enhancePoint;
				}
			}
	
			var source   = $("#trainingItem-template").html();
			var template = Handlebars.compile(source);
			var html    = template({list:enhanceList});
			$(".ticonCnt").html(html);
			$(".skillIcon").attr("src",skill.skillInfo.skillImage);
			var trainingNameList=skill.skillInfo.skillDescribe.trainingName;
			$(".skillName").html(skill.name);
			$(".trainingName-1").html(trainingNameList[0]+"："+trainingCountObj.t1);
			$(".trainingName-2").html(trainingNameList[1]+"："+trainingCountObj.t2);
			$(".trainingName-3").html(trainingNameList[2]+"："+trainingCountObj.t3);
			var enhances="";
			for(var i=0;i<skill.cSkillEnhances.length;i++){
				if(skill.cSkillEnhances[i].enhancePoint>0){
					enhances+=skill.cSkillEnhances[i].description+"<br>";
				}
			}
			$(".trainMap .p").html(enhances);
			this.cSkillEnhances=skill.cSkillEnhances;
			this.trainingList=skill.skillInfo.skillDescribe.training;
		},
		getSkillInfoByName:function(name){
			for(var i=0;i<cData.length;i++){
				if(cData[i].skillName==name){
					return cData[i];
				}
			}
			return null;
		},
		getSkillXiulianList:function(){
			training.renderSkill(gameSkillInfo);
			// console.log(gameSkillInfo)
			// $.getJSON("/skillmacros/getSkillXiulianList.json?gbId="+gbId,function(msg){
			// 	training.renderSkill(msg.data);
			// })
		}
	}
	training.getSkillXiulianList();
	module.exports=training;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var tianzhao = __webpack_require__(5)
	var shiyu = __webpack_require__(6)
	var data = {
	    "guangren": [{
	        "skillName": "斩风",
	        "skillProperty": ["物理攻击", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bbb7fb16-dacd-4dc5-a555-7f483f284cde_1301",
	        "skillDescribe": {
	            "main": "对前方区域的所有敌方造成少量伤害",
	            "static": ["对前方敌方造成少量物理伤害，第三刀伤害和冷却时间翻倍"],
	            "addition": [],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“杀意”状态下,本技能有10%的概率使敌人获得“破甲”效果"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“杀意”状态下,本技能有20%的概率使敌人获得“破甲”效果"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“杀意”状态下,本技能有30%的概率使敌人获得“破甲”效果"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“杀意”状态下,本技能的第三刀有30%概率造成“断筋”效果,移动速度降低50%,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“杀意”状态下,本技能的第三刀有60%概率造成“断筋”效果,移动速度降低50%,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“杀意”状态下,本技能的第三刀有100%概率造成“断筋”效果,移动速度降低50%,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高6%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高12%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "成功施放本技能获得的战意值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "成功施放本技能获得的战意值提高30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "成功施放本技能获得的战意值提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“道意”状态下,本技能有5%的概率对目标造成“削弱”效果,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“道意”状态下,本技能有10%的概率对目标造成“削弱”效果,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“道意”状态下,本技能有15%的概率对目标造成“削弱”效果,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能有10%的概率使不动山的冷却时间减少1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,本技能有20%的概率使不动山的冷却时间减少1秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“道意”状态下,本技能有30%的概率使不动山的冷却时间减少1秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "狂杀",
	        "skillProperty": ["物理攻击", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8a064846-d02d-4a64-a74a-8a942dc2ed33_1304",
	        "skillDescribe": {
	            "main": "拔起双刀向前方挥舞，最多可连续<em class='green'>7</em>次",
	            "static": ["每次使用会发动狂杀追击，每一击造成一定的物理伤害", "最后一击造成大量伤害"],
	            "addition": [{
	                "initiative": "每次挥砍击中敌方，自身有<em class='green'>50%</em>概率获得破伤效果，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>5</em>层",
	                "passivity": "破伤：每层破伤状态提升5%攻击力"
	            },
	            {
	                "initiative": "最后一击使敌方获得击倒状态<em class='green'>3</em>秒",
	                "passivity": "击倒：自身倒地，无法移动和释放技能"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "造成的“破伤”状态持续时间延长5秒（包括自身其他技能产生的“破伤”效果）"
	                },
	                {
	                    "layer": 9,
	                    "value": "造成的“破伤”状态持续时间延长10秒（包括自身其他技能产生的“破伤”效果）"
	                },
	                {
	                    "layer": 10,
	                    "value": "造成的“破伤”状态持续时间延长15秒（包括自身其他技能产生的“破伤”效果）"
	                }],
	                "require": {
	                    "books": "中级狂杀卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "狂杀攻击的次数减少1次"
	                },
	                {
	                    "layer": 9,
	                    "value": "狂杀攻击的次数减少2次"
	                },
	                {
	                    "layer": 10,
	                    "value": "狂杀攻击的次数减少3次"
	                }],
	                "require": {
	                    "books": "中级狂杀卷二*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“杀意”状态下,本技能造成的“破伤”效果概率提高为75%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“杀意”状态下,本技能造成的“破伤”效果概率提高为100%"
	                }],
	                "require": {
	                    "books": "高级狂杀卷二*杀",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“道意”状态下,本技能每次攻击都有10%概率造成目标“削弱”效果,持续5秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“道意”状态下,本技能每次攻击都有20%概率造成目标“削弱”效果,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有50%概率使自身获得“剑道”状态,最多叠加2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有75%概率使自身获得“剑道”状态,最多叠加2层"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有100%概率使自身获得“剑道”状态,最多叠加2层"
	                }],
	                "require": {
	                    "books": "中级狂杀卷一*道",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狂杀攻击的次数增加1次（学习了中级狂杀卷二*杀则无效）"
	                },
	                {
	                    "layer": 14,
	                    "value": "狂杀攻击的次数增加2次（学习了中级狂杀卷二*杀则无效）"
	                },
	                {
	                    "layer": 15,
	                    "value": "狂杀攻击的次数增加3次（学习了中级狂杀卷二*杀则无效）"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能每次使用都立即恢复自身0.5点轻功值"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能每次使用都立即恢复自身1点轻功值"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能每次使用都立即恢复自身1.5点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "道意状态下，每次攻击有30%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "道意状态下，每次攻击有60%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "道意状态下，每次攻击有100%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
	                }],
	                "require": {
	                    "books": "中级狂杀卷二*道",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "斩青云",
	        "skillProperty": ["物理攻击", "引导技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a06db556-dea4-4231-a1ab-08d916f25521_1313",
	        "skillDescribe": {
	            "main": "<em class='green'>1.7</em>秒内持续对自身周围敌方造成伤害",
	            "static": ["每0.5秒对周围敌方造成一次伤害"],
	            "addition": [{
	                "initiative": "每次伤害<em class='green'>20%</em>概率自身进入剑道状态，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>2</em>层",
	                "passivity": "剑道：每层提高160点格挡"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "对自己赋予“破甲”的敌人造成的伤害增加10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "对自己赋予“破甲”的敌人造成的伤害增加20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "对自己赋予“破甲”的敌人造成的伤害增加30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对“击倒”的敌人造成的伤害增加20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "对“击倒”的敌人造成的伤害增加30%"
	                },
	                {
	                    "layer": 15,
	                    "value": "对“击倒”的敌人造成的伤害增加40%"
	                }],
	                "require": {
	                    "books": "高级斩青云卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成“剑道”状态的概率提高至30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成“剑道”状态的概率提高至40%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能造成“剑道”状态的概率提高至50%"
	                }],
	                "require": {
	                    "books": "初级斩青云卷一*道",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "造成的“剑道”状态增加的格挡提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "造成的“剑道”状态增加的格挡提高20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "造成的“剑道”状态增加的格挡提高30%"
	                }],
	                "require": {
	                    "books": "中级斩青云卷一*道",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "造成的“剑道”状态最多可叠加3层"
	                },
	                {
	                    "layer": 14,
	                    "value": "造成的“剑道”状态最多可叠加4层"
	                },
	                {
	                    "layer": 15,
	                    "value": "造成的“剑道”状态最多可叠加5层"
	                }],
	                "require": {
	                    "books": "高级斩青云卷一*道",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "施放本技能期间,自身受到的伤害降低3%"
	                },
	                {
	                    "layer": 4,
	                    "value": "施放本技能期间,自身受到的伤害降低6%"
	                },
	                {
	                    "layer": 5,
	                    "value": "施放本技能期间,自身受到的伤害降低9%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能每次攻击有10%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,本技能每次攻击有20%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“道意”状态下,本技能每次攻击有30%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                }],
	                "require": {
	                    "books": "高级斩青云卷二*道",
	                    "preNum": 0,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "战意诀",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5e2006cd-66de-40fe-a660-04a0b307c413_1303",
	        "skillDescribe": {
	            "main": "战斗的过程中会增加战意值，使用后释放聚集的全部战意，强化自身",
	            "static": ["杀意：获得战意*杀状态，提升暴击力", "道意：获得战意*道状态，提升格挡力"],
	            "addition": [{
	                "initiative": "释放杀意可以获得战意*杀状态，持续<em class='green'>30</em>秒",
	                "passivity": "提升0.5*战意点的暴击力"
	            },
	            {
	                "initiative": "释放道意可以获得战意*道状态，持续<em class='green'>30</em>秒",
	                "passivity": "提升0.5*战意点的格挡力"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“杀意”状态下,自身受到的治疗效果提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“杀意”状态下,自身受到的治疗效果提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加2层,该效果每秒最多触发一次"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加3层,该效果每秒最多触发一次"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加5层,该效果每秒最多触发一次"
	                }],
	                "require": {
	                    "books": "中级战意卷一*杀",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“杀意”状态下,自身对的怪物伤害增加1%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“杀意”状态下,自身对的怪物伤害增加2%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "战意值上限提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "战意值上限提高15%"
	                },
	                {
	                    "layer": 5,
	                    "value": "战意值上限提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“道意”状态下,自身受到的治疗效果提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“道意”状态下,自身受到的治疗效果提高20%"
	                }],
	                "require": {
	                    "books": "初级战意卷一*道",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续10秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续20秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续35秒"
	                }],
	                "require": {
	                    "books": "中级战意卷一*道",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“道意”状态下,自身受到的怪物伤害降低1%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“道意”状态下,自身受到的怪物伤害降低1%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "破空斩",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bfcee7d6-c032-4af7-8367-69fadc1cb4ec_1319",
	        "skillDescribe": {
	            "main": "向前方释放一道剑气，对所有敌方造成伤害",
	            "static": ["对前方直线范围内敌方造成物理伤害"],
	            "addition": [{
	                "initiative": "<em class='green'>20%</em>概率使敌方进入削弱状态，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
	                "passivity": "削弱：每层降低5%的攻击力"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对处于“破甲”的敌人造成伤害提高8%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对处于“破甲”的敌人造成伤害提高16%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对处于“破甲”的敌人造成伤害提高25%"
	                }],
	                "require": {
	                    "books": "中级破空斩卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使用本技能后,则立即增长自身1点问情系无双值"
	                },
	                {
	                    "layer": 14,
	                    "value": "使用本技能后,则立即增长自身2点问情系无双值"
	                }],
	                "require": {
	                    "books": "高级破空斩卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低0.5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低1秒"
	                }],
	                "require": {
	                    "books": "中级破空斩卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“削弱”效果的概率提高为30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“削弱”效果的概率提高为40%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能造成的“削弱”效果的概率提高为50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能造成的“削弱”效果最多可叠加4层（包括自身其他技能产生的“削弱”效果）"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能造成的“削弱”效果最多可叠加5层（包括自身其他技能产生的“削弱”效果）"
	                }],
	                "require": {
	                    "books": "中级破空斩卷一*道",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能造成的“削弱”效果持续时间提高3秒（包括自身其他技能产生的“削弱”效果）"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能造成的“削弱”效果持续时间提高5秒（包括自身其他技能产生的“削弱”效果）"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能造成的“削弱”效果持续时间提高7秒（包括自身其他技能产生的“削弱”效果）"
	                }],
	                "require": {
	                    "books": "高级破空斩卷一*道",
	                    "preNum": 2,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "成功施放本技能获得的战意值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "成功施放本技能获得的战意值提高30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "成功施放本技能获得的战意值提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "破影",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6228614a-5359-4792-90d2-be484691fa6e_1316",
	        "skillDescribe": {
	            "main": "连续按键对前方发动攻击，最多发动<em class='green'>4</em>次攻击",
	            "static": ["每次按键对敌方造成一定的物理伤害"],
	            "addition": [{
	                "initiative": "造成破甲效果，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>5</em>层",
	                "passivity": "破甲：每层降低206点物理防御力"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "自身处于“破伤”时破影造成伤害提高8%"
	                },
	                {
	                    "layer": 9,
	                    "value": "自身处于“破伤”时破影造成伤害提高16%"
	                },
	                {
	                    "layer": 10,
	                    "value": "自身处于“破伤”时破影造成伤害提高25%"
	                }],
	                "require": {
	                    "books": "中级破影卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标1个技能,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标2个技能,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标3个技能,持续3秒"
	                }],
	                "require": {
	                    "books": "高级破影卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "自身每1层“破伤”额外提升本技能5%的伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "自身每1层“破伤”额外提升本技能10%的伤害"
	                }],
	                "require": {
	                    "books": "高级破影卷二*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级破影卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“破甲”状态持续时间延长5秒（包括自身其他技能产生的“破甲”效果）"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“破甲”状态持续时间延长10秒（包括自身其他技能产生的“破甲”效果）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "造成的“破甲”状态降低的物理防御力提高6%（包括自身其他技能产生的“破甲”效果）"
	                },
	                {
	                    "layer": 9,
	                    "value": "造成的“破甲”状态降低的物理防御力提高12%（包括自身其他技能产生的“破甲”效果）"
	                },
	                {
	                    "layer": 10,
	                    "value": "造成的“破甲”状态降低的物理防御力提高20%（包括自身其他技能产生的“破甲”效果）"
	                }],
	                "require": {
	                    "books": "中级破影卷一*道",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能每次攻击都有15%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,本技能每次攻击都有30%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“道意”状态下,本技能每次攻击都有50%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                }],
	                "require": {
	                    "books": "高级破影卷一*道",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高20%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高30%,持续3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高40%,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "追命",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_37ecb19a-7823-4c4c-b228-d2b0817300db_1302",
	        "skillDescribe": {
	            "main": "冲向目标，对前方的敌方造成伤害",
	            "static": ["冲向目标位置", "<em class='green'>2</em>秒内再次按键可向前方区域拔刀挥砍，对敌方造成物理伤害并击飞<em class='green'>3</em>米"],
	            "addition": [{
	                "initiative": "受击单位获得定身状态<em class='green'>1</em>秒",
	                "passivity": "定身：无法移动和使用轻功"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冲向目标后,有30%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "冲向目标后,有60%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "冲向目标后,有100%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
	                }],
	                "require": {
	                    "books": "中级追命卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能的最远射程提高1米"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能的最远射程提高2米"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能的最远射程提高3米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“杀意”状态下,本技能施放后,自身获得霸体效果,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“杀意”状态下,本技能施放后,自身获得霸体效果,持续2秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级追命卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有50%的概率迫使怪物5秒内强制攻击自己"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有100%的概率迫使怪物5秒内强制攻击自己"
	                }],
	                "require": {
	                    "books": "初级追命卷一*道",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标1个技能,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标2个技能,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标3个技能,持续3秒"
	                }],
	                "require": {
	                    "books": "中级追命卷一*道",
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,追命二斩的攻击范围增加3米"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,追命二斩的攻击范围增加6米"
	                }],
	                "require": {
	                    "books": "高级追命卷一*道",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "不动山",
	        "skillProperty": ["物理技能", "引导技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9e836662-764c-4954-8aac-adbf84564b5b_1314",
	        "skillDescribe": {
	            "main": "进入格挡状态，持续<em class='green'>2</em>秒，免疫控制",
	            "static": ["按键后进入不动山姿态，格挡伤害，主动使用闪避可取消"],
	            "addition": [{
	                "initiative": "自身进入<em class='green'>不动山</em>姿态",
	                "passivity": "不动山：免疫控制，对所有受到的伤害造成格挡效果，自身的格挡加成提高"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人86%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 4,
	                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人172%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 5,
	                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人258%基础物理攻击力的物理伤害"
	                }],
	                "require": {
	                    "books": "初级不动山卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量10%的生命上限"
	                },
	                {
	                    "layer": 9,
	                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量20%的生命上限"
	                },
	                {
	                    "layer": 10,
	                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量30%的生命上限"
	                }],
	                "require": {
	                    "books": "中级不动山卷一*杀",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "反击有20%概率将敌人击倒3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "反击有40%概率将敌人击倒3秒"
	                }],
	                "require": {
	                    "books": "高级不动山卷一*杀",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级不动山卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "格挡姿态的持续时间增加0.5秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "格挡姿态的持续时间增加1秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "该技能的格挡加成效果额外提升8%"
	                },
	                {
	                    "layer": 9,
	                    "value": "该技能的格挡加成效果额外提升16%"
	                },
	                {
	                    "layer": 10,
	                    "value": "该技能的格挡加成效果额外提升25%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当自身生命上限低于30%时,该技能的格挡加成效果额外提升15%"
	                },
	                {
	                    "layer": 14,
	                    "value": "当自身生命上限低于30%时,该技能的格挡加成效果额外提升30%"
	                }],
	                "require": {
	                    "books": "高级不动山卷一*道",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "格挡姿态下,每次成功格挡敌人伤害会使自身获得3%的生命上限,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "格挡姿态下,每次成功格挡敌人伤害会使自身获得6%的生命上限,该效果每5秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级不动山卷二*道",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "定风波",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_c82680df-39f5-4229-86b8-910c8c5d30ac_1311",
	        "skillDescribe": {
	            "main": "<em class='green'>击倒</em>前方区域的所有敌方并造成伤害",
	            "static": ["击倒前方直线敌方并造成物理伤害"],
	            "addition": [{
	                "initiative": "敌方获得击倒状态<em class='green'>3</em>秒",
	                "passivity": "击倒：无法移动和使用技能、轻功"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成60%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成120%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 5,
	                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成180%基础物理攻击力的物理伤害"
	                }],
	                "require": {
	                    "books": "初级定风波卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "定风波二斩造成的伤害提高20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "定风波二斩造成的伤害提高40%"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "定风波二斩对处于“击倒”状态的敌人造成的伤害提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "定风波二斩对处于“击倒”状态的敌人造成的伤害提高60%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "定风波二斩可以在自身处于被控制状态施放,并解除自身的受控制状态"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "books": "高级不动山卷二*杀",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级定风波卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "降低定风波0.5秒的吟唱时间"
	                }],
	                "require": {
	                    "books": "高级定风波卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的控制等级增加10点"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的控制等级增加20点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“道意”状态下,本技能对怪物造成的物理伤害额外提高25%,并造成大量仇恨"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“道意”状态下,本技能对怪物造成的物理伤害额外提高50%,并造成大量仇恨"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能有50%概率立即重置追命的冷却时间"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,本技能有75%概率立即重置追命的冷却时间"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“道意”状态下,本技能有100%概率立即重置追命的冷却时间"
	                }],
	                "require": {
	                    "books": "高级定风波卷一*道",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "破月",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9d623569-3504-4a33-9268-9f5b2b9b030e_1312",
	        "skillDescribe": {
	            "main": "解除控制效果并进入<em class='green'>霸体</em>状态，持续<em class='green'>3</em>秒，并对前方敌方并造成伤害",
	            "static": ["解除自身控制状态", "对前方敌方造成物理伤害"],
	            "addition": [{
	                "initiative": "自身进入<em class='green'>霸体</em>状态<em class='green'>3</em>秒",
	                "passivity": "霸体：免疫所有控制效果"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "对被击中的敌人造成“迟钝”效果，降低50%的移动速度，无法使用轻功，持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "对被击中的敌人造成“迟钝”效果，降低50%的移动速度，无法使用轻功，持续5秒"
	                }],
	                "require": {
	                    "books": "初级破月卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“霸体”状态下,自身的物理攻击力提高5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“霸体”状态下,自身的物理攻击力提高10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "“霸体”状态下,自身的物理攻击力提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能产生的“霸体”状态持续时间增加0.5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能产生的“霸体”状态持续时间增加1秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能产生的“霸体”状态持续时间增加1.5秒"
	                }],
	                "require": {
	                    "books": "高级破月卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级破月卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“霸体”状态下,自身的移动速度提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“霸体”状态下,自身的移动速度提高30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“霸体”状态下,自身的移动速度提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“霸体”状态下,自身的物理和法术防御力提高5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“霸体”状态下,自身的物理和法术防御力提高10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "“霸体”状态下,自身的物理和法术防御力提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能可解除自身所有不良状态"
	                }],
	                "require": {
	                    "books": "高级破月卷一*道",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "猎光",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_dde85a40-9924-424c-a7e0-0dc7b657239b_1305",
	        "skillDescribe": {
	            "main": "对区域内所有敌方造成大量物理伤害",
	            "static": ["对前方区域敌方造成极大量物理伤害"],
	            "addition": [],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的物理伤害可忽视敌人8%的物理防御力"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的物理伤害可忽视敌人16%的物理防御力"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能造成的物理伤害可忽视敌人25%的物理防御力"
	                }],
	                "require": {
	                    "books": "中级猎光卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高30%"
	                },
	                {
	                    "layer": 15,
	                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高40%"
	                }],
	                "require": {
	                    "books": "高级猎光卷一*杀",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级猎光卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能立即驱散目标1个正面状态"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能立即驱散目标2个正面状态"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身30×技能等级×驱散状态数的生命上限"
	                },
	                {
	                    "layer": 9,
	                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身60×技能等级×驱散状态数的生命上限"
	                },
	                {
	                    "layer": 10,
	                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身90×技能等级×驱散状态数的生命上限"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“道意”状态下,本技能立即增加3点问道系无双值"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“道意”状态下,本技能立即增加5点问道系无双值"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“道意”状态下,本技能立即增加7点问道系无双值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高100%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高200%"
	                },
	                {
	                    "layer": 5,
	                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高300%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "血绽诀",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_e6adde71-6f5c-4a1a-972c-045df5bb0e95_1306",
	        "skillDescribe": {
	            "main": "进入血绽状态，免疫一切控制和状态，持续<em class='green'>5</em>秒",
	            "static": ["解除自身控制状态", "生命值降为1，同时战意值增加到上限"],
	            "addition": [{
	                "initiative": "自身进入<em class='green'>血绽</em>状态",
	                "passivity": "血绽：免疫所有伤害和控制效果，且每次伤害回复自身造成伤害值20%生命值，最多回复相当于自身总血量50%的生命值"
	            }],
	            "trainingName": ["弑", "悟", "道"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“血绽”状态下,自身的移动速度提高30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“血绽”状态下,自身的移动速度提高60%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“血绽”状态下,自身的移动速度提高100%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能使用后,立即使所有技能冷却时间减少10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能使用后,立即使所有技能冷却时间减少20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能使用后,立即使所有技能冷却时间减少30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能使用后,立即增加两系无双各3点"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能使用后,立即增加两系无双各6点"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能使用后,立即增加两系无双各10点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“血绽”状态下,自身受到的治疗效果提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“血绽”状态下,自身受到的治疗效果提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“血绽”状态下,自身受到的治疗效果提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能使用后,使周围30米范围内的所有队友获得4%的吸血效果,持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能使用后,使周围30米范围内的所有队友获得8%的吸血效果,持续5秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能使用后,使周围30米范围内的所有队友获得12%的吸血效果,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“血绽”状态的持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "“血绽”状态的持续时间增加2秒"
	                }],
	                "require": {
	                    "books": "高级血绽诀卷一*道",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“血绽”状态下，自身对怪物造成的伤害提高25%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“血绽”状态下，自身对怪物造成的伤害提高50%"
	                }],
	                "require": {
	                    "books": "中级血绽诀卷二*道",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    }],
	    "yantian": [{
	        "skillName": "疾风弹",
	        "skillProperty": ["物理攻击", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6cdcfdaf-09f3-41c1-a19d-0591a6aad023_1501",
	        "skillDescribe": {
	            "main": "对敌方单体造成少量伤害",
	            "static": ["对敌方单体造成少量的物理伤害", "狙杀模式下<em class='green'>20%</em>概率对与自身距离20米以上敌方造成双倍伤害"],
	            "addition": [],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高20%"
	                }],
	                "require": {
	                    "books": "中级疾风弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,造成双倍伤害的概率提高至28%"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,造成双倍伤害的概率提高至36%"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下,造成双倍伤害的概率提高至45%"
	                }],
	                "require": {
	                    "books": "高级疾风弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高6%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高12%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高10%"
	                },
	                {
	                    "layer": 5,
	                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对目标造成暴击伤害后,立即恢复自身2点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对目标造成暴击伤害后,立即恢复自身4点轻功值"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对目标造成暴击伤害后,立即恢复自身6点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标2点轻功值"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标4点轻功值"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标6点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "震荡弹",
	        "skillProperty": ["物理攻击", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0f6c166d-b8e3-4521-b9de-2a8bd8b09c01_1503",
	        "skillDescribe": {
	            "main": "对敌方单体造成伤害",
	            "static": ["对敌方单体造成一定的物理伤害", "狙杀模式时，额外附带一个流血效果"],
	            "addition": [{
	                "initiative": "狙杀模式时对目标造成流血效果，持续6秒",
	                "passivity": "流血：每2秒造成15.2%基础物理攻击的伤害"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高30%"
	                },
	                {
	                    "layer": 10,
	                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高45%"
	                }],
	                "require": {
	                    "books": "中级震荡弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,本技能造成的“流血”效果最多可叠加2层"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,本技能造成的“流血”效果最多可叠加3层"
	                }],
	                "require": {
	                    "books": "高级震荡弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,本技能造成的“流血”效果持续时间提高2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,本技能造成的“流血”效果持续时间提高4秒"
	                }],
	                "require": {
	                    "books": "高级震荡弹卷二*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有50%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有75%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续4秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能有100%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续5秒"
	                }],
	                "require": {
	                    "books": "初级震荡弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有15%的概率立即打断目标吟唱或者引导"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有30%的概率立即打断目标吟唱或者引导"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能有50%的概率立即打断目标吟唱或者引导"
	                }],
	                "require": {
	                    "books": "中级震荡弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能有50%概率随机封印目标1个技能,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能有100%概率随机封印目标1个技能,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能有100%概率随机封印目标2个技能,持续3秒"
	                }],
	                "require": {
	                    "books": "高级震荡弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "震地雷",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_08bb8224-7677-4c3a-b18d-f1f1bb69cd4c_1512",
	        "skillDescribe": {
	            "main": "朝目标位置丢掷手雷，将目标及周围的敌方击倒并造成伤害",
	            "static": ["对目标及周围敌方造成基于物理攻击百分比的火系伤害"],
	            "addition": [{
	                "initiative": "将敌方<em class='green'>击倒</em>，持续<em class='green'>3</em>秒",
	                "passivity": "击倒：无法移动、使用轻功和技能"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提升13%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提升26%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的法术伤害额外提高50%,但无法击倒敌人"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的法术伤害额外提高100%,但无法击倒敌人"
	                }],
	                "require": {
	                    "books": "中级震地雷卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "震地雷忽视敌人12%的法术防御力"
	                },
	                {
	                    "layer": 14,
	                    "value": "震地雷忽视敌人25%的法术防御力"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高20%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高40%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能立即扣除敌人6点轻功值"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能立即扣除敌人12点轻功值"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能立即扣除敌人18点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能的最大射程提高3米"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能的最大射程提高5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对敌人造成的“击倒”时间延长0.5秒（学习了中级震地雷卷一*炎则此效果失效）"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对敌人造成的“击倒”时间延长1秒（学习了中级震地雷卷一*炎则此效果失效）"
	                }],
	                "require": {
	                    "books": "高级震地雷卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能爆炸范围扩大2米"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能爆炸范围扩大4米"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能爆炸范围扩大6米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "黯灭弹",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9f72ecc6-6623-407c-82e4-273334415f4c_1504",
	        "skillDescribe": {
	            "main": "对敌方单体造成大量伤害",
	            "static": ["造成大量物理伤害", "狙杀模式下该技能暴击力提高"],
	            "addition": [],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的物理伤害可忽视敌人8%的物理防御力"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的物理伤害可忽视敌人16%的物理防御力"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能造成的物理伤害可忽视敌人25%的物理防御力"
	                }],
	                "require": {
	                    "books": "中级黯灭弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高10%,持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高20%,持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高30%,持续5秒"
	                }],
	                "require": {
	                    "books": "高级黯灭弹卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续4秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续5秒"
	                }],
	                "require": {
	                    "books": "初级黯灭弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有50%的概率立即驱散目标1个正面状态"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有100%的概率立即驱散目标1个正面状态"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能有100%的概率立即驱散目标1个正面状态,如果驱散成功则可以使自己获得“黯灭”状态，提升2%的物理攻击，最多可叠加5层。"
	                }],
	                "require": {
	                    "books": "中级黯灭弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对目标造成造成“弱疗”效果,受到的治疗效果降低10%,持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对目标造成造成“弱疗”效果,受到的治疗效果降低20%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对目标造成暴击伤害后,使自身获得“风行”状态,移动速度提高30%,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对目标造成暴击伤害后,使自身获得“风行”状态,移动速度提高50%,持续3秒"
	                }],
	                "require": {
	                    "books": "高级黯灭弹卷二*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "穿云弹",
	        "skillProperty": ["物理技能", "引导技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_dad6fae4-f0b1-4cba-a501-59376c0906eb_1502",
	        "skillDescribe": {
	            "main": "<em class='green'>2.5</em>秒内持续对目标及周围敌方连续射击",
	            "static": ["每2次射击造成一次物理伤害，最多可攻击目标及周围共<em class='green'>4</em>个目标", "狙杀模式下最多可攻击共<em class='green'>8</em>个目标"],
	            "addition": [{
	                "initiative": "是自己进入<em class='green'>物伤加深</em>状态，持续<em class='green'>5</em>秒",
	                "passivity": "物伤加深：提升20%的物理伤害"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加1个"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加2个"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加3个"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,本技能最后一击的暴击率提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,本技能最后一击的暴击率提高60%"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下,本技能最后一击的暴击率提高90%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能持续期间内,获得“无惧”状态,自身的反控制等级提高25点"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能持续期间内,获得“无惧”状态,自身的反控制等级提高50点"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能持续期间内,获得“霸体”状态,免疫一切控制"
	                }],
	                "require": {
	                    "books": "初级穿云弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "狙杀模式下,本技能每次攻击都都有20%的概率击退敌人2米"
	                },
	                {
	                    "layer": 9,
	                    "value": "狙杀模式下,本技能每次攻击都都有40%的概率击退敌人2米"
	                },
	                {
	                    "layer": 10,
	                    "value": "狙杀模式下,本技能每次攻击都都有60%的概率击退敌人2米"
	                }],
	                "require": {
	                    "books": "中级穿云弹卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,本技能最后一击10%的概率击倒目标3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,本技能最后一击20%的概率击倒目标3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下,本技能最后一击30%的概率击倒目标3秒"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃1秒冷却时间"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃2秒冷却时间"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃3秒冷却时间"
	                }],
	                "require": {
	                    "books": "高级穿云弹卷二*钢",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "螺旋刃",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_05b7aaf4-ae35-4706-aa97-63bac74fd670_1513",
	        "skillDescribe": {
	            "main": "向前方丢掷螺旋刃，对触发区域内所有敌方造成持续伤害，持续<em class='green'>5</em>秒",
	            "static": ["螺旋刃在接触到第一个敌方时展开，每秒对范围内敌方造成一定的物理伤害", "自身受到螺旋刃反作用力后退<em class='green'>10</em>米"],
	            "addition": [{
	                "initiative": "对区域内敌方持续造成<em class='green'>断筋</em>效果",
	                "passivity": "断筋：降低移动速度50%"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放后,后退距离缩短至5米,同时造成的物理伤害提高15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放后,后退距离缩短至0米,同时造成的物理伤害提高30%"
	                }],
	                "require": {
	                    "books": "中级螺旋刃卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "螺旋刃的每次攻击对都忽视敌人12%的物理防御力"
	                },
	                {
	                    "layer": 14,
	                    "value": "螺旋刃的每次攻击对都忽视敌人24%的物理防御力"
	                },
	                {
	                    "layer": 15,
	                    "value": "螺旋刃的每次攻击对都忽视敌人36%的物理防御力"
	                }],
	                "require": {
	                    "books": "高级螺旋刃卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "可在眩晕或击倒状态下使用此技能，但无法解除控制"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "螺旋刃的每次攻击有15%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "螺旋刃的每次攻击有30%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "螺旋刃的每次攻击有50%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
	                }],
	                "require": {
	                    "books": "初级螺旋刃卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "螺旋刃的每次攻击都会扣除敌人2点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "螺旋刃的每次攻击都会扣除敌人4点轻功值"
	                },
	                {
	                    "layer": 10,
	                    "value": "螺旋刃的每次攻击都会扣除敌人6点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,有50%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后,有100%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能施放后,有100%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续3秒"
	                }],
	                "require": {
	                    "books": "高级螺旋刃卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "狙杀模式",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9eca46aa-6473-4cc7-9954-41ed654f7066_1505",
	        "skillDescribe": {
	            "main": "开启/关闭狙杀模式，已牺牲自身机动能力来获取攻击能力的提升，并可以影响部分技能的效果",
	            "static": ["开启/关闭狙杀模式，移动速度大幅下降，攻击能力提高", "狙杀模式下部分技能效果会被影响"],
	            "addition": [{
	                "initiative": "开启时进入<em class='green'>狙杀模式</em>",
	                "passivity": "狙杀模式：提升自身12%基础物理攻击和少量固定物理攻击力，移动速度大幅下降，降低轻功回复速度50%"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "狙杀模式提升物理攻击力的效果提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "狙杀模式提升物理攻击力的效果提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "狙杀模式下,炎杀系无双值增长速度提高5%（同类效果无法共存）"
	                },
	                {
	                    "layer": 9,
	                    "value": "狙杀模式下,炎杀系无双值增长速度提高10%（同类效果无法共存）"
	                },
	                {
	                    "layer": 10,
	                    "value": "狙杀模式下,炎杀系无双值增长速度提高15%（同类效果无法共存）"
	                }],
	                "require": {
	                    "books": "中级狙杀模式卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升0.5%,最多叠加20层；退出狙杀模式后,状态消失"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升1%,最多叠加20层；退出狙杀模式后,状态消失"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升1.5%,最多叠加20层；退出狙杀模式后,状态消失"
	                }],
	                "require": {
	                    "books": "高级狙杀模式卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能冷却时间降低1秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能冷却时间降低3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能冷却时间降低5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "狙杀模式下,自身的命中力提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "狙杀模式下,自身的命中力提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "狙杀模式下,自身的命中力提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "狙杀模式下,移动速度下降变为40%"
	                },
	                {
	                    "layer": 9,
	                    "value": "狙杀模式下,移动速度下降变为20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "狙杀模式下,不再降低移动速度"
	                }],
	                "require": {
	                    "books": "中级狙杀模式卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下，所有指向性技能射程提高1米"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下，所有指向性技能射程提高2米"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下，所有指向性技能射程提高3米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "狙杀模式下，轻功回复速度仅降低30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "狙杀模式下，轻功回复速度仅降低15%"
	                },
	                {
	                    "layer": 15,
	                    "value": "狙杀模式下，不再降低轻功回复速度"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "炎光傀儡",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_46191d43-44a3-45f5-b2ab-93153c44b4e5_1519",
	        "skillDescribe": {
	            "main": "召唤炎光傀儡，拥有主人的<em class='green'>10%</em>附加固定数值的生命，主人的<em class='green'>50%</em>攻击附加少量固定值物理攻击，持续<em class='green'>30</em>秒，不会被怪物攻击",
	            "static": ["傀儡可以使用炎光波技能"],
	            "addition": [{
	                "initiative": "傀儡释放炎光波攻击敌人",
	                "passivity": "炎光波：对前方1*30米区域内所有敌方造成基于物理攻击力的光系法术伤害，持续3秒，冷却5秒"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "进入战斗后,炎光傀儡会提高主人1%的物理攻击力,持续30秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "进入战斗后,炎光傀儡会提高主人2%的物理攻击力,持续30秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人160%基础物理攻击力的法术伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人320%基础物理攻击力的法术伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人480%基础物理攻击力的法术伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "进入战斗后,炎光傀儡会提高主人5%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
	                },
	                {
	                    "layer": 14,
	                    "value": "进入战斗后,炎光傀儡会提高主人10%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
	                },
	                {
	                    "layer": 15,
	                    "value": "进入战斗后,炎光傀儡会提高主人15%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
	                }],
	                "require": {
	                    "books": "高级炎光傀儡卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "炎光傀儡的攻击力提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "炎光傀儡的攻击力提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "炎光傀儡的生命上限提高为主人的30%,持续时间增加15秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "炎光傀儡的生命上限提高为主人的40%,持续时间增加30秒"
	                }],
	                "require": {
	                    "books": "中级炎光傀儡卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“炎光波”造成的法术伤害可以忽视敌人20%的法术防御力"
	                },
	                {
	                    "layer": 14,
	                    "value": "“炎光波”造成的法术伤害可以忽视敌人40%的法术防御力"
	                }],
	                "require": {
	                    "books": "高级炎光傀儡卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使炎光傀儡额外获得“寒光波”技能,每秒对敌人造成主人55.8%基础物理攻击的法术伤害并造成“缚足”效果,移动速度降低50%,持续3秒,冷却时间3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使炎光傀儡额外获得“寒光波”技能,每秒对敌人造成主人100%基础物理攻击的法术伤害并造成“缚足”效果,移动速度降低50%,持续3秒,冷却时间3秒"
	                }],
	                "require": {
	                    "books": "高级炎光傀儡卷二*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "暗诡雷",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_77cffc25-a5b1-4e4e-a821-b2c751bb619a_1511",
	        "skillDescribe": {
	            "main": "在原地安置炸药，对进入引爆区域的敌方造成相应效果，暗诡雷最多存在<em class='green'>60</em>秒",
	            "static": ["<em class='green'>2</em>秒内再次使用使暗诡雷显形并朝目标移动", "可以对敌方造成基于物理攻击力的火系伤害，并且可通过烈性炸药或寒性炸药技能进行效果加强，任意炸药都可以解除敌人隐身效果"],
	            "addition": [{
	                "initiative": "烈性炸药强化后下一个安置的暗诡雷可以在造成伤害同时使敌方<em class='green'>击倒3</em>秒",
	                "passivity": "击倒：无法移动和使用技能、轻功"
	            },
	            {
	                "initiative": "寒性炸药强化后下一个安置的暗诡雷可以在爆炸范围内形成一片持续<em class='green'>10</em>秒的冰霜领域",
	                "passivity": "冰霜领域：领域内所有敌方移动速度降低50%，受到的治疗效果降低50%"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成15%基础物理攻击的法术伤害，持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成30%基础物理攻击的法术伤害，持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成45%基础物理攻击的法术伤害，持续3秒"
	                }],
	                "require": {
	                    "books": "中级暗诡雷卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "流火的威力提升50%"
	                },
	                {
	                    "layer": 14,
	                    "value": "流火的威力提升100%"
	                }],
	                "require": {
	                    "preNum": 3,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低5%，持续10秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低10%，持续10秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低15%，持续10秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人1个技能,持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人2个技能,持续5秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人3个技能,持续5秒"
	                }],
	                "require": {
	                    "books": "中级暗诡雷卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "烈性炸药的技能冷却时间降低3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "烈性炸药的技能冷却时间降低5秒"
	                }],
	                "require": {
	                    "books": "高级暗诡雷卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寒性炸药造成的“弱疗”效果提高为58%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寒性炸药造成的“弱疗”效果提高为66%"
	                },
	                {
	                    "layer": 5,
	                    "value": "寒性炸药造成的“弱疗”效果提高为75%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使敌人在冰霜领域内被冰冻3秒"
	                }],
	                "require": {
	                    "books": "中级暗诡雷卷二*钢",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寒性炸药的技能冷却时间降低4秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寒性炸药的技能冷却时间降低8秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "魔能甲",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0ff0eada-4c36-47a0-8dce-a231fcbd5388_1514",
	        "skillDescribe": {
	            "main": "解除控制，魔能甲时间内免疫控制,最多持续<em class='green'>5</em>秒",
	            "static": ["解除自身受到的控制效果"],
	            "addition": [{
	                "initiative": "自身进入<em class='green'>魔能甲</em>状态",
	                "passivity": "魔能甲：增加自身物理防御力，免疫所有控制效果"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“魔能甲”提升的物理防御力额外增加15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“魔能甲”提升的物理防御力额外增加30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“魔能甲”提升的物理防御力额外增加50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高50%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高75%"
	                },
	                {
	                    "layer": 10,
	                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高100%"
	                }],
	                "require": {
	                    "books": "中级魔能甲卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限4%的伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限8%的伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限12%的伤害"
	                }],
	                "require": {
	                    "books": "高级魔能甲卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级魔能甲卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成50%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 4,
	                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成100%基础物理攻击力的物理伤害"
	                },
	                {
	                    "layer": 5,
	                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成150%基础物理攻击力的物理伤害"
	                }],
	                "require": {
	                    "books": "初级魔能甲卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低10%,持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低20%,持续5秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低30%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续3秒"
	                }],
	                "require": {
	                    "books": "高级魔能甲卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "死亡标记",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_fa89ef70-f605-4fb1-ba73-333a2aea7c20_1515",
	        "skillDescribe": {
	            "main": "使目标受到的伤害增加，持续<em class='green'>5</em>秒，可被对方防御效果减伤。",
	            "static": ["被标记目标每次受到的伤害会额外增加"],
	            "addition": [],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高10%"
	                },
	                {
	                    "layer": 5,
	                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "对处于“死亡标记”的目标每次攻击会立即回复30点生命上限"
	                },
	                {
	                    "layer": 9,
	                    "value": "对处于“死亡标记”的目标每次攻击会立即回复60点生命上限"
	                },
	                {
	                    "layer": 10,
	                    "value": "对处于“死亡标记”的目标每次攻击会立即回复100点生命上限"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“死亡标记”效果的持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "“死亡标记”效果的持续时间增加2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "“死亡标记”效果的持续时间增加3秒"
	                }],
	                "require": {
	                    "books": "高级死亡标记卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级死亡标记卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "处于“死亡标记”的目标吟唱时间延长20%"
	                },
	                {
	                    "layer": 4,
	                    "value": "处于“死亡标记”的目标吟唱时间延长40%"
	                },
	                {
	                    "layer": 5,
	                    "value": "处于“死亡标记”的目标吟唱时间延长60%"
	                }],
	                "require": {
	                    "books": "初级死亡标记卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "处于“死亡标记”的目标自身的反控制等级降低7点"
	                },
	                {
	                    "layer": 9,
	                    "value": "处于“死亡标记”的目标自身的反控制等级降低14点"
	                },
	                {
	                    "layer": 10,
	                    "value": "处于“死亡标记”的目标自身的反控制等级降低20点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "处于“死亡标记”的目标攻击力降低5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "处于“死亡标记”的目标攻击力降低10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "处于“死亡标记”的目标攻击力降低15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "聚能",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_54f2863c-a330-4d89-bd9d-c6f854ea1e09_1506",
	        "skillDescribe": {
	            "main": "<em class='green'>10</em>秒内强化自身，增加自己、傀儡、队友的暴击力和暴击加成",
	            "static": ["使自己和周围队友获得<em class='green'>聚能</em>效果"],
	            "addition": [{
	                "initiative": "使用后，自身、傀儡及周围队友获得<em class='green'>聚能</em>效果",
	                "passivity": "聚能：暴击力提升，暴击伤害加成提升15%"
	            }],
	            "trainingName": ["炎", "悟", "钢"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“聚能”状态的暴击力提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“聚能”状态的暴击力提升20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“聚能”状态的暴击力提升30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“聚能”状态的暴击加成力额外提升10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“聚能”状态的暴击加成力额外提升20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "“聚能”状态的暴击加成力额外提升30%"
	                }],
	                "require": {
	                    "books": "中级聚能卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "自身在“聚能”持续期间对敌人造成暴击后,聚能的冷却时间降低1秒,该效果每秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "自身在“聚能”持续期间对敌人造成暴击后,聚能的冷却时间降低2秒,该效果每秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级聚能卷一*炎",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "小幅提高侦测到隐身敌人的概率"
	                },
	                {
	                    "layer": 4,
	                    "value": "大幅提高侦测到隐身敌人的概率"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级聚能卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升15%,持续10秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升30%,持续10秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升45%,持续10秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“充能”状态下，傀儡免疫受到的15%的PVP伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "“充能”状态下，傀儡免疫受到的30%的PVP伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "“充能”状态下，傀儡免疫受到的50%的PVP伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“充能”状态下,傀儡的暴击力提高15%，暴击加成提高5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "“充能”状态下,傀儡的暴击力提高30%，暴击加成提高10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "“充能”状态下,傀儡的暴击力提高50%，暴击加成提高15%"
	                }],
	                "require": {
	                    "books": "高级聚能卷一*钢",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    }],
	    "liuguang": [{
	        "skillName": "魂击",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b618e745-434f-401a-a28b-0834148641c2_16022",
	        "skillDescribe": {
	            "main": "对敌方造成伤害或者回复友方生命值",
	            "static": ["衍光形态下回复友方单体生命值，", "寂灭形态下对敌方单体造成魂系伤害"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,本技能造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,本技能造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高3%*“沐光”层数"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高4%*“沐光”层数"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高5%*“沐光”层数"
	                }],
	                "require": {
	                    "books": "中级魂击卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能0.5秒冷却时间"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能1秒冷却时间"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能1.5秒冷却时间"
	                }],
	                "require": {
	                    "books": "高级魂击卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高3%*“聚魂”层数"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高4%*“聚魂”层数"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高5%*“聚魂”层数"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,当目标处于“灭之魂”状态时,本技能有15%概率对目标造成“缚足”状态,减速50%,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,当目标处于“灭之魂”状态时,本技能有30%概率对目标造成“缚足”状态,减速50%,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高6%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高12%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "魂爆",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_19d380ad-395a-45fb-bd0b-edac1c360e19_16032",
	        "skillDescribe": {
	            "main": "给目标单位加上一个魂印标记，<em class='green'>3</em>秒后爆炸，对目标周围的敌方造成伤害，或者对周围友方造成治疗",
	            "static": ["寂灭：爆炸造成魂系伤害", "衍光：爆炸造成治疗效果"],
	            "addition": [{
	                "initiative": "衍光形态下，爆炸后会使目标周围敌方单位获得<em class='green'>光之魂</em>状态<em class='green'>3</em>秒",
	                "passivity": "对每个光之魂状态下的敌方造成的每次有效伤害都能回复伤害来源者的生命值"
	            },
	            {
	                "initiative": "寂灭形态下，爆炸后会使目标周围敌方单位获得<em class='green'>灭之魂</em>状态<em class='green'>3</em>秒",
	                "passivity": "对灭之魂状态下的敌方造成的每次有效伤害都能造成额外伤害"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下，本技能爆炸时造成的治疗效果提高7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下，本技能爆炸时造成的治疗效果提高14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“光之魂”状态的持续时间延长1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "“光之魂”状态的持续时间延长2秒"
	                }],
	                "require": {
	                    "books": "中级魂爆卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,延时爆炸的时间缩短1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,延时爆炸的时间缩短2秒"
	                }],
	                "require": {
	                    "books": "高级魂爆卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "攻击“光之魂”状态的单位回复的生命上限提高15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "攻击“光之魂”状态的单位回复的生命上限提高30%"
	                },
	                {
	                    "layer": 10,
	                    "value": "攻击“光之魂”状态的单位回复的生命上限提高45%"
	                }],
	                "require": {
	                    "books": "中级魂爆卷二*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,本技能爆炸时造成的法术伤害提高7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,本技能爆炸时造成的法术伤害提高14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“灭之魂”状态的持续时间延长1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "“灭之魂”状态的持续时间延长2秒"
	                }],
	                "require": {
	                    "books": "中级魂爆卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,延时爆炸的时间缩短1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,延时爆炸的时间缩短2秒"
	                }],
	                "require": {
	                    "books": "高级魂爆卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,本技能爆炸时对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,本技能爆炸时对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "攻击“灭之魂”状态的单位造成的额外伤害提高15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "攻击“灭之魂”状态的单位造成的额外伤害提高30%"
	                }],
	                "require": {
	                    "books": "中级魂爆卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "魂珠",
	        "skillProperty": ["法术技能", "引导技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5c51c105-f05b-4b84-87a7-fd5affbb7f8d_16152",
	        "skillDescribe": {
	            "main": "创造5个魂珠，<em class='green'>2</em>秒内连续引导发射，最多发射5个，手动打断或者目标死亡时魂珠消失",
	            "static": ["衍光形态下，每个魂珠都会给目标回复生命值，最后一个魂珠击中目标时，为目标附加<em class='green'>光盾</em>状态", "寂灭形态下，每个魂珠对敌方造成魂系伤害，最后一个魂珠击中目标时，可吸收一定的生命值转移给施法者"],
	            "addition": [{
	                "initiative": "衍光形态下，使目标获得<em class='green'>光盾</em>，持续<em class='green'>5</em>秒",
	                "passivity": "光盾：吸收所受到的伤害"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,本技能造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,本技能造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升1%,持续10秒,最多叠加5层"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升2%,持续10秒,最多叠加5层"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升3%,持续10秒,最多叠加5层"
	                }],
	                "require": {
	                    "books": "中级魂珠卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高60%"
	                },
	                {
	                    "layer": 15,
	                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高100%"
	                }],
	                "require": {
	                    "books": "高级魂珠卷一*光",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“光盾”效果,吸收的伤害量提高20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“光盾”效果,吸收的伤害量提高40%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,本技能的暴击治疗加成效果提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,本技能的暴击治疗加成效果提高60%"
	                }],
	                "require": {
	                    "books": "高级魂珠卷二*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级魂珠卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升1%,持续10秒,最多叠加5层"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升2%,持续10秒,最多叠加5层"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升3%,持续10秒,最多叠加5层"
	                }],
	                "require": {
	                    "books": "中级魂珠卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高60%"
	                },
	                {
	                    "layer": 15,
	                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高100%"
	                }],
	                "require": {
	                    "books": "高级魂珠卷一*暗",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使施法者在施放魂珠的过程中可以移动，但造成的伤害和治疗效果降低30%"
	                },
	                {
	                    "layer": 9,
	                    "value": "使施法者在施放魂珠的过程中可以移动，但造成的伤害和治疗效果降低15%"
	                },
	                {
	                    "layer": 10,
	                    "value": "使施法者在施放魂珠的过程中可以移动"
	                }],
	                "require": {
	                    "books": "中级魂珠卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,本技能的暴击伤害加成提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,本技能的暴击伤害加成提高60%"
	                }],
	                "require": {
	                    "books": "高级魂珠卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "魂域",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ee646d36-c7de-4fc3-a752-60c862c0a41d_16042",
	        "skillDescribe": {
	            "main": "<em class='green'>5</em>秒内持续回复范围内友方单位生命值或持续对敌方单位造成伤害",
	            "static": ["衍光形态下，每秒回复范围内所有友方单位生命值", "寂灭形态下，每秒对范围内敌方单位造成魂系伤害"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,本技能每秒造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,本技能每秒造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高3%"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高6%"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高10%"
	                }],
	                "require": {
	                    "books": "中级魂域卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,魂域的持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,魂域的持续时间增加2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,魂域的持续时间增加3秒"
	                }],
	                "require": {
	                    "books": "高级魂域卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,魂域范围内的友方获得“轻功急速”效果,轻功回复速度提高15%,持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,魂域范围内的友方获得“轻功急速”效果,轻功回复速度提高30%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,本技能每秒造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,本技能每秒造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除2点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除4点轻功值"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除6点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,魂域的持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,魂域的持续时间增加2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,魂域的持续时间增加3秒"
	                }],
	                "require": {
	                    "books": "高级魂域卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,本技能每秒对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,本技能每秒对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "追魂之魄",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a543dde8-3274-4067-9d08-f8f3ed2ec611_16062",
	        "skillDescribe": {
	            "main": "向前释放一颗包含灵气的光球，造成伤害或回复",
	            "static": ["衍光形态下，向前方释放一颗光魄球，光魄球前进途中碰到的友方目标可以获得生命回复效果。<em class='green'>5</em>秒内再次按键可以直接引爆光魄球，立即对半径5米范围内所有友方造成治疗效果。", "寂灭形态下，向前方释放一颗暗魄球，光魄球前进途中每次碰到敌方都会对其造成魂系伤害。<em class='green'>5</em>秒内再次按键可以直接引爆暗魄球，立即对半径5米范围内所有敌方造成魂系伤害。"],
	            "addition": [{
	                "initiative": "光魄球可使被触碰到的友方获得<em class='green'>生命回复</em>状态，持续<em class='green'>10</em>秒",
	                "passivity": "生命回复：状态持续时间内每2秒回复60.5%施法者基础治疗能力的生命值"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,造成的治疗效果提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,造成的治疗效果提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,光魄球的移动速度降低30%，存在时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,光魄球的移动速度降低50%，存在时间增加2秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升40%"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升60%"
	                }],
	                "require": {
	                    "books": "高级追魂之魄卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升15%"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升30%"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升50%"
	                }],
	                "require": {
	                    "books": "高级追魂之魄卷二*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,光魄球移动过程中造成的法术伤害提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,光魄球移动过程中造成的法术伤害提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,光魄球的移动速度降低30%，存在时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,光魄球的移动速度降低50%，存在时间增加2秒"
	                }],
	                "require": {
	                    "books": "中级追魂之魄卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升15%"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升30%"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升50%"
	                }],
	                "require": {
	                    "books": "高级追魂之魄卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能的吟唱时间缩短0.5秒"
	                }],
	                "require": {
	                    "books": "高级追魂之魄卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "魂镜",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8bc318fa-5652-4138-9ede-1b3aae2dc349_16112",
	        "skillDescribe": {
	            "main": "在目标位置召唤魂镜，持续<em class='green'>300</em>秒，最多同时存在一个",
	            "static": ["衍光形态下召唤的魂镜可以给周围队友增加物理和法术防御力", "寂灭形态下召唤的魂镜可以给周围队友增加物理和法术伤害"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“光之魂镜”增加的物理和法术防御力提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“光之魂镜”增加的物理和法术防御力提高15%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“光之魂镜”增加的物理和法术防御力提高20%"
	                }],
	                "require": {
	                    "books": "初级魂镜卷一*光",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高15%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高20%"
	                }],
	                "require": {
	                    "books": "中级魂镜卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高40%"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "使魂镜可以清除周围5米内敌人的隐身效果"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“灭之魂镜”增加的物理和法术攻击力提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“灭之魂镜”增加的物理和法术攻击力提高15%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“灭之魂镜”增加的物理和法术攻击力提高20%"
	                }],
	                "require": {
	                    "books": "初级魂镜卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低40%"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "转魂",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b461b003-1c23-4e2a-9496-37909b2e7434_16012",
	        "skillDescribe": {
	            "main": "使自己切换为衍光或者寂灭形态，对换2系无双值",
	            "static": ["在衍光形态下所有技能增长衍光系无双值，并且增加自身基于敏捷数值百分比的治疗能力", "在寂灭形态下所有技能增长寂灭系无双值，并且增加自身基于敏捷数值百分比的法术攻击力，寂灭形态下对怪物会造成更多的伤害"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态增加的治疗能力提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态增加的治疗能力提高20%"
	                }],
	                "require": {
	                    "books": "初级转魂卷一*光",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,自身的暴击加成提高5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,自身的暴击加成提高10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,自身的暴击加成提高15%"
	                }],
	                "require": {
	                    "books": "中级转魂卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每120秒触发一次）"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每90秒触发一次）"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每60秒触发一次）"
	                }],
	                "require": {
	                    "books": "高级转魂卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,自身的生命上限降低10%,但法术攻击力提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,自身的生命上限降低10%,但法术攻击力提高10%"
	                }],
	                "require": {
	                    "books": "初级转魂卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,自身的暴击加成提高5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,自身的暴击加成提高10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,自身的暴击加成提高15%"
	                }],
	                "require": {
	                    "books": "中级转魂卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每60秒触发一次）"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每45秒触发一次）"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每30秒触发一次）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,对怪物伤害加成的效果提升5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,对怪物伤害加成的效果提升10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,对怪物伤害加成的效果提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "破碎虚空",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_4e03de08-125a-44cc-a65c-da6763ab17e7_16142",
	        "skillDescribe": {
	            "main": "引爆召唤的魂镜",
	            "static": ["引爆衍光魂镜时可恢复范围内友方生命值，并驱散其所有负面状态", "引爆寂灭魂镜时可对范围内敌方造成魂系伤害，并驱散其所有正面状态"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“光之魂镜”爆炸后造成的治疗效果提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“光之魂镜”爆炸后造成的治疗效果提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复50%基础治疗能力*驱散负面状态个数的生命和法力值"
	                },
	                {
	                    "layer": 9,
	                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复75%基础治疗能力*驱散负面状态个数的生命和法力值"
	                },
	                {
	                    "layer": 10,
	                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复100%基础治疗能力*驱散负面状态个数的生命和法力值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“光之魂镜”爆炸后提高自身3%*驱散负面状态总个数的暴击力，持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "“光之魂镜”爆炸后提高自身4%*驱散负面状态总个数的暴击力，持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "“光之魂镜”爆炸后提高自身5%*驱散负面状态总个数的暴击力，持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下，使用破碎虚空后图腾不再消失"
	                }],
	                "require": {
	                    "books": "高级破碎虚空卷二*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“灭之魂镜”爆炸后造成的法术伤害提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“灭之魂镜”爆炸后造成的法术伤害提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成20%基础法术攻击力*驱散正面状态个数的法术伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成35%基础法术攻击力*驱散正面状态个数的法术伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成50%基础法术攻击力*驱散正面状态个数的法术伤害"
	                }],
	                "require": {
	                    "books": "中级破碎虚空卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“灭之魂镜”爆炸后提高自身3%*驱散正面状态总个数的暴击力，持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "“灭之魂镜”爆炸后提高自身4%*驱散正面状态总个数的暴击力，持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "“灭之魂镜”爆炸后提高自身5%*驱散正面状态总个数的暴击力，持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其5秒内无法再次使用隐身技能"
	                },
	                {
	                    "layer": 4,
	                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其10秒内无法再次使用隐身技能"
	                },
	                {
	                    "layer": 5,
	                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其15秒内无法再次使用隐身技能"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下，使用破碎虚空后图腾不再消失"
	                }],
	                "require": {
	                    "books": "高级破碎虚空卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "轮回之门",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5d17f89f-aa32-4f55-915c-4f52d51b8864_16162",
	        "skillDescribe": {
	            "main": "在自身位置召唤轮回之门，轮回之门存在<em class='green'>5</em>秒，对经过的队友或敌方造成影响",
	            "static": ["衍光形态下，召唤<em class='green'>神佑</em>之门，从门里穿过的友方可以获得神佑之门的祝福，获得<em class='green'>神佑</em>效果", "寂灭形态下，召唤<em class='green'>噬魂</em>之门，从门里穿过的敌方会被噬魂之门诅咒，获得<em class='green'>噬魂</em>效果"],
	            "addition": [{
	                "initiative": "<em class='green'>神佑</em>之门可对经过的队友增加<em class='green'>神佑</em>效果，持续<em class='green'>4</em>秒，不可被同一门重复祝福。",
	                "passivity": "神佑：免疫所有控制效果，移动速度提高50%，同时回复生命值"
	            },
	            {
	                "initiative": "<em class='green'>噬魂</em>之门可对经过的敌方增加<em class='green'>噬魂</em>效果，持续<em class='green'>4</em>秒，不会被同一门重复诅咒。",
	                "passivity": "噬魂：减速50%，同时每2秒造成魂系伤害，并且使敌人无法使用轻功"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,“神佑”效果造成的治疗效果提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,“神佑”效果造成的治疗效果提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,“神佑之墙”的存在时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,“神佑之墙”的存在时间增加2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,“神佑之墙”的存在时间增加3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当生命上限低于20%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
	                },
	                {
	                    "layer": 14,
	                    "value": "当生命上限低于40%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
	                },
	                {
	                    "layer": 15,
	                    "value": "当生命上限低于60%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
	                }],
	                "require": {
	                    "books": "高级轮回之门卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加10米"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加20米"
	                },
	                {
	                    "layer": 5,
	                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加30米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级轮回之门卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,“噬魂”效果造成的法术伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,“噬魂”效果造成的法术伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,“噬魂”效果的持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,“噬魂”效果的持续时间增加2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,“噬魂”效果的持续时间增加3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加10米"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加20米"
	                },
	                {
	                    "layer": 5,
	                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加30米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低5点"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低10点"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低15点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "离魂归位",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5ce69221-6008-43da-b50f-b45e678b7bdb_16052",
	        "skillDescribe": {
	            "main": "解除控制，获得护盾,并归位到图腾附近位置",
	            "static": ["衍光状态时使用获得护盾<em class='green'>光辉之珠</em>，吸收一定量的伤害，最多持续<em class='green'>5</em>秒，手动解除<em class='green'>光辉之珠</em>可以解除周围<em class='green'>5</em>米范围内友方的受控状态", "寂灭状态时使用获得护盾<em class='green'>暗夜之珠</em>，吸收一定量的伤害，最多持续<em class='green'>5</em>秒，手动解除<em class='green'>暗夜之珠</em>可以<em class='green'>禁锢</em>周围<em class='green'>5</em>米范围内的敌方"],
	            "addition": [{
	                "initiative": "手动解除<em class='green'>暗夜之珠</em>可以禁锢周围敌方<em class='green'>3</em>秒",
	                "passivity": "禁锢：无法移动、使用轻功和技能"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“光辉之珠”状态下,吸收的伤害增加10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“光辉之珠”状态下,吸收的伤害增加20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "在“光辉之珠”状态下,吸收的伤害增加30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高15%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高20%"
	                }],
	                "require": {
	                    "books": "中级离魂归位卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短50%"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短80%"
	                }],
	                "require": {
	                    "books": "高级离魂归位卷一*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“光辉之珠”状态下,自身的反控等级提高25点"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“光辉之珠”状态下,自身的反控等级提高50点"
	                }],
	                "require": {
	                    "books": "高级离魂归位卷二*光",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级离魂归位卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在“暗夜之珠”状态下,吸收的伤害增加10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在“暗夜之珠”状态下,吸收的伤害增加20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "在“暗夜之珠”状态下,吸收的伤害增加30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高15%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高20%"
	                }],
	                "require": {
	                    "books": "中级离魂归位卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短50%"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短80%"
	                }],
	                "require": {
	                    "books": "高级离魂归位卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“暗夜之珠”状态下,自身的反控等级提高25点"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“暗夜之珠”状态下,自身的反控等级提高50点"
	                }],
	                "require": {
	                    "books": "高级离魂归位卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "灵魂之禁",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d20442dc-59c8-4aae-be30-113a8649e2bc_16132",
	        "skillDescribe": {
	            "main": "对锁定目标使用，造成禁区效果，禁区消失或被击毁后可以产生爆炸，造成效果，禁区持续时间内可以再次使用技能手动引爆",
	            "static": ["光之禁区爆炸后可以恢复禁区周围友方单位生命值", "灭之禁区爆炸后可以对附近敌方单位造成暗系伤害"],
	            "addition": [{
	                "initiative": "衍光状态下只能对团队目标使用，召唤<em class='green'>光之禁区</em>，持续<em class='green'>6</em>秒",
	                "passivity": "光之禁区：禁锢目标并吸收大量伤害"
	            },
	            {
	                "initiative": "寂灭形态下只能对敌方目标使用，召唤<em class='green'>灭之禁区</em>，持续<em class='green'>6</em>秒",
	                "passivity": "灭之禁区：禁锢目标并吸收大量伤害"
	            }],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,“光之禁区”吸收的伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,“光之禁区”吸收的伤害提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "衍光形态下,“光之禁区”吸收的伤害提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,“光之禁区”爆炸造成的治疗效果提升10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,“光之禁区”爆炸造成的治疗效果提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复2%生命上限和法力值"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复3%生命上限和法力值"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复4%生命上限和法力值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,进入“光之禁区”内的敌方目标0.5秒有50%的概率会被“禁锢”,无法移动且无法施法"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,进入“光之禁区”内的敌方目标0.5秒有100%的概率会被“禁锢”,无法移动且无法施法"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级灵魂之禁卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,“灭之禁区”爆炸造成的法术伤害提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,“灭之禁区”爆炸造成的法术伤害提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续4秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续5秒"
	                }],
	                "require": {
	                    "books": "中级灵魂之禁卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除1%的法力值"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除2%的法力值"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除3%的法力值"
	                }],
	                "require": {
	                    "books": "高级灵魂之禁卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "虚空流转",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0878480e-2d3c-4f45-8e37-f197bd79a260_16122",
	        "skillDescribe": {
	            "main": "解除自身控制状态，并使自己和选定目标互换位置",
	            "static": ["衍光形态：使自己和锁定队友、团友互换位置，解除其受到的控制效果，并减少自己<em class='green'>5%</em>的生命值，使目标恢复生命值", "寂灭形态：使自己和锁定敌方互换位置，对目标造成暗系伤害，并给自身回复伤害<em class='green'>50%</em>的生命值"],
	            "addition": [],
	            "trainingName": ["光", "悟", "灭"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续1秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低10%,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低20%,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低30%,持续3秒"
	                }],
	                "require": {
	                    "books": "中级虚空流转卷一*光",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "books": "初级虚空流转卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级虚空流转卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续1秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续2秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续3秒"
	                }],
	                "require": {
	                    "books": "初级虚空流转卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高20%,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高10%,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高30%,持续3秒"
	                }],
	                "require": {
	                    "books": "中级虚空流转卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续3秒"
	                }],
	                "require": {
	                    "books": "高级虚空流转卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能最大射程增加5米"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能最大射程增加10米"
	                }],
	                "require": {
	                    "books": "中级虚空流转卷二*暗",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    }],
	    "yuxu": [{
	        "skillName": "穿云",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_533edd99-62a6-46a2-919d-45125d595314_1201",
	        "skillDescribe": {
	            "main": "对敌方单体造成少量伤害，元灵种类会影响技能效果",
	            "static": ["造成伤害，火灵状态下为火系伤害、雷灵状态下为雷系伤害、冰灵状态下造成冰系伤害", "雷灵状态下<em class='green'>20%</em>概率对目标周围<em class='green'>3</em>米内敌方造成法术伤害"],
	            "addition": [{
	                "initiative": "火灵状态下<em class='green'>20%</em>概率使敌方单体获得<em class='green'>破魔</em>状态<em class='green'>5</em>秒",
	                "passivity": "降低10%的法术防御力"
	            },
	            {
	                "initiative": "冰灵状态下<em class='green'>10%</em>概率使敌方单体获得<em class='green'>缚足</em>状态<em class='green'>2</em>秒",
	                "passivity": "降低50%移动速度"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "火灵状态下,本技能造成的法术伤害提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "火灵状态下,本技能造成的法术伤害提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "火灵状态下，本技能造成的“破魔”降低的法术防御力提高至15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "火灵状态下，本技能造成的“破魔”降低的法术防御力提高至20%"
	                }],
	                "require": {
	                    "books": "中级穿云卷一*诛",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至50%"
	                },
	                {
	                    "layer": 14,
	                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至75%"
	                },
	                {
	                    "layer": 15,
	                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至100%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "雷灵状态下，本技能造成的法术伤害提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "雷灵状态下，本技能造成的法术伤害提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "雷灵状态下，本技能对周围目标造成的伤害比例提高至30%"
	                },
	                {
	                    "layer": 9,
	                    "value": "雷灵状态下，本技能对周围目标造成的伤害比例提高至50%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "雷灵状态下，本技能对“触电”的敌人施放时，对周围目标造成的伤害比例提高至100%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能增长无双值转化为星罗系"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能增长无双值转化为星罗系,并额外增加1点万象系无双（无法享受初级穿云卷一・悟的效果）"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能增长无双值转化为星罗系,并额外增加2点万象系无双（无法享受初级穿云卷一・悟的效果）"
	                }],
	                "require": {
	                    "books": "中级穿云卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至25%"
	                }],
	                "require": {
	                    "books": "初级穿云卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冰灵状态下,本技能造成的“缚足”效果延长1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "冰灵状态下,本技能造成的“缚足”效果延长2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "冰灵状态下,本技能造成的“缚足”效果延长3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰灵状态下,本技能对“冰冻”的敌人造成的“缚足”的概率提高至50%"
	                },
	                {
	                    "layer": 14,
	                    "value": "冰灵状态下,本技能对“冰冻”的敌人造成的“缚足”的概率提高至100%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰灵状态下,本技能对“冰冻”的敌人有25%的概率再次造成“深度冰冻”，持续2秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "流火",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ef03366b-d75e-48df-813b-4993e6ce9bfe_1203",
	        "skillDescribe": {
	            "main": "对敌方单体造成大量伤害，并增加一个元灵",
	            "static": ["造成火系伤害", "火灵状态下<em class='green'>2</em>秒内可以释放流火二斩，可以引爆<em class='green'>灼烧</em>效果，造成全额伤害，若目标身上没有<em class='green'>灼烧</em>效果，则伤害为全额的一半且消耗一个元灵"],
	            "addition": [{
	                "initiative": "使目标敌方获得<em class='green'>灼烧</em>状态<em class='green'>5</em>秒",
	                "passivity": "共计造成189%基础法术攻击力的火系伤害"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "流火一斩造成的法术伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "流火一斩造成的法术伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "流火一斩造成的法术伤害可忽视敌人5%法术防御力"
	                },
	                {
	                    "layer": 9,
	                    "value": "流火一斩造成的法术伤害可忽视敌人10%法术防御力"
	                },
	                {
	                    "layer": 10,
	                    "value": "流火一斩造成的法术伤害可忽视敌人15%法术防御力"
	                }],
	                "require": {
	                    "books": "中级流火卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "流火二斩后有50%概率不消耗1个元灵"
	                },
	                {
	                    "layer": 14,
	                    "value": "流火二斩后有100%概率不消耗1个元灵"
	                }],
	                "require": {
	                    "books": "高级流火卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "流火一斩对怪物造成的法术伤害额外提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "流火一斩对怪物造成的法术伤害额外提高30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "流火一斩对怪物造成的法术伤害额外提高45%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "流火二斩后有50%概率保持原“灼烧”效果"
	                },
	                {
	                    "layer": 9,
	                    "value": "流火二斩后有100%概率保持原“灼烧”效果"
	                }],
	                "require": {
	                    "books": "中级流火卷二*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的射程增加1米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的射程增加3米"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能的射程增加5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对于处在“冰冻”状态的敌人造成的法术伤害额外提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对于处在“冰冻”状态的敌人造成的法术伤害额外提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对于处在“冰冻”状态的敌人有10%概率造成的3秒“晕眩”"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对于处在“冰冻”状态的敌人有20%概率造成的3秒“晕眩”"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对于处在“冰冻”状态的敌人有30%概率造成的3秒“晕眩”"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对于处在“触电”状态的敌人有20%概率造成的3秒“吟唱迟缓”,吟唱时间增加100%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对于处在“触电”状态的敌人有40%概率造成的3秒“吟唱迟缓”,吟唱时间增加100%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对于处在“触电”状态的敌人有20%概率造成的3秒“盲目”,技能射程降低50%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对于处在“触电”状态的敌人有40%概率造成的3秒“盲目”,技能射程降低50%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "冰封",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_e6aac35d-fa4a-49da-bc43-ea60809ec859_1206",
	        "skillDescribe": {
	            "main": "冰冻目标和其周围敌方，并造成伤害，同时增加一个元灵",
	            "static": ["造成冰系伤害", "冰灵状态下<em class='green'>2</em>秒内可以消耗一个元灵使用冰封二斩，击碎冰块，对每一个周围敌方单位造成冰系伤害"],
	            "addition": [{
	                "initiative": "将敌方冰冻2秒",
	                "passivity": "不能移动"
	            },
	            {
	                "initiative": "冰封二斩可以对敌方单位造成缚足效果，持续3秒",
	                "passivity": "移动速度降低50%"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冰封二斩造成的法术伤害额外提高50%,但无法使敌人“缚足”"
	                },
	                {
	                    "layer": 9,
	                    "value": "冰封二斩造成的法术伤害额外提高100%,但无法使敌人“缚足”"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰封二斩后有50%概率不消耗1个元灵"
	                },
	                {
	                    "layer": 14,
	                    "value": "冰封二斩后有100%概率不消耗1个元灵"
	                }],
	                "require": {
	                    "books": "高级冰封卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的射程增加1米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的射程增加3米"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能的射程增加5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“冰冻”效果增加0.2秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“冰冻”效果增加0.5秒"
	                }],
	                "require": {
	                    "books": "中级冰封卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰封二斩击碎冰块后,有50%概率对周围敌人造成“冰冻”效果,持续2秒"
	                }],
	                "require": {
	                    "books": "高级冰封卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "经过冰块的所有敌人造成“缚足”效果,降低移动速度30%,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "经过冰块的所有敌人造成“缚足”效果,降低移动速度50%,持续3秒"
	                }],
	                "require": {
	                    "books": "中级冰封卷二*禁",
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "聚灵",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_7a922185-0c0d-41b5-aae4-4443f25534fc_1225",
	        "skillDescribe": {
	            "main": "开启元灵，每次使用会以火、冰、雷的顺序进行切换，只能存在一种元灵",
	            "static": ["每<em class='green'>5</em>秒自动增加一个元灵，也可以通过使用部分技能获得，最多存在<em class='green'>5</em>个", "元灵可以通过灵袭和剑罚释放，并可以影响部分技能的效果"],
	            "addition": [{
	                "initiative": "聚灵姿态下，自身获得<em class='green'>法术攻击强化</em>效果",
	                "passivity": "提升法术攻击力"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "聚灵姿态增加的法术攻击力提高7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "聚灵姿态增加的法术攻击力提高14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "火元灵状态下,自身的法术破防提升7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "火元灵状态下,自身的法术破防提升14%"
	                }],
	                "require": {
	                    "books": "中级聚灵卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有10%的概率获得1个元灵,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有20%的概率获得1个元灵,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有30%的概率获得1个元灵,该效果每5秒最多触发一次"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "对怪物造成的伤害额外提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "对怪物造成的伤害额外提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "雷灵姿态下,提升的法术攻击力额外提升20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "雷灵姿态下,提升的法术攻击力额外提升40%"
	                }],
	                "require": {
	                    "books": "中级聚灵卷二*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有10%的概率获得1个元灵,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有20%的概率获得1个元灵,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有30%的概率获得1个元灵,该效果每5秒最多触发一次"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升3%"
	                },
	                {
	                    "layer": 4,
	                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升6%"
	                },
	                {
	                    "layer": 5,
	                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升9%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能1%的冷却时间，该效果5秒内最多只能触发一次"
	                },
	                {
	                    "layer": 9,
	                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能2%的冷却时间，该效果5秒内最多只能触发一次"
	                },
	                {
	                    "layer": 10,
	                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能3%的冷却时间，该效果5秒内最多只能触发一次"
	                }],
	                "require": {
	                    "books": "中级聚灵卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低10%，触发间隔30秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低20%，触发间隔30秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低30%，触发间隔30秒"
	                }],
	                "require": {
	                    "books": "高级聚灵卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "灵袭",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_21dc94a8-9209-41c8-8783-5c5ef4f7e5d3_1204",
	        "skillDescribe": {
	            "main": "释放5颗元灵，向前方直线区域发动一次攻击，对范围内所有敌方造成伤害，三系灵袭不共冷却时间",
	            "static": ["火灵状态下造成火系伤害", "冰灵状态下造成冰系伤害", "雷灵状态下召唤雷域对前方所有敌方进行攻击，每0.5秒造成雷系伤害，雷域存在5秒"],
	            "addition": [{
	                "initiative": "火灵状态下对敌方造成灼伤效果，持续6秒",
	                "passivity": "6秒内造成火系伤害"
	            },
	            {
	                "initiative": "冰灵状态下对敌方造成冰冻效果，持续5秒",
	                "passivity": "无法移动和使用技能，被攻击后解除"
	            },
	            {
	                "initiative": "雷灵状态下对敌方造成触电效果，持续5秒",
	                "passivity": "无法使用轻功，降低20%的物理攻击力"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人10%法术防御力"
	                },
	                {
	                    "layer": 4,
	                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人20%法术防御力"
	                },
	                {
	                    "layer": 5,
	                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人30%法术防御力"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外11%伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外22%伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外33%伤害"
	                }],
	                "require": {
	                    "books": "中级灵袭卷一*诛",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "火灵状态下,施放技能所需和消耗的元灵个数降低1个"
	                },
	                {
	                    "layer": 14,
	                    "value": "火灵状态下,施放技能所需和消耗的元灵个数降低2个"
	                }],
	                "require": {
	                    "books": "高级灵袭卷一*诛",
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "雷灵状态下,本技能造成的法术伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "雷灵状态下,本技能造成的法术伤害提升10%"
	                },
	                {
	                    "layer": 5,
	                    "value": "雷灵状态下,本技能造成的法术伤害提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外11%伤害,并对怪物造成的伤害额外提升7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外22%伤害,并对怪物造成的伤害额外提升14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外33%伤害,并对怪物造成的伤害额外提升21%"
	                }],
	                "require": {
	                    "books": "中级灵袭卷二*诛",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "雷灵状态下,施放技能所需和消耗的元灵个数降低1个"
	                },
	                {
	                    "layer": 14,
	                    "value": "雷灵状态下,施放技能所需和消耗的元灵个数降低2个"
	                }],
	                "require": {
	                    "books": "高级灵袭卷二*诛",
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "59"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级灵袭卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "冰灵状态下,本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度50%"
	                },
	                {
	                    "layer": 4,
	                    "value": "冰灵状态下,本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度80%"
	                }],
	                "require": {
	                    "books": "初级灵袭卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低30%轻功回复速度的效果"
	                },
	                {
	                    "layer": 9,
	                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低60%轻功回复速度的效果"
	                },
	                {
	                    "layer": 10,
	                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低90%轻功回复速度的效果"
	                }],
	                "require": {
	                    "books": "中级灵袭卷一*禁",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰灵状态下,施放技能所需和消耗的元灵个数降低1个"
	                },
	                {
	                    "layer": 14,
	                    "value": "冰灵状态下,施放技能所需和消耗的元灵个数降低2个"
	                }],
	                "require": {
	                    "books": "高级灵袭卷一*禁",
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "冰灵状态下,本技能的控制等级提高5点（相当于1级技能的数值）"
	                },
	                {
	                    "layer": 9,
	                    "value": "冰灵状态下,本技能的控制等级提高10点（相当于2级技能的数值）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "冰灵状态下,本技能可随机封印敌人1个技能,使其无法使用,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "冰灵状态下,本技能可随机封印敌人3个技能,使其无法使用,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "冰灵状态下,本技能可随机封印敌人5个技能,使其无法使用,持续3秒"
	                }],
	                "require": {
	                    "books": "高级灵袭卷二*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "骤雷",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_94871f22-68a3-455d-b927-baf378bc63e9_1202",
	        "skillDescribe": {
	            "main": "释放一个向目标移动的闪电球，碰到一个的敌方后直接爆炸，对周围敌方造成伤害",
	            "static": ["爆炸后对周围所有敌方造成雷系伤害", "使用技能增加一个元灵", "雷灵状态下，在闪电球爆炸前再次施放（爆炸后施放无效果），消耗一个元灵转换为一个新的电球向当前目标转移，新的电球在爆炸后可在原地再产生一个持续伤害的雷域"],
	            "addition": [],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "一段造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "一段造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放的闪电球存在时间增加0.5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放的闪电球存在时间增加1秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能施放的闪电球存在时间增加2秒"
	                }],
	                "require": {
	                    "books": "中级骤雷卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "骤雷二斩后有50%概率不消耗1个元灵"
	                },
	                {
	                    "layer": 14,
	                    "value": "骤雷二斩后有100%概率不消耗1个元灵"
	                }],
	                "require": {
	                    "books": "高级骤雷卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "25%概率对闪电球范围内的敌人造成“破魔”效果,法术防御力降低10%,持续2秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "50%概率对闪电球范围内的敌人造成“破魔”效果,法术防御力降低10%,持续2秒"
	                }],
	                "require": {
	                    "books": "中级骤雷卷二*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级骤雷卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "闪电球的移动速度提高50%"
	                },
	                {
	                    "layer": 4,
	                    "value": "闪电球的移动速度提高100%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "被骤雷一段击中的目标有50%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "被骤雷一段击中的目标有75%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "被骤雷一段击中的目标有100%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
	                }],
	                "require": {
	                    "books": "中级骤雷卷一*禁",
	                    "preNum": 1,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "二段造成的法术伤害提升5%"
	                }],
	                "require": {
	                    "books": "初级骤雷卷二*禁",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "闪电球每次伤害都有3%概率使敌人定身1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "闪电球每次伤害都有6%概率使敌人定身1秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "闪电球每次伤害都有9%概率使敌人定身1秒"
	                }],
	                "require": {
	                    "books": "高级骤雷卷二*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "伐·星落",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1213.png",
	        "skillDescribe": {
	            "main": "向后一跃，并对前方区域的所有敌方造成伤害",
	            "static": ["3秒内每秒对敌方造成念系伤害"],
	            "addition": [],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对“冰冻”目标的伤害提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对“冰冻”目标的伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低0.5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低1秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低1秒,自身获得1秒霸体状态"
	                }],
	                "require": {
	                    "books": "高级星落卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级星落卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续1秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续2秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续3秒"
	                }],
	                "require": {
	                    "books": "初级星落卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能每次攻击对敌人都会扣除其5点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能每次攻击对敌人都会扣除其10点轻功值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续3秒"
	                }],
	                "require": {
	                    "books": "高级星落卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能每次攻击对敌人额外造成“涣散”效果,控制等级降低10,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能每次攻击对敌人额外造成“涣散”效果,控制等级降低20,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "定·星阵",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1212.png",
	        "skillDescribe": {
	            "main": "冰冻自身周围的所有敌方，并造成伤害",
	            "static": ["对周围敌方造成冰系伤害"],
	            "addition": [{
	                "initiative": "将敌方冰冻3秒",
	                "passivity": "无法移动和使用技能，受到攻击后解除"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的法术伤害额外提高25%,但无法使敌人“冰冻”（包括深度冰冻）"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的法术伤害额外提高50%,但无法使敌人“冰冻”（包括深度冰冻）"
	                }],
	                "require": {
	                    "books": "中级星阵卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放1次"
	                },
	                {
	                    "layer": 14,
	                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放2次"
	                },
	                {
	                    "layer": 15,
	                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放3次"
	                }],
	                "require": {
	                    "books": "高级星阵卷一*诛",
	                    "preNum": 1,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“冰冻”效果时间延长0.5秒(如果激活中级星阵卷一*诛,该效果将无法生效）"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“冰冻”效果时间延长1秒(如果激活中级星阵卷一*诛,该效果将无法生效）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度50%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度80%"
	                }],
	                "require": {
	                    "books": "中级星阵卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,有50%概率会重置伐*星落的技能冷却时间"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后,有100%概率会重置伐*星落的技能冷却时间"
	                }],
	                "require": {
	                    "books": "高级星阵卷一*禁",
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能有50%概率造成“深度冰冻”效果,被攻击后不会解除"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能有75%概率造成“深度冰冻”效果,被攻击后不会解除"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能有100%概率造成“深度冰冻”效果,被攻击后不会解除"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "佑·星体",
	        "skillProperty": ["辅助技能", "吟唱技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1216.png",
	        "skillDescribe": {
	            "main": "提升自身和周围队友的法术攻击力与法力值上限，并回复一定法力值",
	            "static": ["立即恢复自身和队友的法力值，并增加自身和队友的法力值上限和法术攻击力"],
	            "addition": [{
	                "initiative": "自身获得星体状态，持续1800秒",
	                "passivity": "提升自己的法术攻击力和法力值上限"
	            },
	            {
	                "initiative": "队友获得星体之佑状态，持续1800秒",
	                "passivity": "提升周围队友法术攻击力和法力值上限，效果与星体叠加"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能恢复的法力值提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能恢复的法力值提高30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能恢复的法力值提高45%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高20%"
	                }],
	                "require": {
	                    "books": "中级星体卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高3%"
	                },
	                {
	                    "layer": 14,
	                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高6%"
	                },
	                {
	                    "layer": 14,
	                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高9%"
	                }],
	                "require": {
	                    "books": "高级星体卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能冷却时间降低5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能冷却时间降低10%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能冷却时间降低15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高2%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高4%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高6%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高4%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高8%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高12%"
	                }],
	                "require": {
	                    "books": "中级星体卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“星体”状态下,使自身提高4*体质的生命上限"
	                },
	                {
	                    "layer": 14,
	                    "value": "“星体”状态下,使自身提高8*体质的生命上限"
	                },
	                {
	                    "layer": 15,
	                    "value": "“星体”状态下,使自身提高12*体质的生命上限"
	                }],
	                "require": {
	                    "books": "高级星体卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "遁·流星",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1211.png",
	        "skillDescribe": {
	            "main": "解除控制效果，并向前方瞬移",
	            "static": ["解除自身控制状态", "向前方瞬移20米"],
	            "addition": [],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能使用后3秒内,自身的法术攻击力提高4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能使用后3秒内,自身的法术攻击力提高8%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能使用后3秒内,自身的法术攻击力提高12%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使用后3秒内自身的法术破防率提高4%"
	                },
	                {
	                    "layer": 9,
	                    "value": "使用后3秒内自身的法术破防率提高9%"
	                },
	                {
	                    "layer": 10,
	                    "value": "使用后3秒内自身的法术破防率提高14%"
	                }],
	                "require": {
	                    "books": "中级流星卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能使用后,立刻增加5点星罗系无双值"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能使用后,立刻增加10点星罗系无双值"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能使用后,立刻增加15点星罗系无双值"
	                }],
	                "require": {
	                    "books": "高级流星卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级流星卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能使用后，3秒内自身受到的物理伤害降低8%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能使用后，3秒内自身受到的物理伤害降低15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收3%生命上限上限的伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收6%生命上限上限的伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收9%生命上限上限的伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续3秒"
	                }],
	                "require": {
	                    "books": "高级流星卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能移动距离提高5米(影响移动距离的效果只能生效一种)"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能移动距离提高10米(影响移动距离的效果只能生效一种)"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "裁·星剑",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1214.png",
	        "skillDescribe": {
	            "main": "对指定区域内所有敌方造成大量伤害，并使星剑范围内敌方受到伤害加深，星剑最多存在10秒",
	            "static": ["对范围内所有敌方造成念系伤害"],
	            "addition": [{
	                "initiative": "使范围内所有敌方晕眩3秒",
	                "passivity": "不能移动和使用轻功、技能，被攻击不会解除"
	            },
	            {
	                "initiative": "对周围敌方造成伤害加深效果",
	                "passivity": "伤害加深10%，星剑消失时该效果消失"
	            }],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的法术伤害额外提高30%,但无法使敌人“晕眩”"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的法术伤害额外提高50%,但无法使敌人“晕眩”"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能造成的法术伤害额外提高80%,但无法使敌人“晕眩”"
	                }],
	                "require": {
	                    "books": "中级星剑卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩30%的伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩50%的伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩70%的伤害"
	                }],
	                "require": {
	                    "books": "高级星剑卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级星剑卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "星剑周围的敌人额外造成“缚足”效果,减速50%"
	                },
	                {
	                    "layer": 4,
	                    "value": "星剑周围的敌人额外造成“缚足”效果,减速80%"
	                }],
	                "require": {
	                    "books": "初级星剑卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "星剑周围的敌人额外造成“虚弱”效果,无双增长速度降低15%（同类效果无法共存）"
	                },
	                {
	                    "layer": 9,
	                    "value": "星剑周围的敌人额外造成“虚弱”效果,无双增长速度降低30%（同类效果无法共存）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "星剑周围的友方额外获得“激昂”效果,无双增长速度提高15%（同类效果无法共存）"
	                },
	                {
	                    "layer": 14,
	                    "value": "星剑周围的友方额外获得“激昂”效果,无双增长速度提高30%（同类效果无法共存）"
	                }],
	                "require": {
	                    "books": "高级星剑卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "星剑造成的“晕眩”效果增加0.5秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
	                },
	                {
	                    "layer": 14,
	                    "value": "星剑造成的“晕眩”效果增加1秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
	                },
	                {
	                    "layer": 15,
	                    "value": "星剑造成的“晕眩”效果增加1.5秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
	                }],
	                "require": {
	                    "books": "高级星剑卷二*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "临·星盾",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1215.png",
	        "skillDescribe": {
	            "main": "解除自身控制状态，并且免疫一切威胁",
	            "static": ["自身无法移动和使用技能，同时免疫一切攻击伤害和不良状态，移除大量怪物对自身的仇恨值，持续5秒"],
	            "addition": [],
	            "trainingName": ["诛", "悟", "禁"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "5秒内再次按键则解除星盾,并立即使自己获得3个元灵"
	                },
	                {
	                    "layer": 4,
	                    "value": "5秒内再次按键则解除星盾,并立即使自己获得4个元灵"
	                },
	                {
	                    "layer": 4,
	                    "value": "5秒内再次按键则解除星盾,并立即使自己获得5个元灵"
	                }],
	                "require": {
	                    "books": "初级星盾卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "解除星盾后,立即使自己获得3点星罗系无双值"
	                },
	                {
	                    "layer": 9,
	                    "value": "解除星盾后,立即使自己获得6点星罗系无双值"
	                },
	                {
	                    "layer": 10,
	                    "value": "解除星盾后,立即使自己获得10点星罗系无双值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,立即清空“灵袭”和“万象*剑罚”的技能冷却时间"
	                }],
	                "require": {
	                    "books": "高级星盾卷一*诛",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级星盾卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续4秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在星盾状态下,自身每2秒回复1%的生命上限和法力值"
	                },
	                {
	                    "layer": 9,
	                    "value": "在星盾状态下,自身每2秒回复2%的生命上限和法力值"
	                },
	                {
	                    "layer": 10,
	                    "value": "在星盾状态下,自身每2秒回复3%的生命上限和法力值"
	                }],
	                "require": {
	                    "books": "中级星盾卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "星盾周围5米范围内的敌人有50%的概率会造成“冰冻”效果,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "星盾周围5米范围内的敌人有75%的概率会造成“冰冻”效果,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "星盾周围5米范围内的敌人有100%的概率会造成“冰冻”效果,持续3秒"
	                }],
	                "require": {
	                    "books": "高级星盾卷一*禁",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    }],
	    "shengtang": [{
	        "skillName": "猛击",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d7fb5bb4-75a1-42a1-b5a4-bc5601ef74e9_1101",
	        "skillDescribe": {
	            "main": "对前方扇形区域的所有敌方造成少量伤害",
	            "static": ["造成物理伤害"],
	            "addition": [],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对“流血”的目标造成的伤害额外提升2%*“流血”层数"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对“流血”的目标造成的伤害额外提升4%*“流血”层数"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对“流血”的目标造成的伤害额外提升6%*“流血”层数"
	                }],
	                "require": {
	                    "books": "中级猛击卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“雷罡体”状态下,本技能有10%的概率对敌人造成“流血”效果"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“雷罡体”状态下,本技能有20%的概率对敌人造成“流血”效果"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“雷罡体”状态下,本技能有30%的概率对敌人造成“流血”效果"
	                }],
	                "require": {
	                    "books": "高级猛击卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“雷罡体”状态下,本技能有30%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“雷罡体”状态下,本技能有50%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
	                }],
	                "require": {
	                    "books": "高级猛击卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有20%的概率对敌人造成“破甲”效果,降低2.5%物理防御力,持续5秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有40%的概率对敌人造成“破甲”效果,降低2.5%物理防御力,持续5秒"
	                }],
	                "require": {
	                    "books": "初级猛击卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对敌人造成“破甲”效果的时间延长1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对敌人造成“破甲”效果的时间延长3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对敌人造成“破甲”效果的时间延长5秒"
	                }],
	                "require": {
	                    "books": "中级猛击卷一*佑",
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对敌人造成“破甲”效果最多可叠加2层"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对敌人造成“破甲”效果最多可叠加3层"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对敌人造成“破甲”效果最多可叠加4层"
	                }],
	                "require": {
	                    "books": "高级猛击卷一*佑",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至60%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至80%"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至100%"
	                }],
	                "require": {
	                    "books": "高级猛击卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "扫荡",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_7f1eaebe-b54b-4c0f-ad28-e5c82531fc67_1104",
	        "skillDescribe": {
	            "main": "对自身周围的所有敌方造成伤害，并附加流血效果",
	            "static": ["对周围所有敌方造成物理伤害"],
	            "addition": [{
	                "initiative": "使周围所有敌方进入<em class='green'>流血</em>状态<em class='green'>6</em>秒",
	                "passivity": "6秒内每2秒受到物理伤害，同时会对受到来自自己赋予流血状态的敌人，之后造成的攻击会提高每层1%的伤害"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能造成的“流血”效果持续时间提高2秒（包括自身其他技能产生的“流血”效果）"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能造成的“流血”效果持续时间提高4秒（包括自身其他技能产生的“流血”效果）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能造成的“流血”效果最多可叠加3层（包括自身其他技能产生的“流血”效果）"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能造成的“流血”效果最多可叠加4层（包括自身其他技能产生的“流血”效果）"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能造成的“流血”效果最多可叠加5层（包括自身其他技能产生的“流血”效果）"
	                }],
	                "require": {
	                    "books": "中级扫荡卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能造成的“流血”效果伤害提高4%（包括自身其他技能产生的“流血”效果）"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能造成的“流血”效果伤害提高8%（包括自身其他技能产生的“流血”效果）"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能造成的“流血”效果伤害提高12%（包括自身其他技能产生的“流血”效果）"
	                }],
	                "require": {
	                    "books": "高级扫荡卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的直接伤害提高7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的直接伤害提高14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的直接伤害对怪物额外提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的直接伤害对怪物额外提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续6秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续8秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续10秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“铁甲”效果最多可叠加2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "“铁甲”效果最多可叠加3层"
	                },
	                {
	                    "layer": 10,
	                    "value": "“铁甲”效果最多可叠加4层"
	                }],
	                "require": {
	                    "books": "中级扫荡卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当自身处于“铁甲”状态且受到暴击伤害时,自动触发“铁甲护体”效果,受到的伤害额外降低12%,持续5秒,触发间隔1分钟"
	                },
	                {
	                    "layer": 14,
	                    "value": "当自身处于“铁甲”状态且受到暴击伤害时,自动触发“铁甲护体”效果,受到的伤害额外降低25%,持续5秒,触发间隔1分钟"
	                }],
	                "require": {
	                    "books": "高级扫荡卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "破阵",
	        "skillProperty": ["物理技能", "蓄力技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_be47d4da-0767-4b30-8f2b-859d30359ba6_1105",
	        "skillDescribe": {
	            "main": "对前方区域所有敌方造成伤害",
	            "static": ["造成物理伤害", "蓄力<em class='green'>0.5</em>秒后可将打击对象击退5米"],
	            "addition": [{
	                "initiative": "蓄力0.5秒后可使打击对象获得攻击削弱效果，持续3秒",
	                "passivity": "降低10%的攻击力"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高11%"
	                },
	                {
	                    "layer": 9,
	                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高22%"
	                },
	                {
	                    "layer": 10,
	                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高33%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高40%"
	                },
	                {
	                    "layer": 15,
	                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高60%"
	                }],
	                "require": {
	                    "books": "高级破阵卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有20%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有40%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能有60%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
	                }],
	                "require": {
	                    "books": "初级破阵卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "蓄力时间增加0.5秒,技能造成的物理伤害提高25%,对敌人降低的攻击力提高为15%。"
	                },
	                {
	                    "layer": 9,
	                    "value": "蓄力时间增加1秒,技能造成的物理伤害提高50%,对敌人降低的攻击力提高为20%。"
	                }],
	                "require": {
	                    "books": "中级破阵卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“罡体”状态下,蓄力结束后,本技能有30%的概率对怪物“击倒”2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“罡体”状态下,蓄力结束后,本技能有60%的概率对怪物“击倒”2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“罡体”状态下,蓄力结束后,本技能有100%的概率对怪物“击倒”2秒"
	                }],
	                "require": {
	                    "books": "高级破阵卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "旋斩",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_cd674063-0bb3-4c15-ae62-b6fb987bb79f_1103",
	        "skillDescribe": {
	            "main": "击倒前方区域的所有敌方并造成伤害",
	            "static": ["造成物理伤害", "2秒内可以再次按键，使用旋斩二斩，3秒内对敌方造成物理伤害"],
	            "addition": [{
	                "initiative": "使敌方被<em class='green'>击倒</em>，持续3秒",
	                "passivity": "自身倒地，无法移动和释放技能"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "旋斩二段造成的物理伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "旋斩二段造成的物理伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高17%"
	                },
	                {
	                    "layer": 9,
	                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高34%"
	                },
	                {
	                    "layer": 10,
	                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高51%"
	                }],
	                "require": {
	                    "books": "中级旋斩卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高60%"
	                },
	                {
	                    "layer": 15,
	                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高90%"
	                }],
	                "require": {
	                    "books": "高级旋斩卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "旋斩二段对怪物伤害额外提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "旋斩二段对怪物伤害额外提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "旋斩二斩施放期间，自身可以移动"
	                }],
	                "require": {
	                    "books": "高级旋斩卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "59"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "49"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "旋斩二斩持续期间内，自身受到的伤害降低3%"
	                },
	                {
	                    "layer": 4,
	                    "value": "旋斩二斩持续期间内，自身受到的伤害降低6%"
	                },
	                {
	                    "layer": 5,
	                    "value": "旋斩二斩持续期间内，自身受到的伤害降低9%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "旋斩二斩的持续时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "旋斩二斩的持续时间增加2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "旋斩二斩的持续时间增加3秒"
	                }],
	                "require": {
	                    "books": "中级旋斩卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "旋斩二斩持续期间内,自身的反控制等级提高25点"
	                },
	                {
	                    "layer": 14,
	                    "value": "旋斩二斩持续期间内,自身的反控制等级提高50点"
	                }],
	                "require": {
	                    "books": "高级旋斩卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "定军",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_c6f4a9d3-0ecb-4d16-adb2-d4f9957aa27e_1112",
	        "skillDescribe": {
	            "main": "对前方直线上所有敌方造成伤害并附加断筋效果",
	            "static": ["对区域内所有敌方造成物理伤害", "造成一个地裂区域，5秒内每秒造成雷系伤害"],
	            "addition": [{
	                "initiative": "使范围内敌方断筋，持续3秒",
	                "passivity": "移动速度降低50%"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能伤害提高50%，但不再生成地裂区域的持续伤害和断筋效果"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能伤害提高75%，但不再生成地裂区域的持续伤害和断筋效果"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对于倒地状态的敌人，造出的伤害额外提高19%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对于倒地状态的敌人，造出的伤害额外提高38%"
	                }],
	                "require": {
	                    "books": "高级定军卷一*罚",
	                    "preNum": 2,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“断筋”效果额外降低目标4%的物理防御力"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“断筋”效果额外降低目标8%的物理防御力"
	                }],
	                "require": {
	                    "books": "中级定军卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“雷罡体”状态下，本技能对敌人造成定身1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“雷罡体”状态下，本技能对敌人造成定身1.5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“雷罡体”状态下，本技能对敌人造成定身2秒"
	                }],
	                "require": {
	                    "books": "高级定军卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "59"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "减少定军0.5秒的吟唱时间"
	                }],
	                "require": {
	                    "books": "高级定军卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "地裂区域的法术伤害提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "地裂区域的法术伤害提高30%"
	                },
	                {
	                    "layer": 5,
	                    "value": "地裂区域的法术伤害提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "地裂区域持续时间提高1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "地裂区域持续时间提高2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "地裂区域持续时间提高3秒"
	                }],
	                "require": {
	                    "books": "中级定军卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "处于地裂区域内的敌人,受到的治疗效果降低30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "处于地裂区域内的敌人,受到的治疗效果降低40%"
	                },
	                {
	                    "layer": 15,
	                    "value": "处于地裂区域内的敌人,受到的治疗效果降低50%"
	                }],
	                "require": {
	                    "books": "高级定军卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "地裂区域对怪物造成的法术伤害额外提高25%"
	                },
	                {
	                    "layer": 9,
	                    "value": "地裂区域对怪物造成的法术伤害额外提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "地裂区域内的敌人受到的伤害提高4%"
	                },
	                {
	                    "layer": 14,
	                    "value": "地裂区域内的敌人受到的伤害提高8%"
	                },
	                {
	                    "layer": 15,
	                    "value": "地裂区域内的敌人受到的伤害提高12%"
	                }],
	                "require": {
	                    "books": "高级定军卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "降世",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_905516bd-e671-4f05-9caf-c3d4bf374a2c_1102",
	        "skillDescribe": {
	            "main": "纵身一跃，快速跳向目标敌方，击倒范围内所有敌方并造成伤害",
	            "static": ["造成物理伤害"],
	            "addition": [{
	                "initiative": "将范围内敌方击倒，持续3秒",
	                "passivity": "自身倒地，无法移动和释放技能"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的物理伤害提高25%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的物理伤害提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能的最远射程提高1米"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能的最远射程提高3米"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能的最远射程提高5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低7%物理防御力,持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低14%物理防御力,持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低21%物理防御力,持续3秒"
	                }],
	                "require": {
	                    "books": "高级降世卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级降世卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高50%,并产生大量仇恨"
	                },
	                {
	                    "layer": 4,
	                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高100%,并产生大量仇恨"
	                },
	                {
	                    "layer": 5,
	                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高150%,并产生大量仇恨"
	                }],
	                "require": {
	                    "books": "初级降世卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能的最远射程提高1米"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能的最远射程提高3米"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能的最远射程提高5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“罡体”状态下,本技能施放后,自身获得霸体效果,持续1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“罡体”状态下,本技能施放后,自身获得霸体效果,持续2秒"
	                }],
	                "require": {
	                    "books": "高级降世卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "罡体",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bb58f86c-8768-487e-93e0-50aaa661e6f1_1115",
	        "skillDescribe": {
	            "main": "使用开启或者关闭罡体状态，罡体与雷罡体共享冷却时间",
	            "static": [],
	            "addition": [{
	                "initiative": "开启时获得罡体效果",
	                "passivity": "物理防御力提升，法术防御力提升，伤害减免率提升3%，同时降低自身50%的移动速度，造成的仇恨值增加50%"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "雷罡体状态下，自身攻击力提升1%"
	                },
	                {
	                    "layer": 4,
	                    "value": "雷罡体状态下，自身攻击力提升2%"
	                },
	                {
	                    "layer": 5,
	                    "value": "雷罡体状态下，自身攻击力提升3%"
	                }],
	                "require": {
	                    "books": "初级罡体卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“雷罡体”状态,自身的暴击力提升5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“雷罡体”状态,自身的暴击力提升10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "“雷罡体”状态,自身的暴击力提升15%"
	                }],
	                "require": {
	                    "books": "中级罡体卷一*罚",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“雷罡体”状态,天罚系无双增长速度提升5%（同类效果无法共存）"
	                },
	                {
	                    "layer": 14,
	                    "value": "“雷罡体”状态,天罚系无双增长速度提升10%（同类效果无法共存）"
	                },
	                {
	                    "layer": 15,
	                    "value": "“雷罡体”状态,天罚系无双增长速度提升15%（同类效果无法共存）"
	                }],
	                "require": {
	                    "books": "高级罡体卷一*罚",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“罡体”状态,移动速度下降变为30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“罡体”状态,移动速度下降变为15%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“罡体”状态,不减移动速度"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加30%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加45%"
	                }],
	                "require": {
	                    "books": "中级罡体卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“罡体”状态,神佑系无双增长速度提升5%（同类效果无法共存）"
	                },
	                {
	                    "layer": 14,
	                    "value": "“罡体”状态,神佑系无双增长速度提升10%（同类效果无法共存）"
	                },
	                {
	                    "layer": 15,
	                    "value": "“罡体”状态,神佑系无双增长速度提升15%（同类效果无法共存）"
	                }],
	                "require": {
	                    "books": "高级罡体卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“罡体”状态,提升1%额外破防抵抗率"
	                },
	                {
	                    "layer": 14,
	                    "value": "“罡体”状态,提升1%额外破防抵抗率"
	                },
	                {
	                    "layer": 15,
	                    "value": "“罡体”状态,提升1%额外破防抵抗率"
	                }],
	                "require": {
	                    "books": "高级罡体卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "龙握",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_69f176a5-2841-4a7b-b1b3-d311f75968e6_1111",
	        "skillDescribe": {
	            "main": "强行将目标敌方拉向自己，并造成伤害",
	            "static": ["打断目标技能的吟唱或引导过程，强行将目标拉到自己身边", "造成物理伤害"],
	            "addition": [],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "使本技能造成的物理伤害提高25%"
	                },
	                {
	                    "layer": 4,
	                    "value": "使本技能造成的物理伤害提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有50%的概率对“流血”的目标造成“迟钝”效果,无法使用轻功,持续2秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有100%的概率对“流血”的目标造成“迟钝”效果,无法使用轻功,持续2秒"
	                }],
	                "require": {
	                    "books": "中级龙握卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在雷罡体状态下,本技能会随机封印目标1个技能,持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在雷罡体状态下,本技能会随机封印目标2个技能,持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在雷罡体状态下,本技能会随机封印目标3个技能,持续5秒"
	                }],
	                "require": {
	                    "books": "高级龙握卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能的最远射程提高1米"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能的最远射程提高3米"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能的最远射程提高5米"
	                }],
	                "require": {
	                    "books": "高级龙握卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "59"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级龙握卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能有50%的概率迫使怪物5秒内强制攻击自己"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能有100%的概率迫使怪物5秒内强制攻击自己"
	                }],
	                "require": {
	                    "books": "初级龙握卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在罡体状态下,本技能使目标的物理攻击力降低6%,持续3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "在罡体状态下,本技能使目标的物理攻击力降低12%,持续3秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "在罡体状态下,本技能使目标的物理攻击力降低20%,持续3秒"
	                }],
	                "require": {
	                    "books": "中级龙握卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在罡体状态下,本技能会随机封印目标1个技能,持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在罡体状态下,本技能会随机封印目标2个技能,持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在罡体状态下,本技能会随机封印目标3个技能,持续5秒"
	                }],
	                "require": {
	                    "books": "高级龙握卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后,将自身牵引至敌人身前,并造成敌人“定身”1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后,将自身牵引至敌人身前,并造成敌人“定身”2秒"
	                }],
	                "require": {
	                    "books": "高级龙握卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "铁血",
	        "skillProperty": ["辅助技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3784085c-2582-418b-9019-a0ad3c245e08_1113",
	        "skillDescribe": {
	            "main": "增加自身和周围队友的生命上限",
	            "static": [],
	            "addition": [{
	                "initiative": "自身获得铁血效果，持续600秒",
	                "passivity": "增加自身生命值上限，受到的治疗效果提升20%"
	            },
	            {
	                "initiative": "队友获得铁血效果，持续600秒",
	                "passivity": "增加周围队友生命上限"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高5%,持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高10%,持续5秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高15%,持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得4%的“吸血”效果,持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得8%的“吸血”效果,持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得12%的“吸血”效果,持续5秒"
	                }],
	                "require": {
	                    "books": "高级铁血卷一*罚",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“铁血”状态对自身提升的生命上限效果提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.2%生命上限,持续10秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.4%生命上限,持续10秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.6%生命上限,持续10秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复1%生命上限,持续10秒,触发间隔2分钟"
	                },
	                {
	                    "layer": 14,
	                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复2%生命上限,持续10秒,触发间隔2分钟"
	                },
	                {
	                    "layer": 15,
	                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复3%生命上限,持续10秒,触发间隔2分钟"
	                }],
	                "require": {
	                    "books": "高级铁血卷一*佑",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“铁血”状态对自身受到的治疗效果提升至25%"
	                },
	                {
	                    "layer": 9,
	                    "value": "“铁血”状态对自身受到的治疗效果提升至30%"
	                }],
	                "require": {
	                    "books": "中级铁血卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "啸天",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9a43e99a-fd4d-4204-99be-195301b7f77c_1116",
	        "skillDescribe": {
	            "main": "解除控制并进入霸体状态，持续3秒",
	            "static": ["解除自身控制状态"],
	            "addition": [{
	                "initiative": "进入霸体状态",
	                "passivity": "免除所有控制效果"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能使自身的获得的“霸体”状态时间延长0.5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能使自身的获得的“霸体”状态时间延长1秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能使自身的获得的“霸体”状态时间延长2秒"
	                }],
	                "require": {
	                    "books": "中级啸天卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低1秒,该效果每3秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低3秒,该效果每3秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低5秒,该效果每3秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级啸天卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级啸天卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能使自身的获得的“霸体”状态额外增加自身5%的物理和法术防御力"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能使自身的获得的“霸体”状态额外增加自身10%的物理和法术防御力"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能使自身的获得的“霸体”状态额外增加自身15%的物理和法术防御力"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在“霸体”状态下,躲闪率增加自身5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在“霸体”状态下,躲闪率增加自身10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在“霸体”状态下,躲闪率增加自身15%"
	                }],
	                "require": {
	                    "books": "中级啸天卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复3%生命上限,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复6%生命上限,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复10%生命上限,该效果每5秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级啸天卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "光盾",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_35079a1f-9fba-4ead-9b24-38d84905ac3d_1106",
	        "skillDescribe": {
	            "main": "只有开启罡体或者雷罡体时使用，可以开启光盾",
	            "static": ["光盾可以吸收自身受到的伤害，开启光盾时无法使用猛击以外的其他技能", "再次使用或持续时间结束会触发光盾反击，造成物理伤害"],
	            "addition": [{
	                "initiative": "获得光盾效果3秒",
	                "passivity": "最多吸收自身受到的伤害"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在雷罡体状态下，光盾反击的伤害提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在雷罡体状态下，光盾反击的伤害提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*5的伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*10的伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*15的伤害"
	                }],
	                "require": {
	                    "books": "中级光盾卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在雷罡体状态下,光盾反击有15%的概率对敌人“击倒”2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "在雷罡体状态下,光盾反击有30%的概率对敌人“击倒”2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "在雷罡体状态下,光盾反击有50%的概率对敌人“击倒”2秒"
	                }],
	                "require": {
	                    "books": "高级光盾卷一*罚",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在罡体状态下,光盾吸收的伤害提高15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在罡体状态下,光盾吸收的伤害提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低13%的折损量"
	                },
	                {
	                    "layer": 9,
	                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低23%的折损量"
	                },
	                {
	                    "layer": 10,
	                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低30%的折损量"
	                }],
	                "require": {
	                    "books": "中级光盾卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的10%吸收为自身伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的20%吸收为自身伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的30%吸收为自身伤害"
	                }],
	                "require": {
	                    "books": "高级光盾卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使光盾只能吸收法术伤害，吸收量提高50%"
	                },
	                {
	                    "layer": 9,
	                    "value": "使光盾只能吸收法术伤害，吸收量提高100%"
	                },
	                {
	                    "layer": 10,
	                    "value": "使光盾只能吸收法术伤害，吸收量提高150%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "无畏",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_37d87ecd-9496-4285-ae37-2a5267a29b5d_1114",
	        "skillDescribe": {
	            "main": "提升自身防御力和攻击力，持续5秒",
	            "static": [],
	            "addition": [{
	                "initiative": "自身获得进入无畏状态",
	                "passivity": "提升自身20%攻击力和防御力"
	            },
	            {
	                "initiative": "罡体状态下使用进入无畏-护状态",
	                "passivity": "降低自身50%攻击力，提升30%伤害减免率，与绝对守护的减伤效果无法叠加，同时存在则取两者中最强的减伤效果"
	            },
	            {
	                "initiative": "雷罡体状态下使用进入无畏-破状态",
	                "passivity": "受到的伤害额外增加30%，提升50%攻击力"
	            }],
	            "trainingName": ["罚", "悟", "佑"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高40%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高60%"
	                }],
	                "require": {
	                    "books": "中级无畏卷一*罚",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低1秒,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低2秒,该效果每5秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低3秒,该效果每5秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级无畏卷一*罚",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得10点天罚系无双值"
	                },
	                {
	                    "layer": 9,
	                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得15点天罚系无双值"
	                },
	                {
	                    "layer": 10,
	                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得20点天罚系无双值"
	                }],
	                "require": {
	                    "books": "中级无畏卷二*罚",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降25%"
	                },
	                {
	                    "layer": 5,
	                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降40%"
	                }],
	                "require": {
	                    "books": "初级无畏卷一*佑",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升30%"
	                },
	                {
	                    "layer": 10,
	                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升45%"
	                }],
	                "require": {
	                    "books": "中级无畏卷一*佑",
	                    "preNum": 3,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低1秒,该效果每3秒最多触发一次"
	                },
	                {
	                    "layer": 14,
	                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低3秒,该效果每3秒最多触发一次"
	                },
	                {
	                    "layer": 15,
	                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低5秒,该效果每3秒最多触发一次"
	                }],
	                "require": {
	                    "books": "高级无畏卷一*佑",
	                    "preNum": 3,
	                    "totolNum": 6,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得10点神佑系无双值"
	                },
	                {
	                    "layer": 9,
	                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得15点神佑系无双值"
	                },
	                {
	                    "layer": 10,
	                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得20点神佑系无双值"
	                }],
	                "require": {
	                    "books": "中级无畏卷二*佑",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    }],
	    "linglong": [{
	        "skillName": "灵击",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_01d54635-2a5c-4c9a-9366-a2867466a782_1401",
	        "skillDescribe": {
	            "main": "对敌方单体造成少量伤害",
	            "static": ["对敌方造成念系伤害"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成法术伤害提高4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成法术伤害提高8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "对“飞萤之痛”状态下敌人额外伤害提升7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "对“飞萤之痛”状态下敌人额外伤害提升14%"
	                }],
	                "require": {
	                    "books": "中级灵击卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有10%概率将该状态传染给附近的1个敌人"
	                },
	                {
	                    "layer": 14,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有20%概率将该状态传染给附近的1个敌人"
	                },
	                {
	                    "layer": 15,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有30%概率将该状态传染给附近的1个敌人"
	                }],
	                "require": {
	                    "books": "高级灵击卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高6%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高12%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有10%的概率额外增长1个魂气"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有20%的概率额外增长1个魂气"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高6%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高12%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高18%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对敌人造成伤害后,立即回复自身1%基础治疗能力的法力值"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对敌人造成伤害后,立即回复自身2%基础治疗能力的法力值"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对敌人造成伤害后,立即回复自身3%基础治疗能力的法力值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对敌人造成暴击伤害后,额外获得1点巧语系无双值"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对敌人造成暴击伤害后,额外获得2点巧语系无双值"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能对敌人造成暴击伤害后,额外获得3点巧语系无双值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "飞萤",
	        "skillProperty": ["法术技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0c95f8ab-e93e-4004-9f1d-0d2dd4bef693_1406",
	        "skillDescribe": {
	            "main": "对敌方单体施加<em class='green'>飞莹之痛</em>状态，不可被驱除",
	            "static": ["每<em class='green'>2</em>秒造成一次魂系伤害，持续<em class='green'>6</em>秒，不可被驱除"],
	            "addition": [{
	                "initiative": "敌方获得<em class='green'>飞莹之痛</em>状态",
	                "passivity": "飞莹之痛：持续受到飞莹折磨，损失生命值"
	            },
	            {
	                "initiative": "敌方获得<em class='green'>飞莹之伤</em>状态",
	                "passivity": "飞莹之痛：使敌人受到的伤害提高2%"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果持续时间提高2秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果持续时间提高4秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加3层"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加4层"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能造成的“飞萤之痛”效果伤害提高10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能造成的“飞萤之痛”效果伤害提高20%"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能造成的“飞萤之痛”效果伤害提高30%"
	                }],
	                "require": {
	                    "books": "高级飞莹卷一*魂",
	                    "preNum": 3,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "消耗2点魂气，使飞萤可以瞬间造成60%基础法术攻击力的法术伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "消耗2点魂气，使飞萤可以瞬间造成120%基础法术攻击力的法术伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级飞莹卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低1%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低2%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低3%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的轻功回复速度降低5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的轻功回复速度降低10%"
	                }],
	                "require": {
	                    "books": "中级飞莹卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低3%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低4%"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低5%"
	                }],
	                "require": {
	                    "books": "高级飞莹卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "青鸟",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1d521290-0a1e-478d-aa9c-60b11f3353fc_1402",
	        "skillDescribe": {
	            "main": "对敌方及其周围单位造成伤害",
	            "static": ["对敌方造成魂系伤害"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对“飞萤之痛”的目标造成的伤害额外提升3%*“飞萤之痛”层数"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对“飞萤之痛”的目标造成的伤害额外提升5%*“飞萤之痛”层数"
	                }],
	                "require": {
	                    "books": "中级青鸟卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "提高0.5秒吟唱时间,使本技能造成的法术伤害提高25%"
	                },
	                {
	                    "layer": 14,
	                    "value": "提高1秒吟唱时间,使本技能造成的法术伤害提高50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "消耗2点魂气，提高20%的技能伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "消耗2点魂气，提高40%的技能伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有10%概率将该状态传染给周围的敌人"
	                },
	                {
	                    "layer": 4,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有20%概率将该状态传染给周围的敌人"
	                },
	                {
	                    "layer": 5,
	                    "value": "当目标身上有“飞萤之痛”状态时,则有30%概率将该状态传染给周围的敌人"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有25%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有50%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有75%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能30%的伤害,且不需要吟唱"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能60%的伤害,且不需要吟唱"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能100%的伤害,且不需要吟唱"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有12%的概率造成“晕眩”效果,持续2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有25%的概率造成“晕眩”效果,持续2秒"
	                }],
	                "require": {
	                    "books": "高级青鸟卷二*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "春风",
	        "skillProperty": ["回复技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a8d41be1-6c5c-4e9e-85e5-fb67022e7889_1411",
	        "skillDescribe": {
	            "main": "治疗自身或友方单体，恢复少量生命值",
	            "static": ["回复自身或友方的生命值"],
	            "addition": [{
	                "initiative": "使目标获得<em class='green'>如沐春风</em>状态，持续<em class='green'>10</em>秒，最多叠加<em class='green'>3</em>层",
	                "passivity": "如沐春风：状态时间内每2秒回复一次生命值"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的直接治疗效果提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的直接治疗效果提升20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "每一层“如沐春风”状态的生命上限回复效果增加10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "每一层“如沐春风”状态的生命上限回复效果增加20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "每一层“如沐春风”状态的生命上限回复效果增加30%"
	                }],
	                "require": {
	                    "books": "中级春风卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“如沐春风”状态的最多叠加层数增加1层"
	                },
	                {
	                    "layer": 14,
	                    "value": "“如沐春风”状态的最多叠加层数增加2层"
	                }],
	                "require": {
	                    "books": "高级春风卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有25%的概率额外增长1个灵气"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有50%的概率额外增长1个灵气"
	                }],
	                "require": {
	                    "books": "中级春风卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升1%"
	                },
	                {
	                    "layer": 4,
	                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升2%"
	                },
	                {
	                    "layer": 5,
	                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升3%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放时有25%概率降低青蔓的冷却时间1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放时有50%概率降低青蔓的冷却时间1秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔90秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔60秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔30秒"
	                }],
	                "require": {
	                    "books": "高级春风卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的射程增加3米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的射程增加5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "鱼跃",
	        "skillProperty": ["法术技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_2cff711a-1e29-4c84-a9bb-c48533a72b5a_1405",
	        "skillDescribe": {
	            "main": "<em class='green'>5</em>秒内持续对指定区域内所有敌方造成缚足和伤害",
	            "static": ["每秒对区域内敌方造成魂系伤害"],
	            "addition": [{
	                "initiative": "区域内所有敌方获得<em class='green'>缚足</em>状态",
	                "passivity": "缚足：移动速度降低50%"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的法术伤害提高5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的法术伤害提高10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有50%概率立即结算敌人身上所有“飞萤之痛”的剩余伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有100%概率立即结算敌人身上所有“飞萤之痛”的剩余伤害"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "提高0.5秒吟唱时间,使本技能造成的法术伤害提高25%"
	                },
	                {
	                    "layer": 14,
	                    "value": "提高1秒吟唱时间,使本技能造成的法术伤害提高50%"
	                }],
	                "require": {
	                    "books": "高级鱼跃卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的法术伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "消耗2点魂气，使鱼跃首次可以额外造成100%基础法术攻击力的法术伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "消耗2点魂气，使鱼跃首次可以额外造成200%基础法术攻击力的法术伤害"
	                }],
	                "require": {
	                    "books": "高级鱼跃卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 5,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级鱼跃卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "5秒内再次使用技能可以引爆鱼灵,范围内敌方同时获得冰冻和迟钝效果，3秒内无法移动、无法施法、无法使用轻功（解控技能也只能解除冰冻效果，无法解除迟钝效果）"
	                }],
	                "require": {
	                    "books": "初级鱼跃卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "引爆鱼灵造成的“冰冻”、“迟钝”效果时间延长1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "引爆鱼灵造成的“冰冻”、“迟钝”效果时间延长2秒"
	                }],
	                "require": {
	                    "books": "中级鱼跃卷一*灵",
	                    "preNum": 1,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "引爆鱼灵有8%概率造成的“深度冰冻”效果,不会被攻击后解除"
	                },
	                {
	                    "layer": 14,
	                    "value": "引爆鱼灵有16%概率造成的“深度冰冻”效果,不会被攻击后解除"
	                },
	                {
	                    "layer": 15,
	                    "value": "引爆鱼灵有25%概率造成的“深度冰冻”效果,不会被攻击后解除"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "在鱼跃范围内的敌人造成“偏斜”效果,命中率下降15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "在鱼跃范围内的敌人造成“偏斜”效果,命中率下降30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在鱼跃范围内的敌人造成“盲目”效果,技能射程降低30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在鱼跃范围内的敌人造成“盲目”效果,技能射程降低50%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "落樱",
	        "skillProperty": ["回复技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a11a6a7c-22ef-43c4-8cc3-51ca817d5968_1413",
	        "skillDescribe": {
	            "main": "治疗自身或友方单体，回复生命值",
	            "static": ["回复自身或友方单位大量生命值"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对处于“如沐春风”状态的目标造成的治疗效果提升3%*“如沐春风”层数"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对处于“如沐春风”状态的目标造成的治疗效果提升5%*“如沐春风”层数"
	                }],
	                "require": {
	                    "books": "中级落樱卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高40%"
	                }],
	                "require": {
	                    "books": "高级落樱卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有25%的概率额外增长1个灵气"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有50%的概率额外增长1个灵气"
	                }],
	                "require": {
	                    "books": "中级落樱卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "消耗2点灵气，提高20%的回复量"
	                },
	                {
	                    "layer": 14,
	                    "value": "消耗2点灵气，提高40%的回复量"
	                }],
	                "require": {
	                    "books": "高级落樱卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续4秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续5秒"
	                }],
	                "require": {
	                    "books": "初级落樱卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升30%"
	                }],
	                "require": {
	                    "books": "中级落樱卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能的吟唱时间降低0.5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能的吟唱时间降低1秒"
	                }],
	                "require": {
	                    "books": "高级落樱卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的射程增加3米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的射程增加5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "青蔓",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a17430c3-edba-4ddb-a205-f342f2a1ab97_1412",
	        "skillDescribe": {
	            "main": "治疗自身和周围队友，恢复生命值",
	            "static": ["同时恢复自身和队友的生命值", "可以扩散自身最多<em class='green'>1</em>层<em class='green'>如沐春风</em>状态给周围队友"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散3层"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散4层"
	                }],
	                "require": {
	                    "books": "中级青蔓卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
	                }],
	                "require": {
	                    "books": "高级青蔓卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能使用后自身的移动速度提高30%,持续3秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能使用后自身的移动速度提高40%,持续3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能使用后自身的移动速度提高50%,持续3秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能使用后立即恢复自身和周围队友10点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能使用后立即恢复自身和周围队友15点轻功值"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能使用后立即恢复自身和周围队友20点轻功值"
	                }],
	                "require": {
	                    "books": "中级青蔓卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "消耗2点灵气，提高20%的回复量"
	                },
	                {
	                    "layer": 14,
	                    "value": "消耗2点灵气，提高40%的回复量"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能使用后有50%概率立即驱散自身和周围队友1个负面状态"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能使用后有100%概率立即驱散自身和周围队友1个负面状态"
	                }],
	                "require": {
	                    "books": "初级青蔓卷二*灵",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "羽化",
	        "skillProperty": ["回复技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_02d9de50-e4ac-48b3-8b88-b5e5df38b028_1414",
	        "skillDescribe": {
	            "main": "复活友方单位并回复该单位部分生命值和法力值",
	            "static": ["复活一个友方死亡目标，回复10%生命值和5%法力值"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "降低10%羽化施法的法力值消耗"
	                },
	                {
	                    "layer": 4,
	                    "value": "降低20%羽化施法的法力值消耗"
	                },
	                {
	                    "layer": 5,
	                    "value": "降低30%羽化施法的法力值消耗"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "复活后的友方拥有的法力值额外增加5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "复活后的友方拥有的法力值额外增加10%"
	                },
	                {
	                    "layer": 10,
	                    "value": "复活后的友方拥有的法力值额外增加15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "复活后的友方拥有的生命上限额外增加5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "复活后的友方拥有的生命上限额外增加10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "复活后的友方拥有的生命上限额外增加15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "降低30%羽化*灵施法的法力值消耗"
	                },
	                {
	                    "layer": 4,
	                    "value": "降低50%羽化*灵施法的法力值消耗"
	                },
	                {
	                    "layer": 5,
	                    "value": "降低70%羽化*灵施法的法力值消耗"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "羽化的冷却时间缩短10秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "羽化的冷却时间缩短20秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "羽化的冷却时间缩短30秒"
	                }],
	                "require": {
	                    "books": "中级羽化卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "羽化的吟唱时间缩短0.5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "羽化的吟唱时间缩短1秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "羽化的吟唱时间缩短1.5秒"
	                }],
	                "require": {
	                    "books": "高级羽化卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "羽化的射程增加5米"
	                },
	                {
	                    "layer": 4,
	                    "value": "羽化的射程增加10米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "白露",
	        "skillProperty": ["回复技能", "引导技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_21f97f59-dd7c-476f-97bd-ea1d229bbc0d_1416",
	        "skillDescribe": {
	            "main": "<em class='green'>3</em>秒内持续恢复目标友方的生命值",
	            "static": ["每秒内恢复1次目标友方的生命值"],
	            "addition": [],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的治疗效果提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的治疗效果提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能可对除目标外周围10米内1个队友造成50%的回复效果"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能可对除目标外周围10米内2个队友造成50%的回复效果"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能可对除目标外周围10米内3个队友造成50%的回复效果"
	                }],
	                "require": {
	                    "books": "中级白露卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高2%,持续5秒,可叠加"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高4%,持续5秒,可叠加"
	                },
	                {
	                    "layer": 15,
	                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高6%,持续5秒,可叠加"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "每次引导消耗1点灵气，造成的治疗效果额外提高20%"
	                },
	                {
	                    "layer": 14,
	                    "value": "每次引导消耗1点灵气，造成的治疗效果额外提高40%"
	                }],
	                "require": {
	                    "books": "高级白露卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能施放期间,自身受到的伤害降低3%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能施放期间,自身受到的伤害降低6%"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能施放期间,自身受到的伤害降低9%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升30%"
	                }],
	                "require": {
	                    "books": "中级白露卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对其他友方使用此技能时，会同时对自己造成70%基础治疗能力的治疗效果"
	                },
	                {
	                    "layer": 14,
	                    "value": "对其他友方使用此技能时，会同时对自己造成140%基础治疗能力的治疗效果"
	                }],
	                "require": {
	                    "books": "高级白露卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的射程增加3米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的射程增加5米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "灵化",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d929d1cf-edb3-42fb-b02f-23dfd7b736a2_1404",
	        "skillDescribe": {
	            "main": "解除控制并进入灵化状态，持续<em class='green'>8</em>秒",
	            "static": ["灵化状态下可使用技能：<em class='green'>魅惑</em>：使周围<em class='green'>5</em>米范围内敌方进入<em class='green'>晕眩</em>状态，持续<em class='green'>3</em>秒；<em class='green'>灵冲</em>：吟唱<em class='green'>3</em>秒，对目标造成大量法术伤害", "灵化加速效果结束后，立即回复两系无双值各<em class='green'>10</em>点"],
	            "addition": [{
	                "initiative": "进入<em class='green'>灵化</em>状态",
	                "passivity": "灵化：免疫所有控制技能效果，受到伤害降低50%，移动速度提升50%"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高10%（灵解状态下无效）"
	                },
	                {
	                    "layer": 4,
	                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高30%（灵解状态下无效）"
	                },
	                {
	                    "layer": 5,
	                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高50%（灵解状态下无效）"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "灵化状态下，每2秒回复自身1.5%的生命值"
	                },
	                {
	                    "layer": 9,
	                    "value": "灵化状态下，每2秒回复自身3%的生命值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "灵化效果解除后,立即获得的两系无双值增加3点"
	                },
	                {
	                    "layer": 14,
	                    "value": "灵化效果解除后,立即获得的两系无双值增加6点"
	                },
	                {
	                    "layer": 15,
	                    "value": "灵化效果解除后,立即获得的两系无双值增加10点"
	                }],
	                "require": {
	                    "books": "高级灵化卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "灵化状态下,自身受到的伤害额外降低10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "灵化状态下,自身受到的伤害额外降低20%"
	                }],
	                "require": {
	                    "books": "高级灵化卷二*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "灵化的持续时间增加2秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "灵化的持续时间增加4秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "灵化的持续时间增加7秒"
	                }],
	                "require": {
	                    "books": "初级灵化卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级灵化卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“灵冲”技能造成的法术伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“灵冲”技能造成的法术伤害提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "“灵冲”技能造成的法术伤害提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "每次施放“灵冲”技能使自身获得1点巧语系无双值"
	                },
	                {
	                    "layer": 9,
	                    "value": "每次施放“灵冲”技能使自身获得3点巧语系无双值"
	                },
	                {
	                    "layer": 10,
	                    "value": "每次施放“灵冲”技能使自身获得5点巧语系无双值"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "“灵冲”技能可无视目标10%的法术防御"
	                },
	                {
	                    "layer": 14,
	                    "value": "“灵冲”技能可无视目标15%的法术防御"
	                },
	                {
	                    "layer": 15,
	                    "value": "“灵冲”技能可无视目标20%的法术防御"
	                }],
	                "require": {
	                    "books": "高级灵化卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "灵甲",
	        "skillProperty": ["辅助技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_43854627-9c01-43a1-ad88-be878538269a_1403",
	        "skillDescribe": {
	            "main": "给自身或友方单位附加一个可以吸收伤害的灵甲，驱散目标身上所有负面状态的效果",
	            "static": ["自身或者友方单位获得一个灵甲护盾，驱散目标身上所有负面状态的效果"],
	            "addition": [{
	                "initiative": "自身进入<em class='green'>灵甲</em>状态，最多持续<em class='green'>60</em>秒",
	                "passivity": "灵甲：吸收自身受到的伤害"
	            },
	            {
	                "initiative": "附加于自身的灵甲被击破后会使周围敌方<em class='green'>变形</em>，持续持续<em class='green'>3</em>秒",
	                "passivity": "变形：变成随机一类小动物，移动速度降低50%，无法使用轻功和技能"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "“灵甲”状态吸收的伤害提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "“灵甲”状态吸收的伤害提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "“灵甲”状态额外提高目标10%物理防御力"
	                },
	                {
	                    "layer": 9,
	                    "value": "“灵甲”状态额外提高目标20%物理防御力"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高20%"
	                },
	                {
	                    "layer": 15,
	                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能的最大射程提高3米"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能的最大射程提高6米"
	                },
	                {
	                    "layer": 5,
	                    "value": "本技能的最大射程提高10米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级灵甲卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "5秒内再次使用可以主动解除自身的“灵甲”状态,并施放“变形”效果"
	                }],
	                "require": {
	                    "books": "初级灵甲卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“变形”效果使目标的法术防御力降低10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“变形”效果使目标的法术防御力降低20%"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能造成的“变形”效果使目标的法术防御力降低30%"
	                }],
	                "require": {
	                    "preNum": 1,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能造成的“变形”效果的持续时间增加0.5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能造成的“变形”效果的持续时间增加1秒"
	                }],
	                "require": {
	                    "books": "高级灵甲卷一*灵",
	                    "preNum": 3,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "当自身的生命上限低于10%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "当自身的生命上限低于20%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "当自身的生命上限低于30%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
	                }],
	                "require": {
	                    "books": "中级灵甲卷二*灵",
	                    "preNum": 0,
	                    "totolNum": 1,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "芊心",
	        "skillProperty": ["回复技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9a51aa88-1a2c-45f3-bce8-d8bc6dd99b44_1415",
	        "skillDescribe": {
	            "main": "使自身和周围所有队友受到的治疗效果提升并免疫所有控制效果",
	            "static": ["提升自身和周围队友受到的治疗效果并免疫控制"],
	            "addition": [{
	                "initiative": "自身和队友获得<em class='green'>芊心</em>状态，持续<em class='green'>3</em>秒",
	                "passivity": "芊心：受到的治疗效果提升50%并免疫控制效果"
	            },
	            {
	                "initiative": "自身和队友获得<em class='green'>灵珑之心</em>状态，持续<em class='green'>1800</em>秒",
	                "passivity": "灵珑之心：每5秒回复一定的生命值和法力值"
	            }],
	            "trainingName": ["魂", "悟", "灵"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“灵珑之心”效果每秒回复的生命上限和法力值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“灵珑之心”效果每秒回复的生命上限和法力值提高20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能造成的“芊心”效果提升的治疗效果提高10%"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能造成的“芊心”效果提升的治疗效果提高20%"
	                }],
	                "require": {
	                    "books": "中级芊心卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能造成的“芊心”效果持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能造成的“芊心”效果持续时间增加2秒"
	                }],
	                "require": {
	                    "books": "高级芊心卷一*魂",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "芊心状态下，自身的法术攻击力和治疗能力提升5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "芊心状态下，自身的法术攻击力和治疗能力提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级芊心卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能造成的“芊心”效果使目标的轻功回复速度提高30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能造成的“芊心”效果使目标的轻功回复速度提高50%"
	                }],
	                "require": {
	                    "books": "初级虚空流转卷一*暗",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能有50%概率为自己和周围队友立即恢复一次等同与其身上所有“如沐春风”的剩余治疗量的生命上限"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能有100%概率为自己和周围队友立即恢复一次等同与其身上所有“如沐春风”的剩余治疗量的生命上限"
	                }],
	                "require": {
	                    "books": "中级芊心卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "本技能造成的“芊心”效果使目标的免爆率提高15%"
	                },
	                {
	                    "layer": 14,
	                    "value": "本技能造成的“芊心”效果使目标的免爆率提高30%"
	                }],
	                "require": {
	                    "books": "高级芊心卷一*灵",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    }],
	    "yecha": [{
	        "skillName": "刃刺",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_15da6653-2ee4-4616-9f0f-8ab3c221a853_1701",
	        "skillDescribe": {
	            "main": "对前方区域敌人造成少量伤害",
	            "static": ["自身处于毒刃状态下,则使目标一定中毒"],
	            "addition": [{
	                "initiative": "有<em class='green'>30%</em>概率使敌人受到<em class='green'>中毒</em>效果，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
	                "passivity": "5秒内每2秒受到10%物理伤害"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升4%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升8%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "每次命中敌人有10%概率使自己获得“极限”效果，持续3秒，最多可叠加2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "每次命中敌人有20%概率使自己获得“极限”效果，持续3秒，最多可叠加2层"
	                },
	                {
	                    "layer": 10,
	                    "value": "每次命中敌人有30%概率使自己获得“极限”效果，有5%概率打出最高伤害，持续3秒，最多可叠加2层"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "极限效果的持续时间增加1秒，层数增加1层"
	                },
	                {
	                    "layer": 14,
	                    "value": "极限效果的持续时间增加2秒，层数增加2层"
	                },
	                {
	                    "layer": 15,
	                    "value": "极限效果的持续时间增加3秒，层数增加3层"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "毒刃状态下对敌人造成的伤害提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "毒刃状态下对敌人造成的伤害提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使用此技能有1%概率使体内瞬间凝聚一枚血毒"
	                },
	                {
	                    "layer": 9,
	                    "value": "使用此技能有2%概率使体内瞬间凝聚一枚血毒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对有中毒的敌人会使其有10%的概率受到断筋效果，移动速度降低50%，持续2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "对有中毒的敌人会使其有10%的概率受到断筋效果，移动速度降低50%，持续2秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "链击",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3d326ec0-bc68-44d6-afa9-e6e352ecd357_1711",
	        "skillDescribe": {
	            "main": "对前方大范围内的敌人造成少量伤害，最多可攻击4次",
	            "static": ["自身处于<em class='green'>毒刃</em>状态下，则使目标一定中毒"],
	            "addition": [{
	                "initiative": "有<em class='green'>30%</em>概率使敌人受到<em class='green'>中毒</em>效果，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
	                "passivity": "5秒内每2秒受到10%物理伤害"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "链击4击内，每下一击的伤害提升5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "链击4击内，每下一击的伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 2,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "左系无双值增长0.7"
	                },
	                {
	                    "layer": 14,
	                    "value": "左系无双值增长1.4"
	                },
	                {
	                    "layer": 15,
	                    "value": "左系无双值增长2.1"
	                }],
	                "require": {
	                    "books": "高级链击卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的伤害额外提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的伤害额外提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "使用此技能有2%概率使体内瞬间凝聚一枚血毒"
	                },
	                {
	                    "layer": 4,
	                    "value": "使用此技能有4%概率使体内瞬间凝聚一枚血毒"
	                }],
	                "require": {
	                    "books": "初级链击卷一*业",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒刃状态下对敌人造成的伤害提升11%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒刃状态下对敌人造成的伤害提升22%"
	                }],
	                "require": {
	                    "books": "中级链击卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对有中毒的敌人会使其有30%的概率受到断筋效果，移动速度降低50%，持续2秒。"
	                },
	                {
	                    "layer": 14,
	                    "value": "对有中毒的敌人会使其有60%的概率受到断筋效果，移动速度降低50%，持续2秒。"
	                }],
	                "require": {
	                    "books": "高级链击卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "血刺",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a014e803-ce33-4d87-bd7d-052a0d6fca4a_1705",
	        "skillDescribe": {
	            "main": "对目标和前方直线的敌人造成大量伤害",
	            "static": ["在目标身后，伤害额外提升<em class='green'>20%</em>", "自身处于毒体状态下，技能伤害增加<em class='green'>20%</em>"],
	            "addition": [{
	                "initiative": "击中敌人可使自己获得<em class='green'>极限</em>效果，持续<em class='green'>3</em>秒，最多可叠加<em class='green'>2</em>层",
	                "passivity": "打出最高伤害的概率提高5%"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下技能伤害额外提高11%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下技能伤害额外提高22%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "在目标身后攻击的额外伤害增加15%"
	                },
	                {
	                    "layer": 14,
	                    "value": "在目标身后攻击的额外伤害增加30%"
	                },
	                {
	                    "layer": 15,
	                    "value": "在目标身后攻击的额外伤害增加45%"
	                }],
	                "require": {
	                    "books": "高级血刺卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提升7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提升15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对生命值高于70%的敌人必定造成最大物理攻击的伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "对生命值高于50%的敌人必定造成最大物理攻击的伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "对生命值高于30%的敌人必定造成最大物理攻击的伤害"
	                }],
	                "require": {
	                    "books": "高级血刺卷二*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "使用此技能有4%概率使体内瞬间凝聚一枚血毒"
	                },
	                {
	                    "layer": 4,
	                    "value": "使用此技能有8%概率使体内瞬间凝聚一枚血毒"
	                }],
	                "require": {
	                    "books": "初级血刺卷一*业",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成25%基础物理攻击力的伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成50%基础物理攻击力的伤害"
	                },
	                {
	                    "layer": 10,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成70%基础物理攻击力的伤害"
	                }],
	                "require": {
	                    "books": "中级血刺卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "提升10%的引爆中毒伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "提升30%的引爆中毒伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "提升50%的引爆中毒伤害"
	                }],
	                "require": {
	                    "books": "高级血刺卷一*业",
	                    "preNum": 3,
	                    "totolNum": 0,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "造成的伤害15%立即转化为自己的生命上限的血量，最多回复自身总血量5%的生命上限的血量"
	                },
	                {
	                    "layer": 14,
	                    "value": "造成的伤害30%立即转化为自己的生命上限的血量，最多回复自身总血量10%的生命上限的血量"
	                }],
	                "require": {
	                    "books": "高级血刺卷二*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }]]
	        }
	    },
	    {
	        "skillName": "毒体",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9943704e-16bc-4ca1-98fd-7b9b51336a5c_1716",
	        "skillDescribe": {
	            "main": "以蝎毒浸体，施放体内“血毒”，是自己进入“毒体”/“毒刃”状态，强化自身战力。掌握“悟死而生”后，体内可以凝聚血毒",
	            "static": ["释放毒体需要消耗<em class='green'>3</em>枚血毒", "释放毒刃需要消耗<em class='green'>1</em>枚血毒", "毒刃和毒体状态不可共存"],
	            "addition": [{
	                "initiative": "进入<em class='green'>毒体</em>状态，持续<em class='green'>10</em>秒",
	                "passivity": "自身最大物理攻击力增加，暴击力增加"
	            },
	            {
	                "initiative": "进入<em class='green'>毒刃</em>状态，持续<em class='green'>10</em>秒",
	                "passivity": "自身破魔力增加，并对中毒的目标伤害增加10%"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "毒体状态下，轻功回复速度增加每秒1.2点"
	                },
	                {
	                    "layer": 4,
	                    "value": "毒体状态下，轻功回复速度增加每秒2.4点"
	                },
	                {
	                    "layer": 5,
	                    "value": "毒体状态下，轻功回复速度增加每秒3.6点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下提升的暴击力额外增加15%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下提升的暴击力额外增加30%"
	                }],
	                "require": {
	                    "books": "中级浸毒卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "毒体状态下，自身受到的法术伤害降低4.5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "毒体状态下，自身受到的法术伤害降低9%"
	                },
	                {
	                    "layer": 15,
	                    "value": "毒体状态下，自身受到的法术伤害降低13.5%"
	                }],
	                "require": {
	                    "books": "高级浸毒卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}], [{},
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "中毒时间增加1秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "中毒时间增加3秒"
	                },
	                {
	                    "layer": 5,
	                    "value": "中毒时间增加5秒"
	                }],
	                "require": {
	                    "books": "初级浸毒卷一*业",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "中毒状态的最多可叠加层数增加2层"
	                },
	                {
	                    "layer": 9,
	                    "value": "中毒状态的最多可叠加层数增加4层"
	                },
	                {
	                    "layer": 10,
	                    "value": "中毒状态的最多可叠加层数增加6层"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "中毒状态下敌人有7%概率打出最小攻击的伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "中毒状态下敌人有14%概率打出最小攻击的伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "中毒状态下敌人有20%概率打出最小攻击的伤害"
	                }],
	                "require": {
	                    "books": "高级浸毒卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "毒刃状态提升的破魔力额外增加30%"
	                },
	                {
	                    "layer": 4,
	                    "value": "毒刃状态提升的破魔力额外增加60%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "额外消耗1个血毒，使毒刃的持续时间增加10秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "额外消耗1个血毒，使毒刃的持续时间增加20秒"
	                }],
	                "require": {
	                    "books": "高级浸毒卷二*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}]]
	        }
	    },
	    {
	        "skillName": "链袭",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_133e6133-7fa0-47db-adb7-4351a275d01b_1713",
	        "skillDescribe": {
	            "main": "召唤3具暗影分身，向前方劈砍长链，对前方区域内敌人造成大量物理伤害",
	            "static": ["自身处于<em class='green'>毒体</em>状态下，技能伤害增加<em class='green'>20%</em>"],
	            "addition": [],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "产生暴击后获得暴击提升状态，增加5%的暴击率，持续5秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "产生暴击后获得暴击提升状态，增加10%的暴击率，持续5秒"
	                }],
	                "require": {
	                    "books": "中级链袭卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "产生暴击后，额外增加左右两系无双值各2点"
	                },
	                {
	                    "layer": 14,
	                    "value": "产生暴击后，额外增加左右两系无双值各4点"
	                },
	                {
	                    "layer": 15,
	                    "value": "产生暴击后，额外增加左右两系无双值各6点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下，技能伤害提高11%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下，技能伤害提高22%"
	                }],
	                "require": {
	                    "books": "中级链袭卷二*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "降低链袭0.6秒的吟唱时间"
	                }],
	                "require": {
	                    "books": "高级链袭卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "使用此技能有8%概率使体内瞬间凝聚一枚血毒"
	                },
	                {
	                    "layer": 4,
	                    "value": "使用此技能有16%概率使体内瞬间凝聚一枚血毒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成25%基础物理攻击力的伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成50%基础物理攻击力的伤害"
	                },
	                {
	                    "layer": 9,
	                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成70%基础物理攻击力的伤害"
	                }],
	                "require": {
	                    "books": "中级链袭卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "提升10%的引爆中毒伤害"
	                },
	                {
	                    "layer": 14,
	                    "value": "提升30%的引爆中毒伤害"
	                },
	                {
	                    "layer": 15,
	                    "value": "提升50%的引爆中毒伤害"
	                }],
	                "require": {
	                    "books": "高级链袭卷一*业",
	                    "preNum": 0,
	                    "totolNum": 3,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "影杀",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6de54a5f-969b-4bd7-9315-c45b0bb571d7_1702",
	        "skillDescribe": {
	            "main": "举刀刺向目标，穿过敌人后移动至身后处并将其<em class='green'>击倒</em>",
	            "static": ["快速移动至目标身后<em class='green'>3</em>米处，并造成物理伤害", "隐身状态下使用此技能不会进入技能冷却", "自身处于<em class='green'>毒体状态下会使敌人减少<em class='green'>10</em>点轻功值"],
	            "addition": [{
	                "initiative": "使敌方被<em class='green'>击倒</em>，持续<em class='green'>3</em>秒",
	                "passivity": "无法移动、使用技能和轻功"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升14%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升28%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下，技能有30%几率造成破甲效果，降低15%物理防御力，持续4秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下，技能有60%几率造成破甲效果，降低15%物理防御力，持续4秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "毒体状态下，技能有100%几率造成破甲效果，降低15%物理防御力，持续4秒"
	                }],
	                "require": {
	                    "books": "中级影杀卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "破甲效果额外提升30%，持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "破甲效果额外提升30%，持续时间增加3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "破甲效果额外提升30%，持续时间增加5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的伤害额外提升21%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的伤害额外提升42%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升5%"
	                },
	                {
	                    "layer": 14,
	                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升10%"
	                },
	                {
	                    "layer": 15,
	                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升15%"
	                }],
	                "require": {
	                    "books": "高级影杀卷二*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使用此技能时无需吟唱"
	                }],
	                "require": {
	                    "books": "高级影杀卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能射程增加1米"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能射程增加2米"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能射程增加3米"
	                }],
	                "require": {
	                    "books": "初级影杀卷一*业",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下额外减少敌人8点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下额外减少敌人16点轻功值"
	                }],
	                "require": {
	                    "books": "中级影杀卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "对中毒状态下的敌人使用此技能，有40%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "对中毒状态下的敌人使用此技能，有70%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "对中毒状态下的敌人使用此技能，有100%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
	                }],
	                "require": {
	                    "books": "高级影杀卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "潜影",
	        "skillProperty": ["物理技能", "吟唱技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1f420f9b-7e75-4e63-abc5-3b406fbe45a5_1714",
	        "skillDescribe": {
	            "main": "化为暗影之体，使敌人无从发现",
	            "static": ["发动攻击或治疗并产生效果后，隐身状态会被解除", "战斗状态下无法使用", "潜影技能等级越高越不容易被发现，观察者的人物等级越低越不容易被发现，观察者与隐身单位的距离越远越不容易被发现"],
	            "addition": [{
	                "initiative": "使自己进入<em class='green'>隐身</em>状态",
	                "passivity": "使敌人无法看到自己，并吸收少量伤害，伤害吸收到达上限后状态提前解除"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "隐身状态下，自身的物理攻击力增加5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "隐身状态下，自身的物理攻击力增加10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "隐身状态下，自身的物理攻击力增加15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "隐身状态下，下一击的暴击概率增加7.5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "隐身状态下，下一击的暴击概率增加15%"
	                },
	                {
	                    "layer": 10,
	                    "value": "隐身状态下，下一击的暴击概率增加22.5%"
	                }],
	                "require": {
	                    "books": "中级潜影卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "隐身状态下，物理破防率增加7%"
	                },
	                {
	                    "layer": 14,
	                    "value": "隐身状态下，物理破防率增加14%"
	                },
	                {
	                    "layer": 15,
	                    "value": "隐身状态下，物理破防率增加21%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "隐身状态下，使用无双技能的无双值消耗减少5点"
	                },
	                {
	                    "layer": 4,
	                    "value": "隐身状态下，使用无双技能的无双值消耗减少12点"
	                },
	                {
	                    "layer": 5,
	                    "value": "隐身状态下，使用无双技能的无双值消耗减少20点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级潜影卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "隐身状态下，移动速度提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "隐身状态下，移动速度提升20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "隐身状态下，移动速度提升30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "隐身状态下，伤害吸收量提升25%"
	                },
	                {
	                    "layer": 9,
	                    "value": "隐身状态下，伤害吸收量提升50%"
	                },
	                {
	                    "layer": 10,
	                    "value": "隐身状态下，伤害吸收量提升75%"
	                }],
	                "require": {
	                    "books": "中级潜影卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "隐身状态下，受到伤害减免10%"
	                },
	                {
	                    "layer": 14,
	                    "value": "隐身状态下，受到伤害减免20%"
	                },
	                {
	                    "layer": 15,
	                    "value": "隐身状态下，受到伤害减免30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "链舞",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_38f6c673-8fad-49c6-9842-80cacd4e8cf1_1715",
	        "skillDescribe": {
	            "main": "极力向前挥舞链刃，对自身周围的敌人造成大量伤害",
	            "static": ["每<em class='green'>0.2</em>秒造成一次物理伤害", "自身处于<em class='green'>毒刃</em>状态下，则使目标一定中毒"],
	            "addition": [{
	                "initiative": "释放过程中自身霸体",
	                "passivity": "免疫晕眩、定身、减速等控制效果"
	            },
	            {
	                "initiative": "有<em class='green'>30%</em>概率使敌人受到中毒效果，持续<em class='green'>5</em>秒,最多可叠加<em class='green'>3</em>层",
	                "passivity": "5秒内每2秒受到10%的物理伤害"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升10%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续2秒"
	                },
	                {
	                    "layer": 10,
	                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续3秒"
	                }],
	                "require": {
	                    "books": "中级链舞卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使敌人获得破甲效果，物理和法术防御降低2%，最多可叠加4层，持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使敌人获得破甲效果，物理和法术防御降低4%，最多可叠加4层，持续5秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "使敌人获得破甲效果，物理和法术防御降低6%，最多可叠加4层，持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高15%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒刃状态下，造成伤害的10%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒刃状态下，造成伤害的20%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
	                },
	                {
	                    "layer": 10,
	                    "value": "毒刃状态下，造成伤害的30%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "每次攻击降低敌人20%移动速度，最多可叠加4层，持续2秒"
	                },
	                {
	                    "layer": 4,
	                    "value": "每次攻击降低敌人20%移动速度，最多可叠加4层，持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒刃状态下对敌人造成的伤害提升11%"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒刃状态下对敌人造成的伤害提升22%"
	                }],
	                "require": {
	                    "books": "中级链舞卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使敌人获得迟钝效果，无法使用轻功，持续2秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使敌人获得迟钝效果，无法使用轻功，持续4秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "使敌人获得迟钝效果，无法使用轻功，持续6秒"
	                }],
	                "require": {
	                    "books": "高级链舞卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "影袭",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5a924cfe-2a99-4b5f-85fb-293f00571dbf_1703",
	        "skillDescribe": {
	            "main": "化为疾影，瞬间冲向前方",
	            "static": ["对敌人造成少量物理伤害"],
	            "addition": [{
	                "initiative": "使周围敌人获得<em class='green'>定身</em>状态<em class='green'>1</em>秒",
	                "passivity": "无法移动"
	            },
	            {
	                "initiative": "毒体期间，会使敌人受到<em class='green'>麻痹</em>状态<em class='green'>3</em>秒",
	                "passivity": "移动速度降低50%，无法使用轻功"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升9%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升18%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使用此技能会减少旋刃1秒的冷却时间"
	                },
	                {
	                    "layer": 9,
	                    "value": "使用此技能会减少旋刃2秒的冷却时间"
	                }],
	                "require": {
	                    "books": "中级影袭卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "施放影袭时，自身获得1秒的霸体效果"
	                },
	                {
	                    "layer": 14,
	                    "value": "施放影袭时，自身获得2秒的霸体效果"
	                }],
	                "require": {
	                    "books": "高级影袭卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提升14%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提升28%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                }],
	                "require": {
	                    "books": "中级影袭卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "前冲距离增加1米"
	                },
	                {
	                    "layer": 4,
	                    "value": "前冲距离增加2米"
	                },
	                {
	                    "layer": 5,
	                    "value": "前冲距离增加3米"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "使中毒状态下的敌人的左右两系无双值减少1点"
	                },
	                {
	                    "layer": 9,
	                    "value": "使中毒状态下的敌人的左右两系无双值减少2点"
	                },
	                {
	                    "layer": 10,
	                    "value": "使中毒状态下的敌人的左右两系无双值减少3点"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降10%，持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降20%，持续5秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降30%，持续5秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "链缚",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_f9a41eb5-4a66-42e2-81cf-f917e2b37b61_1712",
	        "skillDescribe": {
	            "main": "向前方释出链刃，将前方敌人全部牵引至自身面前",
	            "static": ["自身处于<em class='green'>毒体</em>状态下，会使敌人减少<em class='green'>10</em>点轻功值"],
	            "addition": [{
	                "initiative": "被牵引的敌人获得<em class='green'>晕眩</em>状态<em class='green'>3</em>秒",
	                "passivity": "晕眩：无法移动、使用技能和轻功"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升9%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升18%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "本技能施放后，3秒内下一次使用吟唱技能时的吟唱时间降低0.3秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "本技能施放后，3秒内下一次使用吟唱技能时的吟唱时间降低0.6秒"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使敌人获得易伤效果，受到伤害提高5%，持续3秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使敌人获得易伤效果，受到伤害提高10%，持续3秒"
	                }],
	                "require": {
	                    "books": "高级链缚卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提升14%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提升28%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "50%的概率驱散对方一个正面状态"
	                },
	                {
	                    "layer": 4,
	                    "value": "100%的概率驱散对方一个正面状态"
	                }],
	                "require": {
	                    "books": "初级链缚卷一*业",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "毒体状态下额外减少敌人5点轻功值"
	                },
	                {
	                    "layer": 9,
	                    "value": "毒体状态下额外减少敌人10点轻功值"
	                }],
	                "require": {
	                    "books": "中级链缚卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "增加10的技能控制等级"
	                },
	                {
	                    "layer": 14,
	                    "value": "增加20的技能控制等级"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "旋刃",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_366dbe48-e00b-4135-b336-e3f58b8325d8_1704",
	        "skillDescribe": {
	            "main": "以刃护体，对周围敌人造成伤害并反噬敌人的攻击",
	            "static": ["每<em class='green'>0.5</em>秒造成一次物理伤害", "解除自身控制状态"],
	            "addition": [{
	                "initiative": "期间自身获得<em class='green'>旋刃</em>效果，持续<em class='green'>5</em>秒",
	                "passivity": "旋刃：自身的躲闪率提升30%，对给自己造成伤害的敌人反弹伤害"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能伤害提升15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能伤害提升30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "弹射的伤害提升25%"
	                },
	                {
	                    "layer": 9,
	                    "value": "弹射的伤害提升50%"
	                },
	                {
	                    "layer": 10,
	                    "value": "弹射的伤害提升75%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "技能持续时间增加1秒"
	                },
	                {
	                    "layer": 14,
	                    "value": "技能持续时间增加2秒"
	                },
	                {
	                    "layer": 15,
	                    "value": "技能持续时间增加3秒"
	                }],
	                "require": {
	                    "books": "高级旋刃卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "本技能对怪物造成的物理伤害额外提高22.5%"
	                },
	                {
	                    "layer": 4,
	                    "value": "本技能对怪物造成的物理伤害额外提高45%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级旋刃卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "额外增加技能5%的躲闪率"
	                },
	                {
	                    "layer": 4,
	                    "value": "额外增加技能10%的躲闪率"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "获得1秒的霸体状态"
	                },
	                {
	                    "layer": 9,
	                    "value": "获得2秒的霸体状态"
	                },
	                {
	                    "layer": 10,
	                    "value": "获得3秒的霸体状态"
	                }],
	                "require": {
	                    "books": "中级旋刃卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "旋刃期间，移动速度提升30%"
	                },
	                {
	                    "layer": 14,
	                    "value": "旋刃期间，移动速度提升60%"
	                },
	                {
	                    "layer": 15,
	                    "value": "旋刃期间，移动速度提升90%"
	                }],
	                "require": {
	                    "books": "高级旋刃卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "受到来自怪物的伤害减少15%"
	                },
	                {
	                    "layer": 4,
	                    "value": "受到来自怪物的伤害减少30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {},
	            {}]]
	        }
	    },
	    {
	        "skillName": "疾影",
	        "skillProperty": ["物理技能", "瞬发技能"],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_52323c38-5395-4836-bfee-72e428c2cbab_1706",
	        "skillDescribe": {
	            "main": "激发体内潜能，短时间内大幅提升自己的移动和攻击速度",
	            "static": ["解除自身控制状态", "降低大量仇恨值"],
	            "addition": [{
	                "initiative": "获得<em class='green'>疾影</em>状态，持续<em class='green'>10</em>秒",
	                "passivity": "疾影：提升自己的移动速度和刃刺、链击的攻击速度"
	            },
	            {
	                "initiative": "获得<em class='green'>霸体</em>状态，持续<em class='green'>3</em>秒",
	                "passivity": "霸体：免疫所有控制效果"
	            }],
	            "trainingName": ["刹", "悟", "业"],
	            "training": [[{
	                "effect": [{
	                    "layer": 3,
	                    "value": "移动速度额外提升10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "移动速度额外提升20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "移动速度额外提升30%"
	                }],
	                "require": {
	                    "books": "初级疾影卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "疾影状态下增加战斗内轻功回复速度每秒2点"
	                },
	                {
	                    "layer": 9,
	                    "value": "疾影状态下增加战斗内轻功回复速度每秒4点"
	                },
	                {
	                    "layer": 10,
	                    "value": "疾影状态下增加战斗内轻功回复速度每秒6点"
	                }],
	                "require": {
	                    "books": "中级疾影卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "降低自身7%的物理和法术防御力，增加7%的物理和法术攻击力"
	                },
	                {
	                    "layer": 14,
	                    "value": "降低自身14%的物理和法术防御力，增加14%的物理和法术攻击力"
	                },
	                {
	                    "layer": 14,
	                    "value": "降低自身20%的物理和法术防御力，增加20%的物理和法术攻击力"
	                }],
	                "require": {
	                    "books": "高级疾影卷一*刹",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "疾影状态下，对怪物的伤害提高20%"
	                },
	                {
	                    "layer": 9,
	                    "value": "疾影状态下，对怪物的伤害提高40%"
	                },
	                {
	                    "layer": 10,
	                    "value": "疾影状态下，对怪物的伤害提高60%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "技能获得无双值提高10%"
	                },
	                {
	                    "layer": 4,
	                    "value": "技能获得无双值提高20%"
	                },
	                {
	                    "layer": 5,
	                    "value": "技能获得无双值提高30%"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "技能冷却时间降低7%"
	                },
	                {
	                    "layer": 9,
	                    "value": "技能冷却时间降低14%"
	                },
	                {
	                    "layer": 10,
	                    "value": "技能冷却时间降低20%"
	                }],
	                "require": {
	                    "books": "中级疾影卷一*悟",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {}], [{
	                "effect": [{
	                    "layer": 3,
	                    "value": "疾影状态提升5%的躲闪率"
	                },
	                {
	                    "layer": 4,
	                    "value": "疾影状态提升10%的躲闪率"
	                },
	                {
	                    "layer": 5,
	                    "value": "疾影状态提升15%的躲闪率"
	                }],
	                "require": {
	                    "preNum": 0,
	                    "totolNum": 0,
	                    "line": "49"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 8,
	                    "value": "霸体持续时间增加1秒"
	                },
	                {
	                    "layer": 9,
	                    "value": "霸体持续时间增加2秒"
	                }],
	                "require": {
	                    "books": "中级疾影卷一*业",
	                    "preNum": 0,
	                    "totolNum": 2,
	                    "line": "59"
	                }
	            },
	            {
	                "effect": [{
	                    "layer": 13,
	                    "value": "使用技能后瞬间回复1枚血毒"
	                },
	                {
	                    "layer": 14,
	                    "value": "使用技能后瞬间回复2枚血毒"
	                }],
	                "require": {
	                    "books": "高级疾影卷一*业",
	                    "preNum": 0,
	                    "totolNum": 4,
	                    "line": "69"
	                }
	            }], [{},
	            {},
	            {}]]
	        }
	    }]
	};
	data.tianzhao = tianzhao
	data.shiyu = shiyu
	module.exports=data;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var tianzhao = [
	    {
	        "skillName": "月碎",
	        "skillProperty": [
	            "物理攻击",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1a9cbab4-9ffa-4e48-8601-0937045decff_1901",
	        "skillDescribe": {
	            "main": "对前方矩形范围的敌方造成少量伤害",
	            "static": [
	                "挥出剑气，对前方矩形范围的敌方造成少量伤害"
	            ],
	            "addition": [],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的物理伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的物理伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "所有技能造成的破绽效果可叠加3层，持续时间延长至9秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "所有技能造成的破绽效果可叠加4层，持续时间延长至12秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "所有技能造成的破绽效果可叠加5层，持续时间延长至15秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升7.5%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升15%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升22.5%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "使用月碎后额外增加0.5点左系无双和1点右系无双，触发间隔1秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "使用月碎后额外增加1点左系无双和2点右系无双，触发间隔1秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 5,
	                                "value": "月碎造成破绽效果的概率提升至40%"
	                            },
	                            {
	                                "layer": 6,
	                                "value": "月碎造成破绽效果的概率提升至60%"
	                            },
	                            {
	                                "layer": 7,
	                                "value": "月碎造成破绽效果的概率提升至80%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "“剑心”状态下，月碎暴击降低目标10%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身10%移速3秒，冷却5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "“剑心”状态下，月碎暴击降低目标20%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身20%移速3秒，冷却5秒"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "“剑心”状态下，月碎暴击降低目标30%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身30%移速3秒，冷却5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "月碎无视目标3%的物理防御；"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "月碎无视目标6%的物理防御；"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "月碎无视目标10%的物理防御；"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "月碎对12米范围内敌人造成伤害有3%概率造成击退2米效果，触发间隔2秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "月碎对12米范围内敌人造成伤害有6%概率造成击退2米效果，触发间隔2秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "月碎对12米范围内敌人造成伤害有10%概率造成击退2米效果，触发间隔2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "鳞追",
	        "skillProperty": [
	            "物理攻击",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1f3a2969-ea3f-4bcc-b80b-efbcf6cd537c_1902",
	        "skillDescribe": {
	            "main": "向自身前方划出3道龙鳞，靠近自身的敌人将受到至多3次伤害",
	            "static": [
	                "每道龙鳞有50%概率附加1层破绽状态"
	            ],
	            "addition": [
	                {
	                    "initiative": "每道龙鳞有50%概率附加1层破绽状态"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每道龙鳞伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每道龙鳞伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升13%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升26%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升39%"
	                            }
	                        ],
	                        "require": {
	                            "books": "中级麟追卷一*剑",
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每道龙鳞对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每道龙鳞对怪物造成伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "目标每被1道龙鳞命中，有11%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "目标每被1道龙鳞命中，有22%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "目标每被1道龙鳞命中，有33%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "目标每被1道龙鳞命中，有11%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "目标每被1道龙鳞命中，有22%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "目标每被1道龙鳞命中，有33%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "目标每被1道龙鳞命中，有11%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "目标每被1道龙鳞命中，有22%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "目标每被1道龙鳞命中，有33%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "剑·龙旋",
	        "skillProperty": [
	            "物理攻击",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8abb7f5f-57e2-4733-b087-b6407e6478f8_1904",
	        "skillDescribe": {
	            "main": "剑心形态下可用本技能：召唤地龙围绕自身游走并撞地炸裂，分别对0-7米敌人造成伤害",
	            "static": [
	                "地龙游走结束后地龙轰击地面，对0-7米的敌人造成物理伤害"
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的所有伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的所有伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "被龙旋一段命中的敌人，受到治疗效果降低7.5%，持续2秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "被龙旋一段命中的敌人，受到治疗效果降低15%，持续2秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "被龙旋一段命中的敌人，受到的伤害提高1.5%，持续5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "被龙旋一段命中的敌人，受到的伤害提高3%，持续5秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "被龙旋一段命中的敌人，受到的伤害提高5%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成的伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成的伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升20%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升40%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升60%，且额外附带2秒80%减速效果"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升20%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升40%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升60%，并附加1秒眩晕效果"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能对处于破绽状态的目标造成伤害额外提升13%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能对处于破绽状态的目标造成伤害额外提升26%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能对处于破绽状态的目标造成伤害额外提升39%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "剑·杀合",
	        "skillProperty": [
	            "物理技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1cd0a12f-11c1-4ce8-a955-25fa8636c986_1905",
	        "skillDescribe": {
	            "main": "剑心形态下可用本技能；将自身面前和身后各6*16米矩形范围内的敌人推开拉回，在距离自身8米处聚集，造成伤害和眩晕",
	            "static": [
	                "剑心形态下可用本技能；将自身面前和身后各6*16米矩形范围内的敌人推开拉回，在距离自身8米处聚集，造成伤害和眩晕"
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "被剑·杀合命中的敌人有100%概率被附加1层破绽效果"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能造成的伤害提升6%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能造成的伤害提升12%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升12%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升24%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升36%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能的控制等级提升5级"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能的控制等级提升10级"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "本技能的控制等级提升15级"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能冷却时间降低5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能冷却时间降低10%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降1%，持续5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降2%，持续5秒"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降3%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升2%，持续5秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升4%，持续5秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升6%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能的推拉效果可无视敌人的霸体状态（仍受控制等级影响）且不再对怪物生效，控制等级额外提升10级，但冷却时间提高3秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "剑·杀合使用后，自身立即后退8米，且移除推拉效果"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "凌突",
	        "skillProperty": [
	            "物理技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_58de7e28-0317-40a3-99af-fabd591052ad_1907",
	        "skillDescribe": {
	            "main": "启动凌突-闪避形态，使自身获得10%闪避率以应对下一次伤害，同时瞬移至锁定目标位置并造成伤害",
	            "static": [
	                "瞬间移动到目标面前，发动攻击造成物理伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "被凌突一斩命中的目标获得眩晕状态",
	                    "passivity": "眩晕：无法移动和使用技能、轻功"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "使用凌突一斩后5秒内自身控制等级提升2级"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "使用凌突一斩后5秒内自身控制等级提升4级"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "使用凌突一斩后5秒内自身控制等级提升6级"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免8%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免16%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免25%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的伤害对怪物额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的伤害对怪物额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "自身处于凌突闪避状态时，受到的下1次攻击使自身获得1层看破效果"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "自身处于凌突闪避状态时，受到的下1次攻击使自身获得2层看破效果"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "凌突一斩使自身增加1层看破，并提升0.5%物理伤害5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "凌突一斩使自身增加1层看破，并提升1%物理伤害5秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "凌突一斩将攻击的目标碎甲5秒，降低3%物理和法术防御"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "凌突一斩将攻击的目标碎甲5秒，降低6%物理和法术防御"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "凌突一斩将攻击的目标碎甲5秒，降低9%物理和法术防御"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "凌突一斩使用后5秒内，自身受到伤害后瞬间移动到攻击自己的目标面前，发动攻击造成本体技能20%的伤害"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "凌突一斩使用后5秒内，自身受到伤害后瞬间移动到攻击自己的目标面前，发动攻击造成本体技能20%的伤害，并将目标定身2秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "风裂",
	        "skillProperty": [
	            "物理技能",
	            "引导技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_df63e581-30e5-41c5-b493-04cd1d2fa7e9_1906",
	        "skillDescribe": {
	            "main": "召唤撕裂风暴环绕自身，半径10米范围内触碰到风裂的敌人会受到伤害并被减速；5秒内使用二斩可向25米内锁定目标进行攻击",
	            "static": [
	                "风裂环绕时每0.5秒对触碰到的敌人造成物理伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "触碰到环绕风裂的目标获得减速状态"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "剑心形态下：风裂环绕时造成的伤害提高10%；龙魂形态下：风裂环绕时附带的减速效果提升至50%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "剑心形态下：风裂环绕时造成的伤害提高20%；龙魂形态下：风裂环绕时附带的减速效果提升至60%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "剑心形态下：风裂环绕时造成的伤害提高30%；龙魂形态下：风裂环绕时附带的减速效果提升至70%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "剑心形态下：风裂环绕时有10%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升1.5%物理和法术防御"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "剑心形态下：风裂环绕时有20%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升3%物理和法术防御"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "剑心形态下：风裂环绕时有30%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升4.5%物理和法术防御"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成的伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成的伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "剑心形态下：风裂二斩伤害提升10%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续0.5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "剑心形态下：风裂二斩伤害提升20%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续1秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "剑心形态下：风裂二斩伤害提升30%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "使用风裂有100%概率立即获得1层看破效果"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "使用风裂有100%概率立即获得2层看破效果"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标1.5%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标1.5%物理法术伤害，持续3秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标3%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标3%物理法术伤害，持续3秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标4.5%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标4.5%物理法术伤害，持续3秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "剑心形态下：风裂环绕时提升自身1.5%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身1.5%物理法术伤害减免率"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "剑心形态下：风裂环绕时提升自身3%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身3%物理法术伤害减免率"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "剑心形态下：风裂环绕时提升自身4.5%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身4.5%物理法术伤害减免率"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "剑心和龙魂形态下：自身无双获取效率提升1.5%（可与其他增长效果叠加）"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "剑心和龙魂形态下：自身无双获取效率提升3%（可与其他增长效果叠加）"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至3%（每层破绽效果均受此提升）"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至4%（每层破绽效果均受此提升）"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至5%（每层破绽效果均受此提升）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "每次切换形态后，5秒内提升1%暴击率，并提升形态对应防御力1%（剑心形态法术防御，龙魂形态物理防御）"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "每次切换形态后，5秒内提升2%暴击率，并提升形态对应防御力2%（剑心形态法术防御，龙魂形态物理防御）"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "每次切换形态后，5秒内提升3%暴击率，并提升形态对应防御力3%（剑心形态法术防御，龙魂形态物理防御）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "化龙",
	        "skillProperty": [
	            "辅助技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9b7455b7-cf96-45ce-92ae-40dfdeec232f_1908",
	        "skillDescribe": {
	            "main": "使自己切换为<font color='#66CD00'>剑心</font>或者<font color='#66CD00'>龙魂</font>形态，并回复对应系无双值",
	            "static": [
	                "剑心形态下可使用技能剑·龙旋、剑·杀合、剑·如龙，龙魂形态下可使用技能龙·游世、龙·天返、龙·战甲"
	            ],
	            "addition": [
	                {
	                    "initiative": "切换为剑心形态，自己造成的技能伤害变为物理伤害，提升法术防御，并回复左系无双值；切换为龙魂形态，自己造成的技能伤害变为法术伤害，提升物理防御，并回复右系无双值"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "剑心和龙魂形态下：自身无双获取效率提升1.5%（可与其他增长效果叠加）"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "剑心和龙魂形态下：自身无双获取效率提升3%（可与其他增长效果叠加）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至3%（每层破绽效果均受此提升）"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至4%（每层破绽效果均受此提升）"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至5%（每层破绽效果均受此提升）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "每次切换形态后，5秒内提升1%暴击率，并提升形态对应防御力1%（剑心形态法术防御，龙魂形态物理防御）"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "每次切换形态后，5秒内提升2%暴击率，并提升形态对应防御力2%（剑心形态法术防御，龙魂形态物理防御）"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "每次切换形态后，5秒内提升3%暴击率，并提升形态对应防御力3%（剑心形态法术防御，龙魂形态物理防御）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "剑心和龙魂形态下：自身物理伤害提升30点"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "剑心和龙魂形态下：自身物理伤害提升60点"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "剑心和龙魂形态下：自身物理伤害提升90点"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "剑心和龙魂形态下，自身暴击力提高60点"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "剑心和龙魂形态下，自身暴击力提高120点"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "剑心和龙魂形态下，自身暴击力提高180点"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 1,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "化龙技能在被控状态下可以使用"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升3%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升6%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 1,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "龙·游世",
	        "skillProperty": [
	            "物理技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3c688925-98eb-4eed-80c1-a6a5ea8c17fc_1903",
	        "skillDescribe": {
	            "main": "<font color='#66CD00'>龙魂</font>形态下可用本技能：召唤二条龙弧线移动，对路径上的敌方造成伤害",
	            "static": [
	                "每条游龙对路径上的敌人造成物理伤害和眩晕效果，二条游龙会在12米处交汇，对交汇处敌人造成2次伤害"
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每条游龙伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每条游龙伤害提升10%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升10%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升20%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "游龙对交汇处的敌人造成伤害额外提升12%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "游龙对交汇处的敌人造成伤害额外提升24%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "游龙对交汇处的敌人造成伤害额外提升36%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每条游龙对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每条游龙对怪物造成伤害额外提高15%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "游龙立即驱散被命中的敌人1个（1层）正面状态"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "游龙立即驱散被命中的敌人2个（各2层）正面状态"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "游龙立即驱散被命中的敌人3个（各2层）正面状态"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "每驱散1个敌方正面状态自身立即获得100点暴击力5秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "每驱散1个敌方正面状态自身立即获得200点暴击力5秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "每驱散1个敌方正面状态自身立即获得300点暴击力5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "标记交叉处被眩晕的敌人，若4秒内未能离开交叉点10米，则会被立即拉回至交叉处"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "标记交叉处被眩晕的敌人，若3秒内未能离开交叉点10米，则会被立即拉回至交叉处"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "标记交叉处被眩晕的敌人，若2秒内未能离开交叉点10米，则会被立即拉回至交叉处，并被驱散1个（1层）正面状态"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "龙·天返",
	        "skillProperty": [
	            "物理技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3d3dce13-f4c5-4fc5-9416-ec950864a6a0_1909",
	        "skillDescribe": {
	            "main": "龙魂</font>形态下可用本技能；将前方扇形范围内敌方拉回点并击晕，同时自身向后移动；二斩拔剑对前方矩形范围造成伤害",
	            "static": [
	                "向前方12米扇形范围施展攻击，造成物理伤害将范围内敌方拉回至攻击中心点并眩晕；施展同时自身向后移动12米"
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的所有伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的所有伤害提升10%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升1%，持续5秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升2%，持续5秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升3%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "天返一斩造成的眩晕效果额外增加0.5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "天返一斩造成的眩晕效果额外增加1秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高15%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能的推拉效果控制等级额外提升5级"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能的推拉效果控制等级额外提升10级"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能的推拉效果控制等级额外提升15级，可无视敌人的霸体状态（仍受控制等级影响）且不再对怪物生效，但冷却时间提高6秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "天返二斩可在被控状态下使用"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低5%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低10%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "龙·天返二斩伤害额外提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "龙·天返二斩伤害额外提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "龙·天返二斩伤害额外提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "龙·天返二斩无视敌方10%法术防御"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "龙·天返二斩无视敌方20%法术防御"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "龙·天返二斩无视敌方30%法术防御"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "龙·天返二斩造成伤害结算时额外附加200点暴击力"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "龙·天返二斩造成伤害结算时额外附加400点暴击力"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "龙·天返二斩造成伤害结算时额外附加600点暴击力"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "英域",
	        "skillProperty": [
	            "物理技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_05ed5bef-a046-460b-867c-61e0cc72d24a_1910",
	        "skillDescribe": {
	            "main": "在原地召唤一个半径15米的英域，英域内自身和友方战斗能力得到强化，敌方受到治疗效果降低",
	            "static": [
	                "英域持续5秒"
	            ],
	            "addition": [
	                {
	                    "initiative": "英域内的友方和英灵持续获得英域-激发状态"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "英域内己方无双增长速度提高3%（同类效果无法共存）"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "英域内己方无双增长速度提高6%（同类效果无法共存）"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "英域内己方无双增长速度提高9%（同类效果无法共存）"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升0.3%普技加深率，可叠加3层，持续6秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升0.6%普技加深率，可叠加3层，持续6秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升1%普技加深率，可叠加3层，持续6秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "英域持续时间延长0.5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "英域持续时间延长1秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "英域持续时间延长1.5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "英域内己方英灵攻击额外提高4.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "英域内己方英灵攻击额外提高9%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低1.5%物法防，可叠加3层，持续6秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低3%物法防，可叠加3层，持续6秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低4.5%物法防，可叠加3层，持续6秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能使用后自身立即获得1层看破状态，且英域内敌人每2秒有50%概率被施加1层破绽效果"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能使用后自身立即获得2层看破状态，且英域内敌人每2秒有100%概率被施加1层破绽效果"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "英域内敌人获得“偏斜”效果，命中率下降6%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "英域内敌人获得“偏斜”效果，命中率下降12%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓10%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓20%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "剑·如龙",
	        "skillProperty": [
	            "辅助技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_f57c01a6-d7d4-400c-9467-5145948b17c1_1911",
	        "skillDescribe": {
	            "main": "剑心形态下可用本技能；龙影伴身，解除控制并进入霸体状态，提升移动速度；使用本技能后降低大量仇恨值",
	            "static": [
	                "解除控制并进入如龙-霸体状态，提升移动速度"
	            ],
	            "addition": [],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "如龙状态期间自身被暴击立即获得5%伤害减免效果3秒，触发间隔5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "如龙状态期间自身被暴击立即获得10%伤害减免效果3秒，触发间隔5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "如龙状态持续时间增加0.5秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "如龙状态持续时间增加1秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "如龙状态期间自身造成暴击概率提高5%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "如龙状态期间自身造成暴击概率提高10%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "如龙状态期间自身造成暴击概率提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "使用剑·如龙后，10秒内对怪物造成伤害提高5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "使用剑·如龙后，10秒内对怪物造成伤害提高10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "如龙状态持续期间自身移动速度提升20%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "如龙状态持续期间自身移动速度提升40%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "如龙状态期间自身受到的治疗效果提升6%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "如龙状态期间自身受到的治疗效果提升12%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "如龙状态期间自身受到的治疗效果提升18%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "如龙状态期间，自身造成暴击可立即回复2点左系和右系无双值，触发间隔1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "如龙状态期间，自身造成暴击可立即回复4点左系和右系无双值，触发间隔1秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "如龙状态期间，自身造成暴击可立即回复6点左系和右系无双值，触发间隔1秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "龙·战甲",
	        "skillProperty": [
	            "辅助技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_93ec6465-dc6e-47d5-b722-d1efa9f3e247_1912",
	        "skillDescribe": {
	            "main": "龙魂形态下可用本技能；解除控制并进入霸体状态，对自身施放战甲并获得护盾，战甲期间造成伤害可以持续获得护盾",
	            "static": [
	                "解除控制并进入霸体-战甲状态，持续0.5秒"
	            ],
	            "addition": [
	                {
	                    "initiative": "立即获得战甲-护盾状态：根据自身平均物理伤害获得护盾"
	                }
	            ],
	            "trainingName": [
	                "剑",
	                "悟",
	                "龙"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高5%，且战甲期间自身造成伤害转换护盾的比例提高2%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高10%，且战甲期间自身造成伤害转换护盾的比例提高4%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高15%，且战甲期间自身造成伤害转换护盾的比例提高6%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "战甲持续时间增加0.5秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "战甲持续时间增加1秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "战甲持续时间增加1.5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "战甲期间自身获得6%吸血效果"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "战甲期间自身获得12%吸血效果"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "战甲期间自身获得20%吸血效果"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "战甲使用后霸体时间延长0.5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "战甲使用后霸体时间延长1.5秒"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "战甲使用后霸体时间延长2.5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免3%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免6%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "战甲期间自身暴击伤害减免率提高6%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "战甲期间自身暴击伤害减免率提高12%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "战甲期间自身暴击伤害减免率提高18%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    }
	]
	module.exports=tianzhao;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	var shiyu = [
	    {
	        "skillName": "翎击",
	        "skillProperty": [
	            "法术攻击",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d481cadb-224f-4436-a395-828f916efd8c_2110",
	        "skillDescribe": {
	            "main": "对前方扇形区域的敌方造成伤害，并有一定概率附加羽落效果",
	            "static": [
	                "造成法术伤害，最后一击可造成双倍伤害"
	            ],
	            "addition": [],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高4%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高8%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "技能造成的“羽落”状态最多可叠加4层"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "技能造成的“羽落”状态最多可叠加5层"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 5,
	                                "value": "“羽落”状态的持续时间提高1秒"
	                            },
	                            {
	                                "layer": 6,
	                                "value": "“羽落”状态的持续时间提高2秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每次命中敌方扣除敌人2点轻功值"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每次命中敌方扣除敌人4点轻功值"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "每次命中敌方扣除敌人6点轻功值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "每次命中敌方，使敌人降低3%的躲闪率"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "每次命中敌方，使敌人降低6%的躲闪率"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "每次命中敌方，使敌人降低9%的躲闪率"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能每次命中敌人，有5%的概率使“华绽天羽”技能的冷却时间降低1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能每次命中敌人，有10%的概率使“华绽天羽”技能的冷却时间降低1秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能每次命中敌人，有15%的概率使“华绽天羽”技能的冷却时间降低1秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "天狩光轮",
	        "skillProperty": [
	            "魔法攻击",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_4bf964e5-fff1-4ab8-bb6a-ecf6c7a1c3db_2114",
	        "skillDescribe": {
	            "main": "向目标扔出一颗光球，光球触碰到敌方会对产生爆炸，对周围敌方造成伤害",
	            "static": [
	                "光球爆炸后对周围所有敌方造成法术伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "为敌人附加<font color='#66CD00'>羽落</font>状态，最多可叠加3层"
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "光球爆炸时命中人数少于3人，额外造成10%的伤害"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "光球爆炸时命中人数少于3人，额外造成20%的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "光球的移动速度提高50%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "光球的移动速度提高100%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能命中敌方后，对敌人造成“偏斜”效果，命中率下降10%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能命中敌方后，对敌人造成“偏斜”效果，命中率下降20%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能命中敌方后，使敌人攻击力下降3%（可以被驱散），持续2秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能命中敌方后，使敌人攻击力下降6%（可以被驱散），持续2秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能命中敌方后，使敌人攻击力下降10%（可以被驱散），持续2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能命中“羽落”状态下的目标时，有40%概率使敌人定身1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能命中“羽落”状态下的目标时，有100%概率使敌人定身1秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "破冥",
	        "skillProperty": [
	            "法术攻击",
	            "引导技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0e76ab26-1699-44b9-8d69-28d3d16b0de1_2115",
	        "skillDescribe": {
	            "main": "持续对前方敌人造成伤害",
	            "static": [
	                "2秒内每0.5秒对敌方造成造成法术伤害，最后一次结算使自身获得一层羽辉状态"
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的所有伤害提升5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的所有伤害提升10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对眩晕状态敌人造成伤害提高17%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对眩晕状态敌人造成伤害提高34%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对眩晕状态敌人造成伤害提高51%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高23%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高45%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高67%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成的伤害额外提高7.5%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成的伤害额外提高15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "破冥结算间隔变为0.25秒一次，持续时间降为1秒（习得高级破冥卷二·羽后失效）"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "破冥可以在移动过程中释放"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "破冥可以在移动过程中释放且在破冥释放期间，自身移动速度提高50%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "破冥释放期间，自身物理防御力和法术防御力提升3%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "破冥释放期间，自身物理防御力和法术防御力提升6%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "破冥释放期间，自身物理防御力和法术防御力提升9%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "破冥释放期间，受到的伤害降低6%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "破冥释放期间，受到的伤害降低12%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "破冥每次命中“羽落”状态下的目标时，有10%概率使敌人眩晕2秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "破冥每次命中“羽落”状态下的目标时，有20%概率使敌人眩晕2秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "破冥的持续时间增加1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "破冥的持续时间增加2秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "破冥的持续时间增加3秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "锁厄",
	        "skillProperty": [
	            "法术技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9b02c274-c27b-437e-a34f-6dc8ecdbcc09_2116",
	        "skillDescribe": {
	            "main": "将前方扇形区域的敌方拉至身前并造成伤害和控制效果",
	            "static": [
	                "造成的法术伤害，拉至身边并造成眩晕效果"
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高9%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高18%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "使敌人获得易伤效果（不可被驱散），受到伤害提高5%，持续3秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "使敌人获得易伤效果（不可被驱散），受到伤害提高10%，持续3秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高14%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高28%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成“眩晕”效果的持续时间提高0.5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成“眩晕”效果的持续时间提高1秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能命中会降低敌人10点轻功值"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能命中会降低敌人20点轻功值"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能的控制等级提高10"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能的控制等级提高20"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "50%的概率驱散对方1个（1层）正面状态"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "100%的概率驱散对方1个（1层）正面状态"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能成功驱散目标状态后，增加自身800×驱散状态层数的物理/法术防御力，持续5秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "鸿裁",
	        "skillProperty": [
	            "法术技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a647a59e-485e-4e89-a16d-1fd08a879c6c_2117",
	        "skillDescribe": {
	            "main": "将光元素之力融入剑矛，跃起至指定位置并将剑矛插入地面引发冲击波，<font color='#66CD00'>眩晕</font>范围内敌方并造成伤害",
	            "static": [
	                "瞬间移动到目标面前，发动攻击造成法术伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "释放后获得一层<font color='#66CD00'>羽辉</font>状态",
	                    "passivity": "羽辉：提升移动速度"
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高25%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高50%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能的最远射程提高1米"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能的最远射程提高3米"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能的最远射程提高5米"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低4%，持续3秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低8%，持续3秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低12%，持续3秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能造成的伤害能够无视敌方10%的法术防御"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能造成的伤害能够无视敌方20%的法术防御"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能造成的伤害能够无视敌方30%的法术防御"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能造成的“眩晕”效果持续时间增加0.5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能造成的“眩晕”效果持续时间增加1秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能释放后，自身获得“霸体”状态，持续1秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能释放后，自身获得“霸体”状态，持续2秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能释放后，自身获得10%伤害减免，持续3秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能释放后，自身获得20%伤害减免，持续3秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能的控制等级额外提升5级"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能的控制等级额外提升10级"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "本技能的控制等级额外提升15级"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "旋枪",
	        "skillProperty": [
	            "法术技能",
	            "引导技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_652f0272-cb56-4030-8feb-dc2b82bee0d5_2118",
	        "skillDescribe": {
	            "main": "挥舞剑矛对周围敌人造成伤害和击倒效果",
	            "static": [
	                "每次结算造成击倒效果"
	            ],
	            "addition": [
	                {
	                    "initiative": "使自身进入风旋刃状态"
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高9%%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高18%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能释放后，有30%概率获得一层“羽辉”状态"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能释放后，有70%概率获得一层“羽辉”状态"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能释放后，有100%概率获得一层“羽辉”状态"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能命中敌方时产生的击倒状态持续时间提高0.5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能命中敌方时产生的击倒状态持续时间提高1秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高14%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高28%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "释放过程中，可以反弹来自角色和英灵的负面技能效果和50%伤害，但冷却时间提高5秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能释放后，立即获得6点左系无双值"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能释放后，立即获得12点左系无双值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能释放过程中，自身伤害减免提高10%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能释放过程中，自身伤害减免提高20%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能可在被控状态下使用，但冷却时间提高5秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能释放后，获得回血状态，每2秒回复自身最大生命值的2%，持续6秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能释放后，获得回血状态，每2秒回复自身最大生命值的4%，持续6秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "裂穹决",
	        "skillProperty": [
	            "法术技能",
	            "引导技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b10b3edb-db04-4b13-a3eb-18b671443170_2119",
	        "skillDescribe": {
	            "main": "划出三道剑光，对敌人造成大量伤害",
	            "static": [
	                "每道剑光会对被命中的敌方造成的法术伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "释放后获得一层羽辉状态"
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高9%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高18%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能造成的法术伤害可忽视敌人8%的法术防御力"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能造成的法术伤害可忽视敌人16%的法术防御力"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能造成的法术伤害可忽视敌人25%的法术防御力"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高20%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高30%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高40%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高14%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高28%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对眩晕状态敌人造成伤害提高17%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对眩晕状态敌人造成伤害提高34%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对眩晕状态敌人造成伤害提高51%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高30%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高60%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高100%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能的吟唱时间缩短0.5秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低6%，持续3秒，最多可叠加3层"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低12%，持续3秒，最多可叠加3层"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低20%，持续3秒，最多可叠加3层"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "每道剑光有20%概率使敌人眩晕，持续2秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "每道剑光有30%概率使敌人眩晕，持续2秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "每道剑光有40%概率使敌人眩晕，持续2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 1,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低2%，持续3秒，最多可叠加3层"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低4%，持续3秒，最多可叠加3层"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低6%，持续3秒，最多可叠加3层"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "华绽天羽",
	        "skillProperty": [
	            "辅助技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d1319633-72a4-4b37-ae47-330f534ec2c8_2121",
	        "skillDescribe": {
	            "main": "誓羽将翼环化为双翼，升空并开始飞行",
	            "static": [
	                "升空12米，并进入华绽天羽状态"
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "华绽天羽状态下暴击率提高3%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "华绽天羽状态下暴击率提高6%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "华绽天羽状态下暴击率提高10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "华绽天羽状态下法术破防率提高3%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "华绽天羽状态下法术破防率提高6%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "华绽天羽状态下法术破防率提高10%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "华绽天羽状态下，获得基础最大法术攻击6%的基础最小法术攻击"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "华绽天羽状态下，获得基础最大法术攻击12%的基础最小法术攻击"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 6,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高20%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高40%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高60%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高6%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高12%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高4%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高8%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高12%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "华绽天羽状态下每两秒回复右系无双值4点"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "华绽天羽状态下每两秒回复右系无双值8点"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "光影瞬袭的最远射程提高1米"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "光影瞬袭的最远射程提高3米"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "光影瞬袭的最远射程提高5米"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "释放光影瞬袭后，获得1秒霸体状态"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "释放光影瞬袭后，获得2秒霸体状态"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "同光凭神",
	        "skillProperty": [
	            "辅助技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bfee8210-8b68-4f93-9d4f-0a255f009dbf_2124",
	        "skillDescribe": {
	            "main": "自身被圣光之力笼罩，进入同光凭神状态",
	            "static": [
	                "解除控制，清除自身大量仇恨值并进入同光凭神状态，状态持续期间不会受到任何伤害和控制，同时无法释放无双技能"
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "同光凭神状态解除后，获得1秒霸体"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "同光凭神状态解除后，获得2秒霸体"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 3,
	                            "totolNum": 3,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "同光凭神状态持续时间提高1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "同光凭神状态持续时间提高2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 2,
	                            "totolNum": 5,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "同光凭神状态下，自身移动速度提高15%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "同光凭神状态下，自身移动速度提高30%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "同光凭神状态下，自身移动速度提高50%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低10%，持续5秒"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低20%，持续5秒"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低30%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "同光凭神状态持续期间，自身每2秒回复4点左系无双值"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "同光凭神状态持续期间，自身每2秒回复8点左系无双值"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "同光凭神状态持续期间，自身每2秒回复12点左系无双值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "同光凭神状态解除时，自身周围10米敌人获得“盲目”，技能射程降低50%，持续5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "同光凭神状态解除时，自身周围15米敌人获得“盲目”，技能射程降低50%，持续5秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "同光凭神状态解除时，自身周围20米敌人获得“盲目”，技能射程降低50%，持续5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "镇光囚笼",
	        "skillProperty": [
	            "法术技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b66a048e-4944-4b71-a1f9-86037ed3b73c_2125",
	        "skillDescribe": {
	            "main": "掷出一柄光矛，造成伤害并使被命中的敌人无法离开光矛形成的光元素区域",
	            "static": [
	                "造成法术伤害，对怪物额外造成50%伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": "使敌方玩家获得囚光状态"
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高9%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高18%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "镇光囚笼范围内敌方法术防御力降低5%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "镇光囚笼范围内敌方法术防御力降低10%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "镇光囚笼范围内敌方法术防御力降低15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "镇光囚笼的持续时间延长0.5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "镇光囚笼的持续时间延长1秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "镇光囚笼的持续时间延长1.5秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高14%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高28%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高30%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高50%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高80%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "镇光囚笼范围内的敌方每1秒减少0.5点左右系无双值"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "镇光囚笼范围内的敌方每1秒减少1点左右系无双值"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "镇光囚笼范围内的敌方每1秒减少1.5点左右系无双值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "镇光囚笼范围内的敌方受到“虚弱”效果，无双增长速度降低15%（同类效果无法共存）"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "镇光囚笼范围内的敌方受到“虚弱”效果，无双增长速度降低30%（同类效果无法共存）"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低15%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低30%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低45%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "镇光囚笼范围内的敌方反控等级降低10点"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "镇光囚笼范围内的敌方反控等级降低20点"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "镇光囚笼范围内的敌方造成伤害降低4%"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "镇光囚笼范围内的敌方造成伤害降低9%"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "镇光囚笼范围内的敌方造成伤害降低15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "澄空掠影",
	        "skillProperty": [
	            "位移技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_38fbeb2e-62c7-482d-9285-b477d1e4d34a_2127",
	        "skillDescribe": {
	            "main": "解除控制，并向前方位移一段距离",
	            "static": [
	                "接触控制，向前方瞬移15米"
	            ],
	            "addition": [],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能释放后，3秒内自身受到的物理伤害降低8%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能释放后，3秒内自身受到的物理伤害降低15%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收3%生命上限的伤害"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收6%生命上限的伤害"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收9%生命上限的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "技能释放后，立刻增加5点右系无双值"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "技能释放后，立刻增加10点右系无双值"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "技能释放后，立刻增加15点右系无双值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能不再对自身产生位移效果"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能释放后，3秒内移动速度提高20%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能释放后，3秒内移动速度提高50%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能移动距离提高5米(影响移动距离的效果只能生效一种)"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能移动距离提高10米(影响移动距离的效果只能生效一种)"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "技能释放后,自身获得“惊鸿掠影”效果,持续霸体且无法被锁定,持续1秒"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {},
	                    {},
	                    {}
	                ]
	            ]
	        }
	    },
	    {
	        "skillName": "翎羽绝阵",
	        "skillProperty": [
	            "法术技能",
	            "瞬发技能"
	        ],
	        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ab70bb75-1634-4178-8931-3832eb70e92c_2129",
	        "skillDescribe": {
	            "main": "降下羽雨对指定区域造成持续伤害",
	            "static": [
	                "每秒对范围内敌方造成法术伤害"
	            ],
	            "addition": [
	                {
	                    "initiative": ""
	                }
	            ],
	            "trainingName": [
	                "凛",
	                "悟",
	                "羽"
	            ],
	            "training": [
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能伤害提高9%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能伤害提高18%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "翎羽绝阵的结算间隔变为0.5秒一次，持续时间降低50%（习得后高级翎羽绝阵卷一·羽失效）"
	                            },
	                            {},
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "本技能对怪物造成伤害额外提高14%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "本技能对怪物造成伤害额外提高28%"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {},
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "技能获得无双值提高10%"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "技能获得无双值提高20%"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "技能获得无双值提高30%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "技能冷却时间降低7%"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "技能冷却时间降低14%"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "技能冷却时间降低20%"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {}
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "翎羽绝阵每次结算会扣除敌方2点轻功值"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "翎羽绝阵每次结算会扣除敌方4点轻功值"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "翎羽绝阵每次结算会扣除敌方6点轻功值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "本技能每次结算有30%概率使敌人进入“羽落”状态"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "本技能每次结算有60%概率使敌人进入“羽落”状态"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "本技能每次结算有100%概率使敌人进入“羽落”状态"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "翎羽绝阵的持续时间增加1秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "翎羽绝阵的持续时间增加2秒"
	                            },
	                            {
	                                "layer": 15,
	                                "value": "翎羽绝阵的持续时间增加3秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ],
	                [
	                    {
	                        "effect": [
	                            {
	                                "layer": 3,
	                                "value": "翎羽绝阵每次结算会扣除敌方1点左右系无双值"
	                            },
	                            {
	                                "layer": 4,
	                                "value": "翎羽绝阵每次结算会扣除敌方2点左右系无双值"
	                            },
	                            {
	                                "layer": 5,
	                                "value": "翎羽绝阵每次结算会扣除敌方3点左右系无双值"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 0,
	                            "line": "49"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 8,
	                                "value": "翎羽绝阵每次结算有30%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
	                            },
	                            {
	                                "layer": 9,
	                                "value": "翎羽绝阵每次结算有60%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
	                            },
	                            {
	                                "layer": 10,
	                                "value": "翎羽绝阵每次结算有100%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
	                            }
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 2,
	                            "line": "59"
	                        }
	                    },
	                    {
	                        "effect": [
	                            {
	                                "layer": 13,
	                                "value": "本技能每次结算有25%概率随机封印敌方1个技能，持续5秒"
	                            },
	                            {
	                                "layer": 14,
	                                "value": "本技能每次结算有50%概率随机封印敌方1个技能，持续5秒"
	                            },
	                            {}
	                        ],
	                        "require": {
	                            "preNum": 0,
	                            "totolNum": 4,
	                            "line": "69"
	                        }
	                    }
	                ]
	            ]
	        }
	    }
	]
	for(var i = 0; i< shiyu.length; i++) {
	    console.log(shiyu[i].skillName)
	}
	module.exports=shiyu;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var iconData = __webpack_require__(8);
	var skillData = __webpack_require__(9);
	var skillIconUrl = {
		init:function(){
	
		},
		getUrl:function(skillStr){		
			for(var i=0;i<skillData.length;i++){
				if(skillStr==skillData[i].command){							
					var id=skillData[i].id;
					var icon=skillData[i].icon;
					for(var j=0;j<iconData.length;j++){
						var iconId=iconData[j].icon;
						var temp=iconId.split("_");
						var d=temp[temp.length-1];					
						if(d==icon){						
							return "https://nos.netease.com/tianyuapp/"+iconData[j].icon;
						}
					}
				}
			}
			return "";
		}
	}
	module.exports = skillIconUrl;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var iconData=
	[
		{
			"id": 301,
			"school": 3,
			"icon": "tianyuapp_d7fb5bb4-75a1-42a1-b5a4-bc5601ef74e9_1101"
		},
		{
			"id": 302,
			"school": 3,
			"icon": "tianyuapp_7f1eaebe-b54b-4c0f-ad28-e5c82531fc67_1104"
		},
		{
			"id": 303,
			"school": 3,
			"icon": "tianyuapp_be47d4da-0767-4b30-8f2b-859d30359ba6_1105"
		},
		{
			"id": 304,
			"school": 3,
			"icon": "tianyuapp_cd674063-0bb3-4c15-ae62-b6fb987bb79f_1103"
		},
		{
			"id": 305,
			"school": 3,
			"icon": "tianyuapp_3c73939f-1d2f-4997-b182-32cf1e978b9e_1120"
		},
		{
			"id": 306,
			"school": 3,
			"icon": "tianyuapp_c6f4a9d3-0ecb-4d16-adb2-d4f9957aa27e_1112"
		},
		{
			"id": 307,
			"school": 3,
			"icon": "tianyuapp_905516bd-e671-4f05-9caf-c3d4bf374a2c_1102"
		},
		{
			"id": 308,
			"school": 3,
			"icon": "tianyuapp_1aaf2355-b0e3-4544-8c41-88ef54c9a76b_11151"
		},
		{
			"id": 309,
			"school": 3,
			"icon": "tianyuapp_6566e796-bf9b-4c56-8aa8-925bab9abdb0_1123"
		},
		{
			"id": 310,
			"school": 3,
			"icon": "tianyuapp_69f176a5-2841-4a7b-b1b3-d311f75968e6_1111"
		},
		{
			"id": 311,
			"school": 3,
			"icon": "tianyuapp_3784085c-2582-418b-9019-a0ad3c245e08_1113"
		},
		{
			"id": 312,
			"school": 3,
			"icon": "tianyuapp_9a43e99a-fd4d-4204-99be-195301b7f77c_1116"
		},
		{
			"id": 313,
			"school": 3,
			"icon": "tianyuapp_35079a1f-9fba-4ead-9b24-38d84905ac3d_1106"
		},
		{
			"id": 314,
			"school": 3,
			"icon": "tianyuapp_37d87ecd-9496-4285-ae37-2a5267a29b5d_1114"
		},
		{
			"id": 315,
			"school": 3,
			"icon": "tianyuapp_42ff3c35-9c66-4c1a-b4e1-7ec7b949e203_1145"
		},
		{
			"id": 316,
			"school": 3,
			"icon": "tianyuapp_279aeda6-9843-480c-b8b7-c7a0921ecbfa_1141"
		},
		{
			"id": 317,
			"school": 3,
			"icon": "tianyuapp_566a8bdc-2943-45ad-af95-396d61c3810f_1143"
		},
		{
			"id": 318,
			"school": 3,
			"icon": "tianyuapp_92d71dd2-9f26-4d20-8bcc-df2521f05902_1144"
		},
		{
			"id": 319,
			"school": 3,
			"icon": "tianyuapp_8912fc83-5c25-4f89-96ec-788d0606838f_1162"
		},
		{
			"id": 320,
			"school": 3,
			"icon": "tianyuapp_9f1ce8c1-7e9a-420c-b300-e072da8f1ab5_1163"
		},
		{
			"id": 321,
			"school": 3,
			"icon": "tianyuapp_8a7a277e-5bc6-445f-a211-73320d527780_1161"
		},
		{
			"id": 322,
			"school": 3,
			"icon": "tianyuapp_399e93cb-c98b-4f83-9413-028efc490255_1167"
		},
		{
			"id": 323,
			"school": 3,
			"icon": "tianyuapp_b3ba106b-98ff-4916-a346-98d6931e903c_1164"
		},
		{
			"id": 325,
			"school": 3,
			"icon": "tianyuapp_661bce40-4d95-48aa-9d0f-988ff5e3d945_1146"
		},
		{
			"id": 401,
			"school": 4,
			"icon": "tianyuapp_533edd99-62a6-46a2-919d-45125d595314_1201"
		},
		{
			"id": 402,
			"school": 4,
			"icon": "tianyuapp_ef03366b-d75e-48df-813b-4993e6ce9bfe_1203"
		},
		{
			"id": 403,
			"school": 4,
			"icon": "tianyuapp_d8d90478-0b26-4313-aed0-c1eb426b54ed_1220"
		},
		{
			"id": 404,
			"school": 4,
			"icon": "tianyuapp_e6aac35d-fa4a-49da-bc43-ea60809ec859_1206"
		},
		{
			"id": 405,
			"school": 4,
			"icon": "tianyuapp_b658270f-3120-450a-b3c5-9d9cb453f736_1221"
		},
		{
			"id": 406,
			"school": 4,
			"icon": "tianyuapp_7a922185-0c0d-41b5-aae4-4443f25534fc_1225"
		},
		{
			"id": 407,
			"school": 4,
			"icon": "tianyuapp_14403aa7-4254-478f-b748-e4f75c3751c0_1226"
		},
		{
			"id": 408,
			"school": 4,
			"icon": "tianyuapp_f2f184dc-c896-4744-965a-5ba90e0af60d_1227"
		},
		{
			"id": 409,
			"school": 4,
			"icon": "tianyuapp_131c690e-e2ce-4007-b9f4-73adf7a0c7b7_1228"
		},
		{
			"id": 410,
			"school": 4,
			"icon": "tianyuapp_21dc94a8-9209-41c8-8783-5c5ef4f7e5d3_1204"
		},
		{
			"id": 411,
			"school": 4,
			"icon": "tianyuapp_94871f22-68a3-455d-b927-baf378bc63e9_1202"
		},
		{
			"id": 412,
			"school": 4,
			"icon": "tianyuapp_4f52f382-e436-4137-9de7-f602d529da3f_1213"
		},
		{
			"id": 413,
			"school": 4,
			"icon": "tianyuapp_8185c4a9-5098-4050-b13e-5cdb04fa949b_1212"
		},
		{
			"id": 414,
			"school": 4,
			"icon": "tianyuapp_9a08f42c-a632-400f-9556-cc8ed2e497f0_1216"
		},
		{
			"id": 415,
			"school": 4,
			"icon": "tianyuapp_ceddcd89-773d-48c4-97d5-b40354f8d8e9_1211"
		},
		{
			"id": 416,
			"school": 4,
			"icon": "tianyuapp_ad5a13ff-bcbb-4829-b49a-23bf567feb2b_1214"
		},
		{
			"id": 417,
			"school": 4,
			"icon": "tianyuapp_4c409640-e80a-4ce0-9691-a9d171f461f5_1215"
		},
		{
			"id": 418,
			"school": 4,
			"icon": "tianyuapp_ed912b62-ca8e-46c1-a0ff-62619a6467aa_1244"
		},
		{
			"id": 419,
			"school": 4,
			"icon": "tianyuapp_cada011b-0bc7-462b-870f-25cba43008e1_1241"
		},
		{
			"id": 420,
			"school": 4,
			"icon": "tianyuapp_c19e982d-417a-4899-a24f-a084022e6a52_1243"
		},
		{
			"id": 421,
			"school": 4,
			"icon": "tianyuapp_c46ab0fe-18ae-45d2-8caf-b02e64159f1f_1242"
		},
		{
			"id": 422,
			"school": 4,
			"icon": "tianyuapp_e73ad0cd-5b84-44fa-91fe-37541551d1ec_1263"
		},
		{
			"id": 423,
			"school": 4,
			"icon": "tianyuapp_b3bcddc6-19b8-4cb5-add3-fea48ef32714_1264"
		},
		{
			"id": 424,
			"school": 4,
			"icon": "tianyuapp_080accdf-294e-4fa8-8ad6-322498f0fe97_1262"
		},
		{
			"id": 425,
			"school": 4,
			"icon": "tianyuapp_c6153e3a-136a-4a92-a5ae-efdba5d583e3_1261"
		},
		{
			"id": 426,
			"school": 4,
			"icon": "tianyuapp_6895be24-4c9b-4d84-921e-b2c942dc5551_1230"
		},
		{
			"id": 427,
			"school": 4,
			"icon": "tianyuapp_0d6fd6d7-9fd3-40c4-9120-85c96d22435d_1265"
		},
		{
			"id": 434,
			"school": 4,
			"icon": "tianyuapp_c95664af-cd54-419d-afb5-9f442ec8b5c3_12451"
		},
		{
			"id": 501,
			"school": 5,
			"icon": "tianyuapp_bbb7fb16-dacd-4dc5-a555-7f483f284cde_1301"
		},
		{
			"id": 502,
			"school": 5,
			"icon": "tianyuapp_8a064846-d02d-4a64-a74a-8a942dc2ed33_1304"
		},
		{
			"id": 503,
			"school": 5,
			"icon": "tianyuapp_a06db556-dea4-4231-a1ab-08d916f25521_1313"
		},
		{
			"id": 504,
			"school": 5,
			"icon": "tianyuapp_5e2006cd-66de-40fe-a660-04a0b307c413_1303"
		},
		{
			"id": 505,
			"school": 5,
			"icon": "tianyuapp_46d3ae4d-5727-4277-98f2-ea6b75d24295_1317"
		},
		{
			"id": 506,
			"school": 5,
			"icon": "tianyuapp_bfcee7d6-c032-4af7-8367-69fadc1cb4ec_1319"
		},
		{
			"id": 507,
			"school": 5,
			"icon": "tianyuapp_6228614a-5359-4792-90d2-be484691fa6e_1316"
		},
		{
			"id": 508,
			"school": 5,
			"icon": "tianyuapp_37ecb19a-7823-4c4c-b228-d2b0817300db_1302"
		},
		{
			"id": 509,
			"school": 5,
			"icon": "tianyuapp_9e836662-764c-4954-8aac-adbf84564b5b_1314"
		},
		{
			"id": 510,
			"school": 5,
			"icon": "tianyuapp_c82680df-39f5-4229-86b8-910c8c5d30ac_1311"
		},
		{
			"id": 511,
			"school": 5,
			"icon": "tianyuapp_9d623569-3504-4a33-9268-9f5b2b9b030e_1312"
		},
		{
			"id": 512,
			"school": 5,
			"icon": "tianyuapp_dde85a40-9924-424c-a7e0-0dc7b657239b_1305"
		},
		{
			"id": 513,
			"school": 5,
			"icon": "tianyuapp_e6adde71-6f5c-4a1a-972c-045df5bb0e95_1306"
		},
		{
			"id": 514,
			"school": 5,
			"icon": "tianyuapp_80d2781e-4d09-43fd-afc3-f64abe11483b_1345"
		},
		{
			"id": 515,
			"school": 5,
			"icon": "tianyuapp_e264f7b2-f59c-460e-ac4f-b97487457052_1347"
		},
		{
			"id": 516,
			"school": 5,
			"icon": "tianyuapp_e24cb7f7-f85a-4b4a-bff6-7fe1478f87b6_1340"
		},
		{
			"id": 517,
			"school": 5,
			"icon": "tianyuapp_39764716-d949-4161-9603-6d5f687d5c19_1342"
		},
		{
			"id": 518,
			"school": 5,
			"icon": "tianyuapp_ba6fb6df-8428-400a-b40e-24e7a5494e67_1362"
		},
		{
			"id": 519,
			"school": 5,
			"icon": "tianyuapp_a32febc0-1839-4b96-955b-00eb57ce0d58_1361"
		},
		{
			"id": 520,
			"school": 5,
			"icon": "tianyuapp_7d0fc227-5130-4372-88e2-86625a26c8f3_1343"
		},
		{
			"id": 521,
			"school": 5,
			"icon": "tianyuapp_51bc6ddc-1a16-4820-8ac3-355445c276cd_1346"
		},
		{
			"id": 522,
			"school": 5,
			"icon": "tianyuapp_f1700517-a685-43e7-9d8c-8e1017165b9c_1363"
		},
		{
			"id": 541,
			"school": 5,
			"icon": "tianyuapp_8eec4d6d-576d-4e70-8f0d-a593ca04f0a9_1344"
		},
		{
			"id": 601,
			"school": 6,
			"icon": "tianyuapp_6cdcfdaf-09f3-41c1-a19d-0591a6aad023_1501"
		},
		{
			"id": 602,
			"school": 6,
			"icon": "tianyuapp_0f6c166d-b8e3-4521-b9de-2a8bd8b09c01_1503"
		},
		{
			"id": 603,
			"school": 6,
			"icon": "tianyuapp_08bb8224-7677-4c3a-b18d-f1f1bb69cd4c_1512"
		},
		{
			"id": 604,
			"school": 6,
			"icon": "tianyuapp_9f72ecc6-6623-407c-82e4-273334415f4c_1504"
		},
		{
			"id": 605,
			"school": 6,
			"icon": "tianyuapp_dad6fae4-f0b1-4cba-a501-59376c0906eb_1502"
		},
		{
			"id": 606,
			"school": 6,
			"icon": "tianyuapp_05b7aaf4-ae35-4706-aa97-63bac74fd670_1513"
		},
		{
			"id": 607,
			"school": 6,
			"icon": "tianyuapp_9eca46aa-6473-4cc7-9954-41ed654f7066_1505"
		},
		{
			"id": 608,
			"school": 6,
			"icon": "tianyuapp_46191d43-44a3-45f5-b2ab-93153c44b4e5_1519"
		},
		{
			"id": 609,
			"school": 6,
			"icon": "tianyuapp_77cffc25-a5b1-4e4e-a821-b2c751bb619a_1511"
		},
		{
			"id": 610,
			"school": 6,
			"icon": "tianyuapp_9e056495-d1b8-4db0-b983-5ac786273f00_1517"
		},
		{
			"id": 611,
			"school": 6,
			"icon": "tianyuapp_853e2e11-9202-452d-b2f5-12a4803bdaec_1518"
		},
		{
			"id": 612,
			"school": 6,
			"icon": "tianyuapp_0ff0eada-4c36-47a0-8dce-a231fcbd5388_1514"
		},
		{
			"id": 613,
			"school": 6,
			"icon": "tianyuapp_fa89ef70-f605-4fb1-ba73-333a2aea7c20_1515"
		},
		{
			"id": 614,
			"school": 6,
			"icon": "tianyuapp_54f2863c-a330-4d89-bd9d-c6f854ea1e09_1506"
		},
		{
			"id": 615,
			"school": 6,
			"icon": "tianyuapp_164424c0-18df-4460-aa36-0dd82089b8fe_1541"
		},
		{
			"id": 616,
			"school": 6,
			"icon": "tianyuapp_f50cfba3-f7c5-43ed-8311-7899c35db8ff_1542"
		},
		{
			"id": 617,
			"school": 6,
			"icon": "tianyuapp_0465d35b-037d-4b6f-96ae-2e019c11bd51_1543"
		},
		{
			"id": 618,
			"school": 6,
			"icon": "tianyuapp_3371cec9-e3eb-4959-af53-df4d830b4e28_1544"
		},
		{
			"id": 619,
			"school": 6,
			"icon": "tianyuapp_66b81a3c-a5b2-4b33-a17f-e0f777fa150e_1545"
		},
		{
			"id": 620,
			"school": 6,
			"icon": "tianyuapp_68844b62-eeec-4b8e-9c4f-94ff638f0dd9_1562"
		},
		{
			"id": 621,
			"school": 6,
			"icon": "tianyuapp_170a03a2-1730-40e0-af99-5cd0321cb9de_1568"
		},
		{
			"id": 622,
			"school": 6,
			"icon": "tianyuapp_c00dedbb-9861-4443-b6c6-a86af3a0145f_1569"
		},
		{
			"id": 623,
			"school": 6,
			"icon": "tianyuapp_ff3c152e-7018-436d-adfe-f70e3aea849c_1570"
		},
		{
			"id": 626,
			"school": 6,
			"icon": "tianyuapp_6e1116f8-0ac8-43e7-821d-54a054923630_1563"
		},
		{
			"id": 627,
			"school": 6,
			"icon": "tianyuapp_6e1116f8-0ac8-43e7-821d-54a054923630_1563"
		},
		{
			"id": 701,
			"school": 7,
			"icon": "tianyuapp_01d54635-2a5c-4c9a-9366-a2867466a782_1401"
		},
		{
			"id": 702,
			"school": 7,
			"icon": "tianyuapp_1d521290-0a1e-478d-aa9c-60b11f3353fc_1402"
		},
		{
			"id": 703,
			"school": 7,
			"icon": "tianyuapp_0c95f8ab-e93e-4004-9f1d-0d2dd4bef693_1406"
		},
		{
			"id": 704,
			"school": 7,
			"icon": "tianyuapp_a8d41be1-6c5c-4e9e-85e5-fb67022e7889_1411"
		},
		{
			"id": 705,
			"school": 7,
			"icon": "tianyuapp_2cff711a-1e29-4c84-a9bb-c48533a72b5a_1405"
		},
		{
			"id": 706,
			"school": 7,
			"icon": "tianyuapp_a11a6a7c-22ef-43c4-8cc3-51ca817d5968_1413"
		},
		{
			"id": 707,
			"school": 7,
			"icon": "tianyuapp_a17430c3-edba-4ddb-a205-f342f2a1ab97_1412"
		},
		{
			"id": 708,
			"school": 7,
			"icon": "tianyuapp_02d9de50-e4ac-48b3-8b88-b5e5df38b028_1414"
		},
		{
			"id": 709,
			"school": 7,
			"icon": "tianyuapp_21f97f59-dd7c-476f-97bd-ea1d229bbc0d_1416"
		},
		{
			"id": 710,
			"school": 7,
			"icon": "tianyuapp_d929d1cf-edb3-42fb-b02f-23dfd7b736a2_1404"
		},
		{
			"id": 711,
			"school": 7,
			"icon": "tianyuapp_43854627-9c01-43a1-ad88-be878538269a_1403"
		},
		{
			"id": 712,
			"school": 7,
			"icon": "tianyuapp_9a51aa88-1a2c-45f3-bce8-d8bc6dd99b44_1415"
		},
		{
			"id": 713,
			"school": 7,
			"icon": "tianyuapp_e3d34004-fa61-4002-90b7-bb636334b513_1447"
		},
		{
			"id": 714,
			"school": 7,
			"icon": "tianyuapp_f8ed7f42-19b7-491b-aa6b-1f08688ac68f_1442"
		},
		{
			"id": 715,
			"school": 7,
			"icon": "tianyuapp_acaf5e38-8891-4311-bea7-72af2770b192_1441"
		},
		{
			"id": 716,
			"school": 7,
			"icon": "tianyuapp_f7552efa-1c82-401e-8cb9-441d80e87016_1443"
		},
		{
			"id": 717,
			"school": 7,
			"icon": "tianyuapp_8acc5ea3-3e2b-4f72-8d5d-cbde4fc256ef_1462"
		},
		{
			"id": 718,
			"school": 7,
			"icon": "tianyuapp_cff7bcca-e790-48ba-a69c-e8093ff42734_1464"
		},
		{
			"id": 719,
			"school": 7,
			"icon": "tianyuapp_07da9e0e-5a54-4fb1-b080-2a55acee307c_1461"
		},
		{
			"id": 720,
			"school": 7,
			"icon": "tianyuapp_23aee1ea-8cbc-4b98-a838-090e86025c49_1468"
		},
		{
			"id": 721,
			"school": 7,
			"icon": "tianyuapp_0395f632-6145-4244-a99f-8116d45e4b57_1463"
		},
		{
			"id": 731,
			"school": 7,
			"icon": "tianyuapp_a9fa7737-0989-49e1-af1a-925e86bb0af7_1444"
		},
		{
			"id": 801,
			"school": 8,
			"icon": "tianyuapp_b618e745-434f-401a-a28b-0834148641c2_16022"
		},
		{
			"id": 802,
			"school": 8,
			"icon": "tianyuapp_19d380ad-395a-45fb-bd0b-edac1c360e19_16032"
		},
		{
			"id": 803,
			"school": 8,
			"icon": "tianyuapp_5c51c105-f05b-4b84-87a7-fd5affbb7f8d_16152"
		},
		{
			"id": 804,
			"school": 8,
			"icon": "tianyuapp_ee646d36-c7de-4fc3-a752-60c862c0a41d_16042"
		},
		{
			"id": 805,
			"school": 8,
			"icon": "tianyuapp_a543dde8-3274-4067-9d08-f8f3ed2ec611_16062"
		},
		{
			"id": 806,
			"school": 8,
			"icon": "tianyuapp_8bc318fa-5652-4138-9ede-1b3aae2dc349_16112"
		},
		{
			"id": 807,
			"school": 8,
			"icon": "tianyuapp_b461b003-1c23-4e2a-9496-37909b2e7434_16012"
		},
		{
			"id": 808,
			"school": 8,
			"icon": "tianyuapp_4e03de08-125a-44cc-a65c-da6763ab17e7_16142"
		},
		{
			"id": 809,
			"school": 8,
			"icon": "tianyuapp_5d17f89f-aa32-4f55-915c-4f52d51b8864_16162"
		},
		{
			"id": 810,
			"school": 8,
			"icon": "tianyuapp_5ce69221-6008-43da-b50f-b45e678b7bdb_16052"
		},
		{
			"id": 811,
			"school": 8,
			"icon": "tianyuapp_d20442dc-59c8-4aae-be30-113a8649e2bc_16132"
		},
		{
			"id": 812,
			"school": 8,
			"icon": "tianyuapp_0878480e-2d3c-4f45-8e37-f197bd79a260_16122"
		},
		{
			"id": 813,
			"school": 8,
			"icon": "tianyuapp_23dcd7b3-d9a2-45a6-9f58-54f028e1ee4f_1667"
		},
		{
			"id": 814,
			"school": 8,
			"icon": "tianyuapp_09636392-55aa-4edb-a93e-2588c9a9d977_1662"
		},
		{
			"id": 815,
			"school": 8,
			"icon": "tianyuapp_970dbf5e-ab3c-417f-8d90-f8c76c10b2fa_1661"
		},
		{
			"id": 816,
			"school": 8,
			"icon": "tianyuapp_6b3b923d-9b02-4403-baa7-06f89ea338c7_1668"
		},
		{
			"id": 817,
			"school": 8,
			"icon": "tianyuapp_19c3519c-0661-4c20-87b1-3fa12fc9fb90_1663"
		},
		{
			"id": 818,
			"school": 8,
			"icon": "tianyuapp_0c0840eb-cae3-41ee-a17e-8ef9e4c27ca9_1646"
		},
		{
			"id": 819,
			"school": 8,
			"icon": "tianyuapp_1f2a4180-6ff9-4997-a913-f3e537ca947f_1647"
		},
		{
			"id": 820,
			"school": 8,
			"icon": "tianyuapp_7f1cfb10-6fc6-4432-b833-2573c0514a97_1641"
		},
		{
			"id": 821,
			"school": 8,
			"icon": "tianyuapp_ebd919eb-b072-42a8-a05a-4d35f8cff13a_1643"
		},
		{
			"id": 829,
			"school": 8,
			"icon": "tianyuapp_13b5e36f-57ad-4af6-8a5d-b4b025062aef_1645"
		},
		{
			"id": 901,
			"school": 9,
			"icon": "tianyuapp_15da6653-2ee4-4616-9f0f-8ab3c221a853_1701"
		},
		{
			"id": 902,
			"school": 9,
			"icon": "tianyuapp_3d326ec0-bc68-44d6-afa9-e6e352ecd357_1711"
		},
		{
			"id": 903,
			"school": 9,
			"icon": "tianyuapp_a014e803-ce33-4d87-bd7d-052a0d6fca4a_1705"
		},
		{
			"id": 904,
			"school": 9,
			"icon": "tianyuapp_9943704e-16bc-4ca1-98fd-7b9b51336a5c_1716"
		},
		{
			"id": 905,
			"school": 9,
			"icon": "tianyuapp_1c07f502-52ea-48e4-8f42-627c7b81b316_1791"
		},
		{
			"id": 906,
			"school": 9,
			"icon": "tianyuapp_133e6133-7fa0-47db-adb7-4351a275d01b_1713"
		},
		{
			"id": 907,
			"school": 9,
			"icon": "tianyuapp_6de54a5f-969b-4bd7-9315-c45b0bb571d7_1702"
		},
		{
			"id": 908,
			"school": 9,
			"icon": "tianyuapp_1f420f9b-7e75-4e63-abc5-3b406fbe45a5_1714"
		},
		{
			"id": 909,
			"school": 9,
			"icon": "tianyuapp_1a4fefa9-9dee-4772-a291-47d0f730e14d_1790"
		},
		{
			"id": 910,
			"school": 9,
			"icon": "tianyuapp_38f6c673-8fad-49c6-9842-80cacd4e8cf1_1715"
		},
		{
			"id": 911,
			"school": 9,
			"icon": "tianyuapp_5a924cfe-2a99-4b5f-85fb-293f00571dbf_1703"
		},
		{
			"id": 912,
			"school": 9,
			"icon": "tianyuapp_f9a41eb5-4a66-42e2-81cf-f917e2b37b61_1712"
		},
		{
			"id": 913,
			"school": 9,
			"icon": "tianyuapp_366dbe48-e00b-4135-b336-e3f58b8325d8_1704"
		},
		{
			"id": 914,
			"school": 9,
			"icon": "tianyuapp_52323c38-5395-4836-bfee-72e428c2cbab_1706"
		},
		{
			"id": 915,
			"school": 9,
			"icon": "tianyuapp_24e5494a-39cf-49b3-8df3-afbea0ce40f4_1741"
		},
		{
			"id": 916,
			"school": 9,
			"icon": "tianyuapp_61d56b97-7880-4615-b6b9-9bf4b1f844e9_1742"
		},
		{
			"id": 917,
			"school": 9,
			"icon": "tianyuapp_a4e057ad-c126-4c0e-aec1-b230e0b1dac9_1743"
		},
		{
			"id": 918,
			"school": 9,
			"icon": "tianyuapp_a0d9a73d-22ec-49cc-9f58-b0e15136b19a_1745"
		},
		{
			"id": 919,
			"school": 9,
			"icon": "tianyuapp_12385ad2-a65b-4671-a7c1-6a911d53002a_1744"
		},
		{
			"id": 920,
			"school": 9,
			"icon": "tianyuapp_1ae7022b-0ce7-48f5-b98e-9cc13201cfd3_1761"
		},
		{
			"id": 921,
			"school": 9,
			"icon": "tianyuapp_b7f7d092-6dcb-4732-87d6-d35ee6d8e367_1762"
		},
		{
			"id": 922,
			"school": 9,
			"icon": "tianyuapp_57b4a431-bbfa-47a5-9450-02031fd4b1e1_1763"
		},
		{
			"id": 923,
			"school": 9,
			"icon": "tianyuapp_63e3aea8-0be8-4e8b-bbdf-45b8e67200e1_1764"
		},
		{
			"id": 930,
			"school": 9,
			"icon": "tianyuapp_751ffe5a-210e-47bf-92d0-2e278fad6971_1765"
		},
		{
			"id": 1,
			"school": 0,
			"icon": "tianyuapp_c1aeef14-c03e-4935-8b19-5db00ebca83e_10"
		},
		{
			"id": 2,
			"school": 0,
			"icon": "tianyuapp_09044b03-cb79-41f0-82e4-f13e68720f52_11"
		},
		{
			"id": 3,
			"school": 0,
			"icon": "tianyuapp_ba0aa3d5-bb24-4509-bde6-4b25950bb374_12"
		},
		{
			"id": 4,
			"school": 0,
			"icon": "tianyuapp_77241612-68e5-4eda-bd36-9a2430d31f42_13"
		},
		{
			"id": 5,
			"school": 0,
			"icon": "tianyuapp_dda7a677-fa3f-45bf-a0fb-75a58c0147e6_14"
		},
		{
			"id": 6,
			"school": 0,
			"icon": "tianyuapp_2a544a04-673b-468d-a719-e90e4500b78f_15"
		},
		{
			"id": 7,
			"school": 0,
			"icon": "tianyuapp_dcfa015a-6b16-4284-90c7-cc64dc283282_16"
		},
		{
			"id": 8,
			"school": 0,
			"icon": "tianyuapp_5796e301-462c-4100-97a2-6d8e7be64b7e_17"
		},
		{
			"id": 9,
			"school": 0,
			"icon": "tianyuapp_920d0078-f3e0-44c1-b3b3-e4a0a48e0d60_18"
		},
		{
			"id": 10,
			"school": 0,
			"icon": "tianyuapp_ca90ab14-ca94-4aa3-ae98-c62637b4c2dc_19"
		},
		{
			"id": 11,
			"school": 0,
			"icon": "tianyuapp_149eb38c-69c4-4c66-abaa-56565113c640_20"
		},
		{
			"id": 12,
			"school": 0,
			"icon": "tianyuapp_0e2d2048-2294-4fd5-bbba-ff55c35660db_21"
		},
		{
			"id": 13,
			"school": 0,
			"icon": "tianyuapp_90cab5c8-239a-41ec-aea5-3e4a81156380_22"
		},
		{
			"id": 14,
			"school": 0,
			"icon": "tianyuapp_0246a933-79dd-489b-aa0c-0448d86dc689_23"
		},
		{
			"id": 15,
			"school": 0,
			"icon": "tianyuapp_a9972661-32ff-4b5a-8896-e1f3171b8a48_24"
		},
		{
			"id": 16,
			"school": 0,
			"icon": "tianyuapp_67fcfa3d-bf9e-47e8-a9de-a2881e446939_28"
		},
		{
			"id": 17,
			"school": 0,
			"icon": "tianyuapp_2c754b43-99d6-4b22-84d0-d5ff4a695e58_29"
		},
		{
			"id": 18,
			"school": 0,
			"icon": "tianyuapp_007d5dfb-e480-4d4c-914a-d454c6ca2f4d_30"
		},
		{
			"id": 19,
			"school": 0,
			"icon": "tianyuapp_c6dfbcb6-bb6e-48c9-86a9-98f358ffd91d_25"
		},
		{
			"id": 20,
			"school": 0,
			"icon": "tianyuapp_f23712ee-8e63-4af9-b2f5-44a3bd432540_26"
		},
		{
			"id": 21,
			"school": 0,
			"icon": "tianyuapp_88b5f56d-04ce-423a-9539-dad93c7a2017_27"
		},
		{
			"id": 22,
			"school": 0,
			"icon": "tianyuapp_0b765269-d163-426a-b532-8369555e8b0f_31"
		},
		{
			"id": 23,
			"school": 0,
			"icon": "tianyuapp_f168ab25-62a3-4091-b78b-f1fdf9a87d44_32"
		},
		{
			"id": 24,
			"school": 0,
			"icon": "tianyuapp_5abbbee2-d477-49ca-8e30-7e839984c92f_33"
		},
		{
			"id": 25,
			"school": 0,
			"icon": "tianyuapp_3449d18f-d1ab-4b91-beac-6bb8858028f9_34"
		},
		{
			"id": 26,
			"school": 0,
			"icon": "tianyuapp_1ba83c36-1301-4cf0-addf-5f75e6bfaa9b_35"
		},
		{
			"id": 27,
			"school": 0,
			"icon": "tianyuapp_3f7d9ef6-14c5-4d2c-890a-8e8f07701b48_36"
		},
		{
			"id": 28,
			"school": 0,
			"icon": "tianyuapp_dad94c6d-23d7-4629-95b1-948dee99ae3b_37"
		},
		{
			"id": 29,
			"school": 0,
			"icon": "tianyuapp_e0c21509-1970-4a4d-b55a-ef4decad0569_38"
		},
		{
			"id": 30,
			"school": 0,
			"icon": "tianyuapp_65f6596c-d2a4-405d-af93-8fc9f88c801d_39"
		},
		{
			"id": 31,
			"school": 0,
			"icon": "tianyuapp_4c7ccbf0-fa7f-4ef4-892d-6bdb6775c997_40"
		},
		{
			"id": 32,
			"school": 0,
			"icon": "tianyuapp_7846301b-cdde-41c4-a33a-29c652fc1293_41"
		},
		{
			"id": 33,
			"school": 0,
			"icon": "tianyuapp_243369a8-5f24-4f50-9da0-38f1c6c8b854_42"
		},
		{
			"id": 1101,
			"school": 10,
			"icon": "tianyuapp_1a9cbab4-9ffa-4e48-8601-0937045decff_1901"
		},
		{
			"id": 1102,
			"school": 10,
			"icon": "tianyuapp_1f3a2969-ea3f-4bcc-b80b-efbcf6cd537c_1902"
		},
		{
			"id": 1103,
			"school": 10,
			"icon": "tianyuapp_8abb7f5f-57e2-4733-b087-b6407e6478f8_1904"
		},
		{
			"id": 1104,
			"school": 10,
			"icon": "tianyuapp_1cd0a12f-11c1-4ce8-a955-25fa8636c986_1905"
		},
		{
			"id": 1105,
			"school": 10,
			"icon": "tianyuapp_58de7e28-0317-40a3-99af-fabd591052ad_1907"
		},
		{
			"id": 1106,
			"school": 10,
			"icon": "tianyuapp_df63e581-30e5-41c5-b493-04cd1d2fa7e9_1906"
		},
		{
			"id": 1107,
			"school": 10,
			"icon": "tianyuapp_9b7455b7-cf96-45ce-92ae-40dfdeec232f_1908"
		},
		{
			"id": 1108,
			"school": 10,
			"icon": "tianyuapp_3c688925-98eb-4eed-80c1-a6a5ea8c17fc_1903"
		},
		{
			"id": 1109,
			"school": 10,
			"icon": "tianyuapp_3d3dce13-f4c5-4fc5-9416-ec950864a6a0_1909"
		},
		{
			"id": 1110,
			"school": 10,
			"icon": "tianyuapp_05ed5bef-a046-460b-867c-61e0cc72d24a_1910"
		},
		{
			"id": 1111,
			"school": 10,
			"icon": "tianyuapp_f57c01a6-d7d4-400c-9467-5145948b17c1_1911"
		},
		{
			"id": 1112,
			"school": 10,
			"icon": "tianyuapp_93ec6465-dc6e-47d5-b722-d1efa9f3e247_1912"
		},
		{
			"id": 1113,
			"school": 10,
			"icon": "tianyuapp_b73135e5-86e0-4fad-b15e-aaa5be227dd0_1913"
		},
		{
			"id": 1114,
			"school": 10,
			"icon": "tianyuapp_0d92c3a5-3554-47b6-a0e2-ee7aff083a89_1914"
		},
		{
			"id": 1115,
			"school": 10,
			"icon": "tianyuapp_365e8dd5-5563-4d6e-b0aa-b65baf39708a_1916"
		},
		{
			"id": 1116,
			"school": 10,
			"icon": "tianyuapp_f0c348e9-487d-457b-98af-adabe03a9f39_1917"
		},
		{
			"id": 1117,
			"school": 10,
			"icon": "tianyuapp_29414f59-a083-46fa-8395-9c4ef5cca34f_1915"
		},
		{
			"id": 1118,
			"school": 10,
			"icon": "tianyuapp_efd0e48e-10d9-48c5-950d-3b8ca58a97f3_1918"
		},
		{
			"id": 1119,
			"school": 10,
			"icon": "tianyuapp_53220624-d882-4dd2-845e-5a99a3ce4523_1919"
		},
		{
			"id": 1120,
			"school": 10,
			"icon": "tianyuapp_b0935d8d-f62c-4223-ad02-5207b74298ff_1920"
		},
		{
			"id": 1121,
			"school": 10,
			"icon": "tianyuapp_1eb30983-f827-448c-9b7e-1172be8c29f5_1921"
		},
		{
			"id": 1122,
			"school": 10,
			"icon": "tianyuapp_c48ab922-d971-429a-b94d-061912fc6670_1922"
		},
		{
			"id": 1201,
			"school": 11,
			"icon": "tianyuapp_d481cadb-224f-4436-a395-828f916efd8c_2110"
		},
		{
			"id": 1205,
			"school": 11,
			"icon": "tianyuapp_4bf964e5-fff1-4ab8-bb6a-ecf6c7a1c3db_2114"
		},
		{
			"id": 1206,
			"school": 11,
			"icon": "tianyuapp_0e76ab26-1699-44b9-8d69-28d3d16b0de1_2115"
		},
		{
			"id": 1207,
			"school": 11,
			"icon": "tianyuapp_9b02c274-c27b-437e-a34f-6dc8ecdbcc09_2116"
		},
		{
			"id": 1208,
			"school": 11,
			"icon": "tianyuapp_a647a59e-485e-4e89-a16d-1fd08a879c6c_2117"
		},
		{
			"id": 1209,
			"school": 11,
			"icon": "tianyuapp_652f0272-cb56-4030-8feb-dc2b82bee0d5_2118"
		},
		{
			"id": 1210,
			"school": 11,
			"icon": "tianyuapp_b10b3edb-db04-4b13-a3eb-18b671443170_2119"
		},
		{
			"id": 1211,
			"school": 11,
			"icon": "tianyuapp_f2e16881-4726-46b9-ac9e-11ffc890b99a_2120"
		},
		{
			"id": 1212,
			"school": 11,
			"icon": "tianyuapp_d1319633-72a4-4b37-ae47-330f534ec2c8_2121"
		},
		{
			"id": 1213,
			"school": 11,
			"icon": "tianyuapp_d7010307-fe56-46a3-af2c-224b04614e58_2122"
		},
		{
			"id": 1214,
			"school": 11,
			"icon": "tianyuapp_8acdccd0-0ede-4705-88c5-0e1714baade1_2123"
		},
		{
			"id": 1215,
			"school": 11,
			"icon": "tianyuapp_bfee8210-8b68-4f93-9d4f-0a255f009dbf_2124"
		},
		{
			"id": 1216,
			"school": 11,
			"icon": "tianyuapp_b66a048e-4944-4b71-a1f9-86037ed3b73c_2125"
		},
		{
			"id": 1217,
			"school": 11,
			"icon": "tianyuapp_9cdc1ce0-3555-428c-bb6e-d9797dd14d83_2126"
		},
		{
			"id": 1218,
			"school": 11,
			"icon": "tianyuapp_38fbeb2e-62c7-482d-9285-b477d1e4d34a_2127"
		},
		{
			"id": 1219,
			"school": 11,
			"icon": "tianyuapp_ab70bb75-1634-4178-8931-3832eb70e92c_2129"
		},
		{
			"id": 1220,
			"school": 11,
			"icon": "tianyuapp_9a76bfca-5d0a-4dc1-8764-aefbb1aaec92_2130"
		},
		{
			"id": 1221,
			"school": 11,
			"icon": "tianyuapp_15cd9792-9eb5-40f5-8e16-afe94ec0dfc4_2131"
		},
		{
			"id": 1223,
			"school": 11,
			"icon": "tianyuapp_b15a2b7b-53dd-4832-8fa0-3fd5d0266ca8_2132"
		},
		{
			"id": 1224,
			"school": 11,
			"icon": "tianyuapp_353093dc-7df4-45ec-b98a-801ed12031a1_2133"
		},
		{
			"id": 1226,
			"school": 11,
			"icon": "tianyuapp_5cb930cb-f3c9-4ce9-a8c8-034c9bdfd949_2134"
		},
		{
			"id": 1227,
			"school": 11,
			"icon": "tianyuapp_c0efbb11-9328-4a6e-bc4d-67a5c90f66bb_2135"
		},
		{
			"id": 1228,
			"school": 11,
			"icon": "tianyuapp_8652a276-a639-4afb-a071-523eee8ea4f3_2136"
		},
		{
			"id": 1229,
			"school": 11,
			"icon": "tianyuapp_26a51ded-75f3-4982-985f-a8560b087516_2137"
		},
		{
			"id": 1230,
			"school": 11,
			"icon": "tianyuapp_b7cf8930-071d-4a1b-bdd2-56746834859d_2138"
		},
		{
			"id": 1231,
			"school": 11,
			"icon": "tianyuapp_42f54e90-ae8b-46b2-b4bc-42f0fe9af728_2139"
		},
		{
			"id": 1232,
			"school": 11,
			"icon": "tianyuapp_7fb4bd5f-dedd-468a-9a63-ff64f816e898_2140"
		}
	];
	module.exports=iconData;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var skillData=
	[
		{
			"id": 301,
			"type": 0,
			"school": 3,
			"icon": 1101,
			"describe": "【猛击】",
			"command": "/技能 猛击"
		},
		{
			"id": 302,
			"type": 0,
			"school": 3,
			"icon": 1104,
			"describe": "【扫荡】",
			"command": "/技能 扫荡"
		},
		{
			"id": 303,
			"type": 0,
			"school": 3,
			"icon": 1105,
			"describe": "【破阵】",
			"command": "/技能 破阵"
		},
		{
			"id": 304,
			"type": 0,
			"school": 3,
			"icon": 1103,
			"describe": "【旋斩】",
			"command": "/技能 旋斩"
		},
		{
			"id": 305,
			"type": 0,
			"school": 3,
			"icon": 1103,
			"describe": "【旋斩二斩】",
			"command": "/技能 旋斩二斩"
		},
		{
			"id": 306,
			"type": 0,
			"school": 3,
			"icon": 1112,
			"describe": "【定军】",
			"command": "/技能 定军"
		},
		{
			"id": 307,
			"type": 0,
			"school": 3,
			"icon": 1102,
			"describe": "【降世】",
			"command": "/技能 降世"
		},
		{
			"id": 308,
			"type": 0,
			"school": 3,
			"icon": 11151,
			"describe": "【罡体】",
			"command": "/技能 罡体"
		},
		{
			"id": 309,
			"type": 0,
			"school": 3,
			"icon": 1123,
			"describe": "【雷罡体】",
			"command": "/技能 雷罡体"
		},
		{
			"id": 310,
			"type": 0,
			"school": 3,
			"icon": 1111,
			"describe": "【龙握】",
			"command": "/技能 龙握"
		},
		{
			"id": 311,
			"type": 0,
			"school": 3,
			"icon": 1113,
			"describe": "【铁血】",
			"command": "/技能 铁血"
		},
		{
			"id": 312,
			"type": 0,
			"school": 3,
			"icon": 1116,
			"describe": "【啸天】",
			"command": "/技能 啸天"
		},
		{
			"id": 313,
			"type": 0,
			"school": 3,
			"icon": 1106,
			"describe": "【光盾】",
			"command": "/技能 光盾"
		},
		{
			"id": 314,
			"type": 0,
			"school": 3,
			"icon": 1106,
			"describe": "【光盾二斩】",
			"command": "/技能 光盾二斩"
		},
		{
			"id": 315,
			"type": 0,
			"school": 3,
			"icon": 1114,
			"describe": "【无畏】",
			"command": "/技能 无畏"
		},
		{
			"id": 316,
			"type": 0,
			"school": 3,
			"icon": 1145,
			"describe": "【飞雷·断】",
			"command": "/技能 飞雷·断"
		},
		{
			"id": 317,
			"type": 0,
			"school": 3,
			"icon": 1141,
			"describe": "【炎雷·转】",
			"command": "/技能 炎雷·转"
		},
		{
			"id": 318,
			"type": 0,
			"school": 3,
			"icon": 1143,
			"describe": "【奔雷·冲】",
			"command": "/技能 奔雷·冲"
		},
		{
			"id": 319,
			"type": 0,
			"school": 3,
			"icon": 1144,
			"describe": "【雷神·千裂破】",
			"command": "/技能 雷神·千裂破"
		},
		{
			"id": 320,
			"type": 0,
			"school": 3,
			"icon": 1162,
			"describe": "【撼·雷霆】",
			"command": "/技能 撼·雷霆"
		},
		{
			"id": 321,
			"type": 0,
			"school": 3,
			"icon": 1163,
			"describe": "【锁·擒魔】",
			"command": "/技能 锁·擒魔"
		},
		{
			"id": 322,
			"type": 0,
			"school": 3,
			"icon": 1161,
			"describe": "【霸·罡体】",
			"command": "/技能 霸·罡体"
		},
		{
			"id": 323,
			"type": 0,
			"school": 3,
			"icon": 1167,
			"describe": "【雷神·绝对守护】",
			"command": "/技能 雷神·绝对守护"
		},
		{
			"id": 324,
			"type": 0,
			"school": 3,
			"icon": 1164,
			"describe": "【惊雷·震万钧】",
			"command": "/技能 惊雷·震万钧"
		},
		{
			"id": 325,
			"type": 0,
			"school": 3,
			"icon": 1146,
			"describe": "【冲雷·降天罡】",
			"command": "/技能 冲雷·降天罡"
		},
		{
			"id": 401,
			"type": 0,
			"school": 4,
			"icon": 1201,
			"describe": "【穿云】",
			"command": "/技能 穿云"
		},
		{
			"id": 402,
			"type": 0,
			"school": 4,
			"icon": 1203,
			"describe": "【流火】",
			"command": "/技能 流火"
		},
		{
			"id": 403,
			"type": 0,
			"school": 4,
			"icon": 1203,
			"describe": "【流火二斩】",
			"command": "/技能 流火二斩"
		},
		{
			"id": 404,
			"type": 0,
			"school": 4,
			"icon": 1206,
			"describe": "【冰封】",
			"command": "/技能 冰封"
		},
		{
			"id": 405,
			"type": 0,
			"school": 4,
			"icon": 1206,
			"describe": "【冰封二斩】",
			"command": "/技能 冰封二斩"
		},
		{
			"id": 406,
			"type": 0,
			"school": 4,
			"icon": 1225,
			"describe": "【聚灵】",
			"command": "/技能 聚灵"
		},
		{
			"id": 407,
			"type": 0,
			"school": 4,
			"icon": 1226,
			"describe": "【火元灵】",
			"command": "/技能 火元灵"
		},
		{
			"id": 408,
			"type": 0,
			"school": 4,
			"icon": 1227,
			"describe": "【冰元灵】",
			"command": "/技能 冰元灵"
		},
		{
			"id": 409,
			"type": 0,
			"school": 4,
			"icon": 1228,
			"describe": "【雷元灵】",
			"command": "/技能 雷元灵"
		},
		{
			"id": 410,
			"type": 0,
			"school": 4,
			"icon": 1204,
			"describe": "【灵袭】",
			"command": "/技能 灵袭"
		},
		{
			"id": 411,
			"type": 0,
			"school": 4,
			"icon": 1202,
			"describe": "【骤雷】",
			"command": "/技能 骤雷"
		},
		{
			"id": 412,
			"type": 0,
			"school": 4,
			"icon": 1202,
			"describe": "【骤雷二斩】",
			"command": "/技能 骤雷二斩"
		},
		{
			"id": 413,
			"type": 0,
			"school": 4,
			"icon": 1213,
			"describe": "【伐·星落】",
			"command": "/技能 伐·星落"
		},
		{
			"id": 414,
			"type": 0,
			"school": 4,
			"icon": 1212,
			"describe": "【定·星阵】",
			"command": "/技能 定·星阵"
		},
		{
			"id": 415,
			"type": 0,
			"school": 4,
			"icon": 1212,
			"describe": "【定·星阵二斩】",
			"command": "/技能 定·星阵二斩"
		},
		{
			"id": 416,
			"type": 0,
			"school": 4,
			"icon": 1212,
			"describe": "【定·星阵三斩】",
			"command": "/技能 定·星阵三斩"
		},
		{
			"id": 417,
			"type": 0,
			"school": 4,
			"icon": 1212,
			"describe": "【定·星阵四斩】",
			"command": "/技能 定·星阵四斩"
		},
		{
			"id": 418,
			"type": 0,
			"school": 4,
			"icon": 1216,
			"describe": "【佑·星体】",
			"command": "/技能 佑·星体"
		},
		{
			"id": 419,
			"type": 0,
			"school": 4,
			"icon": 1211,
			"describe": "【遁·流星】",
			"command": "/技能 遁·流星"
		},
		{
			"id": 420,
			"type": 0,
			"school": 4,
			"icon": 1214,
			"describe": "【裁·星剑】",
			"command": "/技能 裁·星剑"
		},
		{
			"id": 421,
			"type": 0,
			"school": 4,
			"icon": 1214,
			"describe": "【裁·星剑二斩】",
			"command": "/技能 裁·星剑二斩"
		},
		{
			"id": 422,
			"type": 0,
			"school": 4,
			"icon": 1215,
			"describe": "【临·星盾】",
			"command": "/技能 临·星盾"
		},
		{
			"id": 423,
			"type": 0,
			"school": 4,
			"icon": 1215,
			"describe": "【临·星盾二斩】",
			"command": "/技能 临·星盾二斩"
		},
		{
			"id": 424,
			"type": 0,
			"school": 4,
			"icon": 1244,
			"describe": "【万象·剑罚】",
			"command": "/技能 万象·剑罚"
		},
		{
			"id": 425,
			"type": 0,
			"school": 4,
			"icon": 1241,
			"describe": "【焚天·剑舞】",
			"command": "/技能 焚天·剑舞"
		},
		{
			"id": 426,
			"type": 0,
			"school": 4,
			"icon": 1243,
			"describe": "【离火·剑影】",
			"command": "/技能 离火·剑影"
		},
		{
			"id": 427,
			"type": 0,
			"school": 4,
			"icon": 1242,
			"describe": "【天火玄冰坠】",
			"command": "/技能 天火玄冰坠"
		},
		{
			"id": 428,
			"type": 0,
			"school": 4,
			"icon": 1263,
			"describe": "【星刃·闪】",
			"command": "/技能 星刃·闪"
		},
		{
			"id": 429,
			"type": 0,
			"school": 4,
			"icon": 1264,
			"describe": "【御风·流】",
			"command": "/技能 御风·流"
		},
		{
			"id": 430,
			"type": 0,
			"school": 4,
			"icon": 1262,
			"describe": "【虚空·禁】",
			"command": "/技能 虚空·禁"
		},
		{
			"id": 431,
			"type": 0,
			"school": 4,
			"icon": 1261,
			"describe": "【霜月锁千秋】",
			"command": "/技能 霜月锁千秋"
		},
		{
			"id": 432,
			"type": 0,
			"school": 4,
			"icon": 1230,
			"describe": "【霜月锁千秋二斩】",
			"command": "/技能 霜月锁千秋二斩"
		},
		{
			"id": 433,
			"type": 0,
			"school": 4,
			"icon": 1265,
			"describe": "【星流幻空影】",
			"command": "/技能 星流幻空影"
		},
		{
			"id": 434,
			"type": 0,
			"school": 4,
			"icon": 12451,
			"describe": "【苍摇玄天雷】",
			"command": "/技能 苍摇玄天雷 "
		},
		{
			"id": 501,
			"type": 0,
			"school": 5,
			"icon": 1301,
			"describe": "【斩风】",
			"command": "/技能 斩风"
		},
		{
			"id": 502,
			"type": 0,
			"school": 5,
			"icon": 1301,
			"describe": "【斩风二斩】",
			"command": "/技能 斩风二斩"
		},
		{
			"id": 503,
			"type": 0,
			"school": 5,
			"icon": 1301,
			"describe": "【斩风三斩】",
			"command": "/技能 斩风三斩"
		},
		{
			"id": 504,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀】",
			"command": "/技能 狂杀"
		},
		{
			"id": 505,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀二斩】",
			"command": "/技能 狂杀二斩"
		},
		{
			"id": 506,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀三斩】",
			"command": "/技能 狂杀三斩"
		},
		{
			"id": 507,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀四斩】",
			"command": "/技能 狂杀四斩"
		},
		{
			"id": 508,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀五斩】",
			"command": "/技能 狂杀五斩"
		},
		{
			"id": 509,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀六斩】",
			"command": "/技能 狂杀六斩"
		},
		{
			"id": 510,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀七斩】",
			"command": "/技能 狂杀七斩"
		},
		{
			"id": 511,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀八斩】",
			"command": "/技能 狂杀八斩"
		},
		{
			"id": 512,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀九斩】",
			"command": "/技能 狂杀九斩"
		},
		{
			"id": 513,
			"type": 0,
			"school": 5,
			"icon": 1304,
			"describe": "【狂杀最终斩】",
			"command": "/技能 狂杀最终斩"
		},
		{
			"id": 514,
			"type": 0,
			"school": 5,
			"icon": 1313,
			"describe": "【斩青云】",
			"command": "/技能 斩青云"
		},
		{
			"id": 515,
			"type": 0,
			"school": 5,
			"icon": 1303,
			"describe": "【战意诀】",
			"command": "/技能 战意诀"
		},
		{
			"id": 516,
			"type": 0,
			"school": 5,
			"icon": 1317,
			"describe": "【战意之姿】",
			"command": "/技能 战意之姿"
		},
		{
			"id": 517,
			"type": 0,
			"school": 5,
			"icon": 1319,
			"describe": "【破空斩】",
			"command": "/技能 破空斩"
		},
		{
			"id": 518,
			"type": 0,
			"school": 5,
			"icon": 1316,
			"describe": "【破影】",
			"command": "/技能 破影"
		},
		{
			"id": 519,
			"type": 0,
			"school": 5,
			"icon": 1316,
			"describe": "【破影二斩】",
			"command": "/技能 破影二斩"
		},
		{
			"id": 520,
			"type": 0,
			"school": 5,
			"icon": 1316,
			"describe": "【破影三斩】",
			"command": "/技能 破影三斩"
		},
		{
			"id": 521,
			"type": 0,
			"school": 5,
			"icon": 1316,
			"describe": "【破影四斩】",
			"command": "/技能 破影四斩"
		},
		{
			"id": 522,
			"type": 0,
			"school": 5,
			"icon": 1302,
			"describe": "【追命】",
			"command": "/技能 追命"
		},
		{
			"id": 523,
			"type": 0,
			"school": 5,
			"icon": 1302,
			"describe": "【追命二斩】",
			"command": "/技能 追命二斩"
		},
		{
			"id": 524,
			"type": 0,
			"school": 5,
			"icon": 1314,
			"describe": "【不动山】",
			"command": "/技能 不动山"
		},
		{
			"id": 525,
			"type": 0,
			"school": 5,
			"icon": 1314,
			"describe": "【不动山反击】",
			"command": "/技能 不动山反击"
		},
		{
			"id": 526,
			"type": 0,
			"school": 5,
			"icon": 1311,
			"describe": "【定风波】",
			"command": "/技能 定风波"
		},
		{
			"id": 527,
			"type": 0,
			"school": 5,
			"icon": 1311,
			"describe": "【定风波二斩】",
			"command": "/技能 定风波二斩"
		},
		{
			"id": 528,
			"type": 0,
			"school": 5,
			"icon": 1312,
			"describe": "【破月】",
			"command": "/技能 破月"
		},
		{
			"id": 529,
			"type": 0,
			"school": 5,
			"icon": 1305,
			"describe": "【猎光】",
			"command": "/技能 猎光"
		},
		{
			"id": 530,
			"type": 0,
			"school": 5,
			"icon": 1306,
			"describe": "【血绽诀】",
			"command": "/技能 血绽诀"
		},
		{
			"id": 531,
			"type": 0,
			"school": 5,
			"icon": 1345,
			"describe": "【瞬杀·暗月】",
			"command": "/技能 瞬杀·暗月"
		},
		{
			"id": 532,
			"type": 0,
			"school": 5,
			"icon": 1347,
			"describe": "【凌杀·飞羽】",
			"command": "/技能 凌杀·飞羽"
		},
		{
			"id": 533,
			"type": 0,
			"school": 5,
			"icon": 1340,
			"describe": "【闪杀·幻刃】",
			"command": "/技能 闪杀·幻刃"
		},
		{
			"id": 534,
			"type": 0,
			"school": 5,
			"icon": 1342,
			"describe": "【千刃·散浮华】",
			"command": "/技能 千刃·散浮华"
		},
		{
			"id": 535,
			"type": 0,
			"school": 5,
			"icon": 1362,
			"describe": "【斩风雷】",
			"command": "/技能 斩风雷"
		},
		{
			"id": 536,
			"type": 0,
			"school": 5,
			"icon": 1361,
			"describe": "【斩流火】",
			"command": "/技能 斩流火"
		},
		{
			"id": 537,
			"type": 0,
			"school": 5,
			"icon": 1343,
			"describe": "【斩晴空】",
			"command": "/技能 斩晴空"
		},
		{
			"id": 538,
			"type": 0,
			"school": 5,
			"icon": 1343,
			"describe": "【斩晴空二斩】",
			"command": "/技能 斩晴空二斩"
		},
		{
			"id": 539,
			"type": 0,
			"school": 5,
			"icon": 1346,
			"describe": "【灭魄·封神斩】",
			"command": "/技能 灭魄·封神斩"
		},
		{
			"id": 540,
			"type": 0,
			"school": 5,
			"icon": 1363,
			"describe": "【断情·月轮斩】",
			"command": "/技能 断情·月轮斩"
		},
		{
			"id": 541,
			"type": 0,
			"school": 5,
			"icon": 1344,
			"describe": "【疾杀·碎惊风】",
			"command": "/技能 疾杀·碎惊风"
		},
		{
			"id": 601,
			"type": 0,
			"school": 6,
			"icon": 1501,
			"describe": "【疾风弹】",
			"command": "/技能 疾风弹"
		},
		{
			"id": 602,
			"type": 0,
			"school": 6,
			"icon": 1503,
			"describe": "【震荡弹】",
			"command": "/技能 震荡弹"
		},
		{
			"id": 603,
			"type": 0,
			"school": 6,
			"icon": 1512,
			"describe": "【震地雷】",
			"command": "/技能 震地雷"
		},
		{
			"id": 604,
			"type": 0,
			"school": 6,
			"icon": 1504,
			"describe": "【黯灭弹】",
			"command": "/技能 黯灭弹"
		},
		{
			"id": 605,
			"type": 0,
			"school": 6,
			"icon": 1502,
			"describe": "【穿云弹】",
			"command": "/技能 穿云弹"
		},
		{
			"id": 606,
			"type": 0,
			"school": 6,
			"icon": 1513,
			"describe": "【螺旋刃】",
			"command": "/技能 螺旋刃"
		},
		{
			"id": 607,
			"type": 0,
			"school": 6,
			"icon": 1505,
			"describe": "【狙杀模式】",
			"command": "/技能 狙杀模式"
		},
		{
			"id": 608,
			"type": 0,
			"school": 6,
			"icon": 1519,
			"describe": "【炎光傀儡】",
			"command": "/技能 炎光傀儡"
		},
		{
			"id": 609,
			"type": 0,
			"school": 6,
			"icon": 1511,
			"describe": "【暗诡雷】",
			"command": "/技能 暗诡雷"
		},
		{
			"id": 610,
			"type": 0,
			"school": 6,
			"icon": 1511,
			"describe": "【暗诡雷二斩】",
			"command": "/技能 暗诡雷二斩"
		},
		{
			"id": 611,
			"type": 0,
			"school": 6,
			"icon": 1517,
			"describe": "【烈性炸药】",
			"command": "/技能 烈性炸药"
		},
		{
			"id": 612,
			"type": 0,
			"school": 6,
			"icon": 1518,
			"describe": "【寒性炸药】",
			"command": "/技能 寒性炸药"
		},
		{
			"id": 613,
			"type": 0,
			"school": 6,
			"icon": 1514,
			"describe": "【魔能甲】",
			"command": "/技能 魔能甲"
		},
		{
			"id": 614,
			"type": 0,
			"school": 6,
			"icon": 1514,
			"describe": "【魔能甲二斩】",
			"command": "/技能 魔能甲二斩"
		},
		{
			"id": 615,
			"type": 0,
			"school": 6,
			"icon": 1506,
			"describe": "【死亡标记】",
			"command": "/技能 死亡标记"
		},
		{
			"id": 616,
			"type": 0,
			"school": 6,
			"icon": 1515,
			"describe": "【聚能】",
			"command": "/技能 聚能"
		},
		{
			"id": 617,
			"type": 0,
			"school": 6,
			"icon": 1541,
			"describe": "【死亡狙击】",
			"command": "/技能 死亡狙击"
		},
		{
			"id": 618,
			"type": 0,
			"school": 6,
			"icon": 1542,
			"describe": "【杀戮风暴】",
			"command": "/技能 杀戮风暴"
		},
		{
			"id": 619,
			"type": 0,
			"school": 6,
			"icon": 1543,
			"describe": "【毁灭连爆】",
			"command": "/技能 毁灭连爆"
		},
		{
			"id": 620,
			"type": 0,
			"school": 6,
			"icon": 1544,
			"describe": "【爆裂流星·天火】",
			"command": "/技能 爆裂流星·天火"
		},
		{
			"id": 621,
			"type": 0,
			"school": 6,
			"icon": 1545,
			"describe": "【追命链狙·业火】",
			"command": "/技能 追命链狙·业火"
		},
		{
			"id": 622,
			"type": 0,
			"school": 6,
			"icon": 1562,
			"describe": "【黑铁·刀山】",
			"command": "/技能 黑铁·刀山"
		},
		{
			"id": 623,
			"type": 0,
			"school": 6,
			"icon": 1568,
			"describe": "【蓝钢·狱牙】",
			"command": "/技能 蓝钢·狱牙"
		},
		{
			"id": 624,
			"type": 0,
			"school": 6,
			"icon": 1569,
			"describe": "【利刃傀儡】",
			"command": "/技能 利刃傀儡"
		},
		{
			"id": 625,
			"type": 0,
			"school": 6,
			"icon": 1570,
			"describe": "【战争铁甲】",
			"command": "/技能 战争铁甲"
		},
		{
			"id": 626,
			"type": 0,
			"school": 6,
			"icon": 1563,
			"describe": "【灭屠战机】",
			"command": "/技能 灭屠战机"
		},
		{
			"id": 627,
			"type": 0,
			"school": 6,
			"icon": 1563,
			"describe": "【灭屠战机二段】",
			"command": "/技能 灭屠战机二段"
		},
		{
			"id": 701,
			"type": 0,
			"school": 7,
			"icon": 1401,
			"describe": "【灵击】",
			"command": "/技能 灵击"
		},
		{
			"id": 702,
			"type": 0,
			"school": 7,
			"icon": 1402,
			"describe": "【青鸟】",
			"command": "/技能 青鸟"
		},
		{
			"id": 703,
			"type": 0,
			"school": 7,
			"icon": 1402,
			"describe": "【青鸟二斩】",
			"command": "/技能 青鸟二斩"
		},
		{
			"id": 704,
			"type": 0,
			"school": 7,
			"icon": 1406,
			"describe": "【飞萤】",
			"command": "/技能 飞萤"
		},
		{
			"id": 705,
			"type": 0,
			"school": 7,
			"icon": 1411,
			"describe": "【春风】",
			"command": "/技能 春风"
		},
		{
			"id": 706,
			"type": 0,
			"school": 7,
			"icon": 1411,
			"describe": "【春风】（自我施法）",
			"command": "/技能 [自我施法] 春风"
		},
		{
			"id": 707,
			"type": 0,
			"school": 7,
			"icon": 1405,
			"describe": "【鱼跃】",
			"command": "/技能 鱼跃"
		},
		{
			"id": 708,
			"type": 0,
			"school": 7,
			"icon": 1405,
			"describe": "【鱼跃二斩】",
			"command": "/技能 鱼跃二斩"
		},
		{
			"id": 709,
			"type": 0,
			"school": 7,
			"icon": 1413,
			"describe": "【落樱】",
			"command": "/技能 落樱"
		},
		{
			"id": 710,
			"type": 0,
			"school": 7,
			"icon": 1413,
			"describe": "【落樱】（自我施法）",
			"command": "/技能 [自我施法] 落樱"
		},
		{
			"id": 711,
			"type": 0,
			"school": 7,
			"icon": 1412,
			"describe": "【青蔓】",
			"command": "/技能 青蔓"
		},
		{
			"id": 712,
			"type": 0,
			"school": 7,
			"icon": 1414,
			"describe": "【羽化】",
			"command": "/技能 羽化"
		},
		{
			"id": 713,
			"type": 0,
			"school": 7,
			"icon": 1414,
			"describe": "【羽化·灵】",
			"command": "/技能 羽化·灵"
		},
		{
			"id": 714,
			"type": 0,
			"school": 7,
			"icon": 1416,
			"describe": "【白露】",
			"command": "/技能 白露"
		},
		{
			"id": 715,
			"type": 0,
			"school": 7,
			"icon": 1416,
			"describe": "【白露】（自我施法）",
			"command": "/技能 [自我施法] 白露"
		},
		{
			"id": 716,
			"type": 0,
			"school": 7,
			"icon": 1404,
			"describe": "【灵化】",
			"command": "/技能 灵化"
		},
		{
			"id": 717,
			"type": 0,
			"school": 7,
			"icon": 1403,
			"describe": "【灵甲】",
			"command": "/技能 灵甲"
		},
		{
			"id": 718,
			"type": 0,
			"school": 7,
			"icon": 1403,
			"describe": "【灵甲】（自我施法）",
			"command": "/技能 [自我施法] 灵甲"
		},
		{
			"id": 719,
			"type": 0,
			"school": 7,
			"icon": 1403,
			"describe": "【灵甲二斩】",
			"command": "/技能 灵甲二斩"
		},
		{
			"id": 720,
			"type": 0,
			"school": 7,
			"icon": 1415,
			"describe": "【芊心】",
			"command": "/技能 芊心"
		},
		{
			"id": 721,
			"type": 0,
			"school": 7,
			"icon": 1447,
			"describe": "【鹿奔袭】",
			"command": "/技能 鹿奔袭"
		},
		{
			"id": 722,
			"type": 0,
			"school": 7,
			"icon": 1442,
			"describe": "【蛇缠藤】",
			"command": "/技能 蛇缠藤"
		},
		{
			"id": 723,
			"type": 0,
			"school": 7,
			"icon": 1441,
			"describe": "【鹰翼击】",
			"command": "/技能 鹰翼击"
		},
		{
			"id": 724,
			"type": 0,
			"school": 7,
			"icon": 1443,
			"describe": "【灵猿·啸空山】",
			"command": "/技能 灵猿·啸空山"
		},
		{
			"id": 725,
			"type": 0,
			"school": 7,
			"icon": 1462,
			"describe": "【月落甘霖】",
			"command": "/技能 月落甘霖"
		},
		{
			"id": 726,
			"type": 0,
			"school": 7,
			"icon": 1464,
			"describe": "【花游风间】",
			"command": "/技能 花游风间"
		},
		{
			"id": 727,
			"type": 0,
			"school": 7,
			"icon": 1464,
			"describe": "【花游风间】（自我施法）",
			"command": "/技能 [自我施法] 花游风间"
		},
		{
			"id": 728,
			"type": 0,
			"school": 7,
			"icon": 1461,
			"describe": "【花灵吐蕊】",
			"command": "/技能 花灵吐蕊"
		},
		{
			"id": 729,
			"type": 0,
			"school": 7,
			"icon": 1468,
			"describe": "【莲华·千叶舞】",
			"command": "/技能 莲华·千叶舞"
		},
		{
			"id": 730,
			"type": 0,
			"school": 7,
			"icon": 1463,
			"describe": "【灵佑·万物生】",
			"command": "/技能 灵佑·万物生"
		},
		{
			"id": 731,
			"type": 0,
			"school": 7,
			"icon": 1444,
			"describe": "【梦蝶·舞长天】",
			"command": "/技能 梦蝶·舞长天"
		},
		{
			"id": 801,
			"type": 0,
			"school": 8,
			"icon": 16022,
			"describe": "【魂击】",
			"command": "/技能 魂击"
		},
		{
			"id": 802,
			"type": 0,
			"school": 8,
			"icon": 16022,
			"describe": "【魂击】（自我施法）",
			"command": "/技能 [自我施法] 魂击"
		},
		{
			"id": 803,
			"type": 0,
			"school": 8,
			"icon": 16032,
			"describe": "【魂爆】",
			"command": "/技能 魂爆"
		},
		{
			"id": 804,
			"type": 0,
			"school": 8,
			"icon": 16032,
			"describe": "【魂爆】（自我施法）",
			"command": "/技能 [自我施法] 魂爆"
		},
		{
			"id": 805,
			"type": 0,
			"school": 8,
			"icon": 16152,
			"describe": "【魂珠】",
			"command": "/技能 魂珠"
		},
		{
			"id": 806,
			"type": 0,
			"school": 8,
			"icon": 16042,
			"describe": "【魂域】",
			"command": "/技能 魂域"
		},
		{
			"id": 807,
			"type": 0,
			"school": 8,
			"icon": 16062,
			"describe": "【追魂之魄】",
			"command": "/技能 追魂之魄"
		},
		{
			"id": 808,
			"type": 0,
			"school": 8,
			"icon": 16062,
			"describe": "【追魂之魄二斩】",
			"command": "/技能 追魂之魄二斩"
		},
		{
			"id": 809,
			"type": 0,
			"school": 8,
			"icon": 16112,
			"describe": "【魂镜】",
			"command": "/技能 魂镜"
		},
		{
			"id": 810,
			"type": 0,
			"school": 8,
			"icon": 16012,
			"describe": "【转魂】",
			"command": "/技能 转魂"
		},
		{
			"id": 811,
			"type": 0,
			"school": 8,
			"icon": 16142,
			"describe": "【破碎虚空】",
			"command": "/技能 破碎虚空"
		},
		{
			"id": 812,
			"type": 0,
			"school": 8,
			"icon": 16162,
			"describe": "【轮回之门】",
			"command": "/技能 轮回之门"
		},
		{
			"id": 813,
			"type": 0,
			"school": 8,
			"icon": 16052,
			"describe": "【离魂归位】",
			"command": "/技能 离魂归位"
		},
		{
			"id": 814,
			"type": 0,
			"school": 8,
			"icon": 16052,
			"describe": "【离魂归位二斩】",
			"command": "/技能 离魂归位二斩"
		},
		{
			"id": 815,
			"type": 0,
			"school": 8,
			"icon": 16132,
			"describe": "【灵魂之禁】",
			"command": "/技能 灵魂之禁"
		},
		{
			"id": 816,
			"type": 0,
			"school": 8,
			"icon": 16132,
			"describe": "【灵魂之禁】（自我施法）",
			"command": "/技能 [自我施法] 灵魂之禁"
		},
		{
			"id": 817,
			"type": 0,
			"school": 8,
			"icon": 16132,
			"describe": "【灵魂之禁二斩】",
			"command": "/技能 灵魂之禁二斩"
		},
		{
			"id": 818,
			"type": 0,
			"school": 8,
			"icon": 16122,
			"describe": "【虚空流转】",
			"command": "/技能 虚空流转"
		},
		{
			"id": 819,
			"type": 0,
			"school": 8,
			"icon": 1667,
			"describe": "【幽夜暗握】",
			"command": "/技能 幽夜暗握"
		},
		{
			"id": 820,
			"type": 0,
			"school": 8,
			"icon": 1662,
			"describe": "【死神过境】",
			"command": "/技能 死神过境"
		},
		{
			"id": 821,
			"type": 0,
			"school": 8,
			"icon": 1661,
			"describe": "【引魂离殇】",
			"command": "/技能 引魂离殇"
		},
		{
			"id": 822,
			"type": 0,
			"school": 8,
			"icon": 1668,
			"describe": "【一念堕魔】",
			"command": "/技能 一念堕魔"
		},
		{
			"id": 823,
			"type": 0,
			"school": 8,
			"icon": 1663,
			"describe": "【万魂俱寂】",
			"command": "/技能 万魂俱寂"
		},
		{
			"id": 824,
			"type": 0,
			"school": 8,
			"icon": 1646,
			"describe": "【极光之触】",
			"command": "/技能 极光之触"
		},
		{
			"id": 825,
			"type": 0,
			"school": 8,
			"icon": 1647,
			"describe": "【沐光之念】",
			"command": "/技能 沐光之念"
		},
		{
			"id": 826,
			"type": 0,
			"school": 8,
			"icon": 1641,
			"describe": "【涅槃之穹】",
			"command": "/技能 涅槃之穹"
		},
		{
			"id": 827,
			"type": 0,
			"school": 8,
			"icon": 1641,
			"describe": "【涅槃之穹】（自我施法）",
			"command": "/技能 [自我施法] 涅槃之穹"
		},
		{
			"id": 828,
			"type": 0,
			"school": 8,
			"icon": 1643,
			"describe": "【一念成神】",
			"command": "/技能 一念成神"
		},
		{
			"id": 829,
			"type": 0,
			"school": 8,
			"icon": 1645,
			"describe": "【移光引魂】",
			"command": "/技能 移光引魂"
		},
		{
			"id": 901,
			"type": 0,
			"school": 9,
			"icon": 1701,
			"describe": "【刃刺】",
			"command": "/技能 刃刺"
		},
		{
			"id": 902,
			"type": 0,
			"school": 9,
			"icon": 1701,
			"describe": "【刃刺二斩】",
			"command": "/技能 刃刺二斩"
		},
		{
			"id": 903,
			"type": 0,
			"school": 9,
			"icon": 1701,
			"describe": "【刃刺三斩】",
			"command": "/技能 刃刺三斩"
		},
		{
			"id": 904,
			"type": 0,
			"school": 9,
			"icon": 1701,
			"describe": "【刃刺四斩】",
			"command": "/技能 刃刺四斩"
		},
		{
			"id": 905,
			"type": 0,
			"school": 9,
			"icon": 1711,
			"describe": "【链击】",
			"command": "/技能 链击"
		},
		{
			"id": 906,
			"type": 0,
			"school": 9,
			"icon": 1711,
			"describe": "【链击二斩】",
			"command": "/技能 链击二斩"
		},
		{
			"id": 907,
			"type": 0,
			"school": 9,
			"icon": 1711,
			"describe": "【链击三斩】",
			"command": "/技能 链击三斩"
		},
		{
			"id": 908,
			"type": 0,
			"school": 9,
			"icon": 1711,
			"describe": "【链击四斩】",
			"command": "/技能 链击四斩"
		},
		{
			"id": 909,
			"type": 0,
			"school": 9,
			"icon": 1705,
			"describe": "【血刺】",
			"command": "/技能 血刺"
		},
		{
			"id": 910,
			"type": 0,
			"school": 9,
			"icon": 1716,
			"describe": "【毒体】",
			"command": "/技能 毒体"
		},
		{
			"id": 911,
			"type": 0,
			"school": 9,
			"icon": 1791,
			"describe": "【毒刃】",
			"command": "/技能 毒刃"
		},
		{
			"id": 912,
			"type": 0,
			"school": 9,
			"icon": 1713,
			"describe": "【链袭】",
			"command": "/技能 链袭"
		},
		{
			"id": 913,
			"type": 0,
			"school": 9,
			"icon": 1702,
			"describe": "【影杀】",
			"command": "/技能 影杀"
		},
		{
			"id": 914,
			"type": 0,
			"school": 9,
			"icon": 1714,
			"describe": "【潜影】",
			"command": "/技能 潜影"
		},
		{
			"id": 915,
			"type": 0,
			"school": 9,
			"icon": 1790,
			"describe": "【瞬影】",
			"command": "/技能 瞬影"
		},
		{
			"id": 916,
			"type": 0,
			"school": 9,
			"icon": 1715,
			"describe": "【链舞】",
			"command": "/技能 链舞"
		},
		{
			"id": 917,
			"type": 0,
			"school": 9,
			"icon": 1703,
			"describe": "【影袭】",
			"command": "/技能 影袭"
		},
		{
			"id": 918,
			"type": 0,
			"school": 9,
			"icon": 1712,
			"describe": "【链缚】",
			"command": "/技能 链缚"
		},
		{
			"id": 919,
			"type": 0,
			"school": 9,
			"icon": 1704,
			"describe": "【旋刃】",
			"command": "/技能 旋刃"
		},
		{
			"id": 920,
			"type": 0,
			"school": 9,
			"icon": 1706,
			"describe": "【疾影】",
			"command": "/技能 疾影"
		},
		{
			"id": 921,
			"type": 0,
			"school": 9,
			"icon": 1741,
			"describe": "【刃·致命】",
			"command": "/技能 刃·致命"
		},
		{
			"id": 922,
			"type": 0,
			"school": 9,
			"icon": 1742,
			"describe": "【化影·伏杀】",
			"command": "/技能 化影·伏杀"
		},
		{
			"id": 923,
			"type": 0,
			"school": 9,
			"icon": 1743,
			"describe": "【化影·绝杀】",
			"command": "/技能 化影·绝杀"
		},
		{
			"id": 924,
			"type": 0,
			"school": 9,
			"icon": 1745,
			"describe": "【戮·神灭】",
			"command": "/技能 戮·神灭"
		},
		{
			"id": 925,
			"type": 0,
			"school": 9,
			"icon": 1744,
			"describe": "【戮·神陨】",
			"command": "/技能 戮·神陨"
		},
		{
			"id": 926,
			"type": 0,
			"school": 9,
			"icon": 1761,
			"describe": "【链·囚罪】",
			"command": "/技能 链·囚罪"
		},
		{
			"id": 927,
			"type": 0,
			"school": 9,
			"icon": 1762,
			"describe": "【影·遁形】",
			"command": "/技能 影·遁形"
		},
		{
			"id": 928,
			"type": 0,
			"school": 9,
			"icon": 1763,
			"describe": "【化影·裂地】",
			"command": "/技能 化影·裂地"
		},
		{
			"id": 929,
			"type": 0,
			"school": 9,
			"icon": 1764,
			"describe": "【戮·神囚】",
			"command": "/技能 戮·神囚"
		},
		{
			"id": 930,
			"type": 0,
			"school": 9,
			"icon": 1765,
			"describe": "【追影·夺魂】",
			"command": "/技能 追影·夺魂"
		},
		{
			"id": 1000,
			"type": 0,
			"school": 0,
			"icon": 50001,
			"describe": "【英灵急呼】",
			"command": "/英灵技能 英灵急呼"
		},
		{
			"id": 1001,
			"type": 0,
			"school": 0,
			"icon": 50002,
			"describe": "【英灵觉醒技】",
			"command": "/英灵技能 英灵觉醒技"
		},
		{
			"id": 1101,
			"type": 0,
			"school": 10,
			"icon": 1901,
			"describe": "【月碎】",
			"command": "/技能 月碎"
		},
		{
			"id": 1102,
			"type": 0,
			"school": 10,
			"icon": 1901,
			"describe": "【月碎二斩】",
			"command": "/技能 月碎二斩"
		},
		{
			"id": 1103,
			"type": 0,
			"school": 10,
			"icon": 1901,
			"describe": "【月碎三斩】",
			"command": "/技能 月碎三斩"
		},
		{
			"id": 1104,
			"type": 0,
			"school": 10,
			"icon": 1901,
			"describe": "【月碎四斩】",
			"command": "/技能 月碎四斩"
		},
		{
			"id": 1105,
			"type": 0,
			"school": 10,
			"icon": 1902,
			"describe": "【鳞追】",
			"command": "/技能 鳞追"
		},
		{
			"id": 1106,
			"type": 0,
			"school": 10,
			"icon": 1904,
			"describe": "【剑·龙旋】",
			"command": "/技能 剑·龙旋"
		},
		{
			"id": 1107,
			"type": 0,
			"school": 10,
			"icon": 1905,
			"describe": "【剑·杀合】",
			"command": "/技能 剑·杀合"
		},
		{
			"id": 1108,
			"type": 0,
			"school": 10,
			"icon": 1907,
			"describe": "【凌突】",
			"command": "/技能 凌突"
		},
		{
			"id": 1109,
			"type": 0,
			"school": 10,
			"icon": 1907,
			"describe": "【凌突二斩】",
			"command": "/技能 凌突二斩"
		},
		{
			"id": 1110,
			"type": 0,
			"school": 10,
			"icon": 1906,
			"describe": "【风裂】",
			"command": "/技能 风裂"
		},
		{
			"id": 1111,
			"type": 0,
			"school": 10,
			"icon": 1906,
			"describe": "【风裂二斩】",
			"command": "/技能 风裂二斩"
		},
		{
			"id": 1112,
			"type": 0,
			"school": 10,
			"icon": 1908,
			"describe": "【化龙】",
			"command": "/技能 化龙"
		},
		{
			"id": 1113,
			"type": 0,
			"school": 10,
			"icon": 1903,
			"describe": "【龙·游世】",
			"command": "/技能 龙·游世"
		},
		{
			"id": 1114,
			"type": 0,
			"school": 10,
			"icon": 1909,
			"describe": "【龙·天返】",
			"command": "/技能 龙·天返"
		},
		{
			"id": 1115,
			"type": 0,
			"school": 10,
			"icon": 1909,
			"describe": "【龙·天返二斩】",
			"command": "/技能 龙·天返二斩"
		},
		{
			"id": 1116,
			"type": 0,
			"school": 10,
			"icon": 1910,
			"describe": "【英域】",
			"command": "/技能 英域"
		},
		{
			"id": 1117,
			"type": 0,
			"school": 10,
			"icon": 1911,
			"describe": "【剑·如龙】",
			"command": "/技能 剑·如龙"
		},
		{
			"id": 1118,
			"type": 0,
			"school": 10,
			"icon": 1912,
			"describe": "【龙·战甲】",
			"command": "/技能 龙·战甲"
		},
		{
			"id": 1119,
			"type": 0,
			"school": 10,
			"icon": 1913,
			"describe": "【剑曲·月华】",
			"command": "/技能 剑曲·月华"
		},
		{
			"id": 1120,
			"type": 0,
			"school": 10,
			"icon": 1914,
			"describe": "【剑啸·奔云】",
			"command": "/技能 剑啸·奔云"
		},
		{
			"id": 1121,
			"type": 0,
			"school": 10,
			"icon": 1914,
			"describe": "【剑啸·奔云二斩】",
			"command": "/技能 剑啸·奔云二斩"
		},
		{
			"id": 1122,
			"type": 0,
			"school": 10,
			"icon": 1916,
			"describe": "【剑啸·天绝】",
			"command": "/技能 剑啸·天绝"
		},
		{
			"id": 1123,
			"type": 0,
			"school": 10,
			"icon": 1917,
			"describe": "【剑指·湍流怒】",
			"command": "/技能 剑指·湍流怒"
		},
		{
			"id": 1124,
			"type": 0,
			"school": 10,
			"icon": 1915,
			"describe": "【剑怒·地龙威】",
			"command": "/技能 剑怒·地龙威"
		},
		{
			"id": 1125,
			"type": 0,
			"school": 10,
			"icon": 1918,
			"describe": "【龙吟·奔流】",
			"command": "/技能 龙吟·奔流"
		},
		{
			"id": 1126,
			"type": 0,
			"school": 10,
			"icon": 1919,
			"describe": "【龙吟·惊鳞】",
			"command": "/技能 龙吟·惊鳞"
		},
		{
			"id": 1127,
			"type": 0,
			"school": 10,
			"icon": 1920,
			"describe": "【龙吟·燃心】",
			"command": "/技能 龙吟·燃心"
		},
		{
			"id": 1128,
			"type": 0,
			"school": 10,
			"icon": 1921,
			"describe": "【龙耀·天击世】",
			"command": "/技能 龙耀·天击世"
		},
		{
			"id": 1129,
			"type": 0,
			"school": 10,
			"icon": 1921,
			"describe": "【龙耀·天击世二斩】",
			"command": "/技能 龙耀·天击世二斩"
		},
		{
			"id": 1130,
			"type": 0,
			"school": 10,
			"icon": 1922,
			"describe": "【龙律·时逆卷】",
			"command": "/技能 龙律·时逆卷"
		},
		{
			"id": 1201,
			"type": 0,
			"school": 11,
			"icon": 2110,
			"describe": "【翎击】",
			"command": "/技能 翎击"
		},
		{
			"id": 1202,
			"type": 0,
			"school": 11,
			"icon": 2110,
			"describe": "【翎击二斩】",
			"command": "/技能 翎击二斩"
		},
		{
			"id": 1203,
			"type": 0,
			"school": 11,
			"icon": 2110,
			"describe": "【翎击三斩】",
			"command": "/技能 翎击三斩"
		},
		{
			"id": 1204,
			"type": 0,
			"school": 11,
			"icon": 2110,
			"describe": "【翎击四斩】",
			"command": "/技能 翎击四斩"
		},
		{
			"id": 1205,
			"type": 0,
			"school": 11,
			"icon": 2114,
			"describe": "【天狩光轮】",
			"command": "/技能 天狩光轮"
		},
		{
			"id": 1206,
			"type": 0,
			"school": 11,
			"icon": 2115,
			"describe": "【破冥】",
			"command": "/技能 破冥"
		},
		{
			"id": 1207,
			"type": 0,
			"school": 11,
			"icon": 2116,
			"describe": "【锁厄】",
			"command": "/技能 锁厄"
		},
		{
			"id": 1208,
			"type": 0,
			"school": 11,
			"icon": 2117,
			"describe": "【鸿落】",
			"command": "/技能 鸿落"
		},
		{
			"id": 1209,
			"type": 0,
			"school": 11,
			"icon": 2118,
			"describe": "【风旋刃】",
			"command": "/技能 风旋刃"
		},
		{
			"id": 1210,
			"type": 0,
			"school": 11,
			"icon": 2119,
			"describe": "【裂穹斩】",
			"command": "/技能 裂穹斩"
		},
		{
			"id": 1211,
			"type": 0,
			"school": 11,
			"icon": 2120,
			"describe": "【帝·裂穹斩】",
			"command": "/技能 帝·裂穹斩"
		},
		{
			"id": 1212,
			"type": 0,
			"school": 11,
			"icon": 2121,
			"describe": "【华绽天羽】",
			"command": "/技能 华绽天羽"
		},
		{
			"id": 1213,
			"type": 0,
			"school": 11,
			"icon": 2122,
			"describe": "【光影瞬袭】",
			"command": "/技能 光影瞬袭"
		},
		{
			"id": 1214,
			"type": 0,
			"school": 11,
			"icon": 2123,
			"describe": "【呼啸深空】",
			"command": "/技能 呼啸深空"
		},
		{
			"id": 1215,
			"type": 0,
			"school": 11,
			"icon": 2124,
			"describe": "【同光凭神】",
			"command": "/技能 同光凭神"
		},
		{
			"id": 1216,
			"type": 0,
			"school": 11,
			"icon": 2125,
			"describe": "【镇光囚笼】",
			"command": "/技能 镇光囚笼"
		},
		{
			"id": 1217,
			"type": 0,
			"school": 11,
			"icon": 2126,
			"describe": "【帝·裁决再临】",
			"command": "/技能 帝·裁决再临"
		},
		{
			"id": 1218,
			"type": 0,
			"school": 11,
			"icon": 2127,
			"describe": "【惊鸿掠影】",
			"command": "/技能 惊鸿掠影"
		},
		{
			"id": 1219,
			"type": 0,
			"school": 11,
			"icon": 2129,
			"describe": "【翎羽绝阵】",
			"command": "/技能 翎羽绝阵"
		},
		{
			"id": 1220,
			"type": 0,
			"school": 11,
			"icon": 2130,
			"describe": "【帝·翎羽绝阵】",
			"command": "/技能 帝·翎羽绝阵"
		},
		{
			"id": 1221,
			"type": 0,
			"school": 11,
			"icon": 2131,
			"describe": "【天祈·旋光】",
			"command": "/技能 天祈·旋光"
		},
		{
			"id": 1222,
			"type": 0,
			"school": 11,
			"icon": 2131,
			"describe": "【天祈·旋光二斩】",
			"command": "/技能 天祈·旋光二斩"
		},
		{
			"id": 1223,
			"type": 0,
			"school": 11,
			"icon": 2132,
			"describe": "【天命·束身之矛】",
			"command": "/技能 天命·束身之矛"
		},
		{
			"id": 1224,
			"type": 0,
			"school": 11,
			"icon": 2133,
			"describe": "【天剑·徊刃】",
			"command": "/技能 天剑·徊刃"
		},
		{
			"id": 1225,
			"type": 0,
			"school": 11,
			"icon": 2133,
			"describe": "【天剑·徊刃二斩】",
			"command": "/技能 天剑·徊刃二斩"
		},
		{
			"id": 1226,
			"type": 0,
			"school": 11,
			"icon": 2134,
			"describe": "【天命·三重羽袭】",
			"command": "/技能 天命·三重羽袭"
		},
		{
			"id": 1227,
			"type": 0,
			"school": 11,
			"icon": 2135,
			"describe": "【天剑·撼斩】",
			"command": "/技能 天剑·撼斩"
		},
		{
			"id": 1228,
			"type": 0,
			"school": 11,
			"icon": 2136,
			"describe": "【神令·高天剑笼】",
			"command": "/技能 神令·高天剑笼"
		},
		{
			"id": 1229,
			"type": 0,
			"school": 11,
			"icon": 2137,
			"describe": "【神罚·曙光照夜】",
			"command": "/技能 神罚·曙光照夜"
		},
		{
			"id": 1230,
			"type": 0,
			"school": 11,
			"icon": 2138,
			"describe": "【神罚·天光凝锋】",
			"command": "/技能 神罚·天光凝锋"
		},
		{
			"id": 1231,
			"type": 0,
			"school": 11,
			"icon": 2139,
			"describe": "【神命·弥涅瓦之佑】",
			"command": "/技能 神命·弥涅瓦之佑"
		},
		{
			"id": 1232,
			"type": 0,
			"school": 11,
			"icon": 2140,
			"describe": "【神命·白帝之威临】",
			"command": "/技能 神命·白帝之威临"
		},
		{
			"id": 1233,
			"type": 0,
			"school": 11,
			"icon": 2140,
			"describe": "【消·白帝之威临】",
			"command": "/技能 消·白帝之威临"
		},
		{
			"id": 2000,
			"type": 1,
			"school": 0,
			"icon": 40749,
			"describe": "【蘑菇小酥】",
			"command": "/物品 蘑菇小酥"
		},
		{
			"id": 2001,
			"type": 1,
			"school": 0,
			"icon": 20130,
			"describe": "【蜂蜜布丁】",
			"command": "/物品 蜂蜜布丁"
		},
		{
			"id": 2002,
			"type": 1,
			"school": 0,
			"icon": 40756,
			"describe": "【樱花红豆羹】",
			"command": "/物品 樱花红豆羹"
		},
		{
			"id": 2003,
			"type": 1,
			"school": 0,
			"icon": 40745,
			"describe": "【祭海饮】",
			"command": "/物品 祭海饮"
		},
		{
			"id": 2004,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【澜江酿】",
			"command": "/物品 澜江酿"
		},
		{
			"id": 2005,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【活络散】",
			"command": "/物品 活络散"
		},
		{
			"id": 2006,
			"type": 1,
			"school": 0,
			"icon": 40156,
			"describe": "【椰子烈酒】",
			"command": "/物品 椰子烈酒"
		},
		{
			"id": 2007,
			"type": 1,
			"school": 0,
			"icon": 40764,
			"describe": "【西米桃浆】",
			"command": "/物品 西米桃浆"
		},
		{
			"id": 2008,
			"type": 1,
			"school": 0,
			"icon": 40175,
			"describe": "【圣品玉露丹】",
			"command": "/物品 圣品玉露丹"
		},
		{
			"id": 2009,
			"type": 1,
			"school": 0,
			"icon": 50114,
			"describe": "【凡品秘贴丹】",
			"command": "/物品 凡品秘贴丹"
		},
		{
			"id": 2010,
			"type": 1,
			"school": 0,
			"icon": 30508,
			"describe": "【精品秘贴丹】",
			"command": "/物品 精品秘贴丹"
		},
		{
			"id": 2011,
			"type": 1,
			"school": 0,
			"icon": 40689,
			"describe": "【圣品秘贴丹】",
			"command": "/物品 圣品秘贴丹"
		},
		{
			"id": 2012,
			"type": 1,
			"school": 0,
			"icon": 40682,
			"describe": "【凡品青麟丹】",
			"command": "/物品 凡品青麟丹"
		},
		{
			"id": 2013,
			"type": 1,
			"school": 0,
			"icon": 40690,
			"describe": "【精品青麟丹】",
			"command": "/物品 精品青麟丹"
		},
		{
			"id": 2014,
			"type": 1,
			"school": 0,
			"icon": 40755,
			"describe": "【明前甘露】",
			"command": "/物品 明前甘露"
		},
		{
			"id": 2015,
			"type": 1,
			"school": 0,
			"icon": 40156,
			"describe": "【新茶气津】",
			"command": "/物品 新茶气津"
		},
		{
			"id": 2016,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【雨前气津】",
			"command": "/物品 雨前气津"
		},
		{
			"id": 2017,
			"type": 1,
			"school": 0,
			"icon": 40747,
			"describe": "【明前气津】",
			"command": "/物品 明前气津"
		},
		{
			"id": 2018,
			"type": 1,
			"school": 0,
			"icon": 40737,
			"describe": "【新茶凝香】",
			"command": "/物品 新茶凝香"
		},
		{
			"id": 2019,
			"type": 1,
			"school": 0,
			"icon": 40757,
			"describe": "【雨前凝香】",
			"command": "/物品 雨前凝香"
		},
		{
			"id": 2020,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【星落酒】",
			"command": "/物品 星落酒"
		},
		{
			"id": 2021,
			"type": 1,
			"school": 0,
			"icon": 40661,
			"describe": "【天神酒】",
			"command": "/物品 天神酒"
		},
		{
			"id": 2022,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【杏花酿】",
			"command": "/物品 杏花酿"
		},
		{
			"id": 2023,
			"type": 1,
			"school": 0,
			"icon": 20105,
			"describe": "【仙菇药剂】",
			"command": "/物品 仙菇药剂"
		},
		{
			"id": 2024,
			"type": 1,
			"school": 0,
			"icon": 20161,
			"describe": "【永恒酒·初】",
			"command": "/物品 永恒酒·初"
		},
		{
			"id": 2025,
			"type": 1,
			"school": 0,
			"icon": 20162,
			"describe": "【轮回酿·初】",
			"command": "/物品 轮回酿·初"
		},
		{
			"id": 2026,
			"type": 1,
			"school": 0,
			"icon": 20165,
			"describe": "【混沌饮·初】",
			"command": "/物品 混沌饮·初"
		},
		{
			"id": 2027,
			"type": 1,
			"school": 0,
			"icon": 20161,
			"describe": "【永恒酒·高】",
			"command": "/物品 永恒酒·高"
		},
		{
			"id": 2028,
			"type": 1,
			"school": 0,
			"icon": 20162,
			"describe": "【轮回酿·高】",
			"command": "/物品 轮回酿·高"
		},
		{
			"id": 2029,
			"type": 1,
			"school": 0,
			"icon": 20165,
			"describe": "【混沌饮·高】",
			"command": "/物品 混沌饮·高"
		},
		{
			"id": 2030,
			"type": 1,
			"school": 0,
			"icon": 20165,
			"describe": "【天怒饮】",
			"command": "/物品 天怒饮"
		},
		{
			"id": 2031,
			"type": 1,
			"school": 0,
			"icon": 40825,
			"describe": "【微弱火元素】",
			"command": "/物品 微弱火元素"
		},
		{
			"id": 2032,
			"type": 1,
			"school": 0,
			"icon": 40825,
			"describe": "【中性火元素】",
			"command": "/物品 中性火元素"
		},
		{
			"id": 2033,
			"type": 1,
			"school": 0,
			"icon": 40825,
			"describe": "【烈性火元素】",
			"command": "/物品 烈性火元素"
		},
		{
			"id": 2034,
			"type": 1,
			"school": 0,
			"icon": 40825,
			"describe": "【微弱赤炎元素】",
			"command": "/物品 微弱赤炎元素"
		},
		{
			"id": 2035,
			"type": 1,
			"school": 0,
			"icon": 40825,
			"describe": "【中性赤炎元素】",
			"command": "/物品 中性赤炎元素"
		},
		{
			"id": 2036,
			"type": 1,
			"school": 0,
			"icon": 40823,
			"describe": "【微弱水元素】",
			"command": "/物品 微弱水元素"
		},
		{
			"id": 2037,
			"type": 1,
			"school": 0,
			"icon": 40823,
			"describe": "【中性水元素】",
			"command": "/物品 中性水元素"
		},
		{
			"id": 2038,
			"type": 1,
			"school": 0,
			"icon": 40823,
			"describe": "【烈性水元素】",
			"command": "/物品 烈性水元素"
		},
		{
			"id": 2039,
			"type": 1,
			"school": 0,
			"icon": 40823,
			"describe": "【微弱碧波元素】",
			"command": "/物品 微弱碧波元素"
		},
		{
			"id": 2040,
			"type": 1,
			"school": 0,
			"icon": 40823,
			"describe": "【中性碧波元素】",
			"command": "/物品 中性碧波元素"
		},
		{
			"id": 2041,
			"type": 1,
			"school": 0,
			"icon": 40819,
			"describe": "【微弱金元素】",
			"command": "/物品 微弱金元素"
		},
		{
			"id": 2042,
			"type": 1,
			"school": 0,
			"icon": 40819,
			"describe": "【中性金元素】",
			"command": "/物品 中性金元素"
		},
		{
			"id": 2043,
			"type": 1,
			"school": 0,
			"icon": 40819,
			"describe": "【烈性金元素】",
			"command": "/物品 烈性金元素"
		},
		{
			"id": 2044,
			"type": 1,
			"school": 0,
			"icon": 40819,
			"describe": "【微弱疾影元素】",
			"command": "/物品 微弱疾影元素"
		},
		{
			"id": 2045,
			"type": 1,
			"school": 0,
			"icon": 40819,
			"describe": "【中性疾影元素】",
			"command": "/物品 中性疾影元素"
		},
		{
			"id": 2046,
			"type": 1,
			"school": 0,
			"icon": 40821,
			"describe": "【微弱土元素】",
			"command": "/物品 微弱土元素"
		},
		{
			"id": 2047,
			"type": 1,
			"school": 0,
			"icon": 40821,
			"describe": "【中性土元素】",
			"command": "/物品 中性土元素"
		},
		{
			"id": 2048,
			"type": 1,
			"school": 0,
			"icon": 40821,
			"describe": "【烈性土元素】",
			"command": "/物品 烈性土元素"
		},
		{
			"id": 2049,
			"type": 1,
			"school": 0,
			"icon": 40821,
			"describe": "【微弱坚石元素】",
			"command": "/物品 微弱坚石元素"
		},
		{
			"id": 2050,
			"type": 1,
			"school": 0,
			"icon": 40821,
			"describe": "【中性坚石元素】",
			"command": "/物品 中性坚石元素"
		},
		{
			"id": 2051,
			"type": 1,
			"school": 0,
			"icon": 40816,
			"describe": "【微弱木元素】",
			"command": "/物品 微弱木元素"
		},
		{
			"id": 2052,
			"type": 1,
			"school": 0,
			"icon": 40816,
			"describe": "【中性木元素】",
			"command": "/物品 中性木元素"
		},
		{
			"id": 2053,
			"type": 1,
			"school": 0,
			"icon": 40816,
			"describe": "【烈性木元素】",
			"command": "/物品 烈性木元素"
		},
		{
			"id": 2054,
			"type": 1,
			"school": 0,
			"icon": 40816,
			"describe": "【微弱元灵元素】",
			"command": "/物品 微弱元灵元素"
		},
		{
			"id": 2055,
			"type": 1,
			"school": 0,
			"icon": 40816,
			"describe": "【中性元灵元素】",
			"command": "/物品 中性元灵元素"
		},
		{
			"id": 2056,
			"type": 1,
			"school": 0,
			"icon": 40707,
			"describe": "【凡品乾金药剂】",
			"command": "/物品 凡品乾金药剂"
		},
		{
			"id": 2057,
			"type": 1,
			"school": 0,
			"icon": 40707,
			"describe": "【精品乾金药剂】",
			"command": "/物品 精品乾金药剂"
		},
		{
			"id": 2058,
			"type": 1,
			"school": 0,
			"icon": 40707,
			"describe": "【圣品乾金药剂】",
			"command": "/物品 圣品乾金药剂"
		},
		{
			"id": 2059,
			"type": 1,
			"school": 0,
			"icon": 40707,
			"describe": "【凡品坤木药剂】",
			"command": "/物品 凡品坤木药剂"
		},
		{
			"id": 2060,
			"type": 1,
			"school": 0,
			"icon": 40707,
			"describe": "【精品坤木药剂】",
			"command": "/物品 精品坤木药剂"
		},
		{
			"id": 2061,
			"type": 1,
			"school": 0,
			"icon": 40708,
			"describe": "【凡品静心药剂】",
			"command": "/物品 凡品静心药剂"
		},
		{
			"id": 2062,
			"type": 1,
			"school": 0,
			"icon": 40708,
			"describe": "【精品静心药剂】",
			"command": "/物品 精品静心药剂"
		},
		{
			"id": 2063,
			"type": 1,
			"school": 0,
			"icon": 40708,
			"describe": "【圣品静心药剂】",
			"command": "/物品 圣品静心药剂"
		},
		{
			"id": 2064,
			"type": 1,
			"school": 0,
			"icon": 40708,
			"describe": "【凡品凝神药剂】",
			"command": "/物品 凡品凝神药剂"
		},
		{
			"id": 2065,
			"type": 1,
			"school": 0,
			"icon": 40708,
			"describe": "【精品凝神药剂】",
			"command": "/物品 精品凝神药剂"
		},
		{
			"id": 2066,
			"type": 1,
			"school": 0,
			"icon": 40710,
			"describe": "【凡品强力药剂】",
			"command": "/物品 凡品强力药剂"
		},
		{
			"id": 2067,
			"type": 1,
			"school": 0,
			"icon": 40710,
			"describe": "【精品强力药剂】",
			"command": "/物品 精品强力药剂"
		},
		{
			"id": 2068,
			"type": 1,
			"school": 0,
			"icon": 40710,
			"describe": "【圣品强力药剂】",
			"command": "/物品 圣品强力药剂"
		},
		{
			"id": 2069,
			"type": 1,
			"school": 0,
			"icon": 40710,
			"describe": "【凡品离火药剂】",
			"command": "/物品 凡品离火药剂"
		},
		{
			"id": 2070,
			"type": 1,
			"school": 0,
			"icon": 40710,
			"describe": "【精品离火药剂】",
			"command": "/物品 精品离火药剂"
		},
		{
			"id": 2071,
			"type": 1,
			"school": 0,
			"icon": 40711,
			"describe": "【凡品启智药剂】",
			"command": "/物品 凡品启智药剂"
		},
		{
			"id": 2072,
			"type": 1,
			"school": 0,
			"icon": 40711,
			"describe": "【精品启智药剂】",
			"command": "/物品 精品启智药剂"
		},
		{
			"id": 2073,
			"type": 1,
			"school": 0,
			"icon": 40711,
			"describe": "【圣品启智药剂】",
			"command": "/物品 圣品启智药剂"
		},
		{
			"id": 2074,
			"type": 1,
			"school": 0,
			"icon": 40711,
			"describe": "【凡品睿智药剂】",
			"command": "/物品 凡品睿智药剂"
		},
		{
			"id": 2075,
			"type": 1,
			"school": 0,
			"icon": 40711,
			"describe": "【精品睿智药剂】",
			"command": "/物品 精品睿智药剂"
		},
		{
			"id": 2076,
			"type": 1,
			"school": 0,
			"icon": 40719,
			"describe": "【凡品暴烈药剂】",
			"command": "/物品 凡品暴烈药剂"
		},
		{
			"id": 2077,
			"type": 1,
			"school": 0,
			"icon": 40719,
			"describe": "【精品暴烈药剂】",
			"command": "/物品 精品暴烈药剂"
		},
		{
			"id": 2078,
			"type": 1,
			"school": 0,
			"icon": 40719,
			"describe": "【圣品暴烈药剂】",
			"command": "/物品 圣品暴烈药剂"
		},
		{
			"id": 2079,
			"type": 1,
			"school": 0,
			"icon": 40719,
			"describe": "【凡品雷吼药剂】",
			"command": "/物品 凡品雷吼药剂"
		},
		{
			"id": 2080,
			"type": 1,
			"school": 0,
			"icon": 40719,
			"describe": "【精品雷吼药剂】",
			"command": "/物品 精品雷吼药剂"
		},
		{
			"id": 2081,
			"type": 1,
			"school": 0,
			"icon": 40720,
			"describe": "【凡品锐气药剂】",
			"command": "/物品 凡品锐气药剂"
		},
		{
			"id": 2082,
			"type": 1,
			"school": 0,
			"icon": 40720,
			"describe": "【精品锐气药剂】",
			"command": "/物品 精品锐气药剂"
		},
		{
			"id": 2083,
			"type": 1,
			"school": 0,
			"icon": 40720,
			"describe": "【圣品锐气药剂】",
			"command": "/物品 圣品锐气药剂"
		},
		{
			"id": 2084,
			"type": 1,
			"school": 0,
			"icon": 40720,
			"describe": "【凡品震怒药剂】",
			"command": "/物品 凡品震怒药剂"
		},
		{
			"id": 2085,
			"type": 1,
			"school": 0,
			"icon": 40720,
			"describe": "【精品震怒药剂】",
			"command": "/物品 精品震怒药剂"
		},
		{
			"id": 2086,
			"type": 1,
			"school": 0,
			"icon": 40685,
			"describe": "【凡品锐眼药剂】",
			"command": "/物品 凡品锐眼药剂"
		},
		{
			"id": 2087,
			"type": 1,
			"school": 0,
			"icon": 40685,
			"describe": "【精品锐眼药剂】",
			"command": "/物品 精品锐眼药剂"
		},
		{
			"id": 2088,
			"type": 1,
			"school": 0,
			"icon": 40685,
			"describe": "【圣品锐眼药剂】",
			"command": "/物品 圣品锐眼药剂"
		},
		{
			"id": 2089,
			"type": 1,
			"school": 0,
			"icon": 40685,
			"describe": "【凡品精准药剂】",
			"command": "/物品 凡品精准药剂"
		},
		{
			"id": 2090,
			"type": 1,
			"school": 0,
			"icon": 40685,
			"describe": "【精品精准药剂】",
			"command": "/物品 精品精准药剂"
		},
		{
			"id": 2091,
			"type": 1,
			"school": 0,
			"icon": 40709,
			"describe": "【凡品兑泽药剂】",
			"command": "/物品 凡品兑泽药剂"
		},
		{
			"id": 2092,
			"type": 1,
			"school": 0,
			"icon": 40709,
			"describe": "【精品兑泽药剂】",
			"command": "/物品 精品兑泽药剂"
		},
		{
			"id": 2093,
			"type": 1,
			"school": 0,
			"icon": 40709,
			"describe": "【圣品兑泽药剂】",
			"command": "/物品 圣品兑泽药剂"
		},
		{
			"id": 2094,
			"type": 1,
			"school": 0,
			"icon": 40709,
			"describe": "【凡品艮山药剂】",
			"command": "/物品 凡品艮山药剂"
		},
		{
			"id": 2095,
			"type": 1,
			"school": 0,
			"icon": 40709,
			"describe": "【精品艮山药剂】",
			"command": "/物品 精品艮山药剂"
		},
		{
			"id": 2096,
			"type": 1,
			"school": 0,
			"icon": 306401,
			"describe": "【杂鱼菜汤】",
			"command": "/物品 杂鱼菜汤"
		},
		{
			"id": 2097,
			"type": 1,
			"school": 0,
			"icon": 306402,
			"describe": "【肉夹馍】",
			"command": "/物品 肉夹馍"
		},
		{
			"id": 2098,
			"type": 1,
			"school": 0,
			"icon": 40726,
			"describe": "【鱼脊炖豆腐】",
			"command": "/物品 鱼脊炖豆腐"
		},
		{
			"id": 2099,
			"type": 1,
			"school": 0,
			"icon": 306404,
			"describe": "【银月刺身】",
			"command": "/物品 银月刺身"
		},
		{
			"id": 2100,
			"type": 1,
			"school": 0,
			"icon": 306405,
			"describe": "【精炖灵鱼羹】",
			"command": "/物品 精炖灵鱼羹"
		},
		{
			"id": 2101,
			"type": 1,
			"school": 0,
			"icon": 306411,
			"describe": "【香酥鱼排】",
			"command": "/物品 香酥鱼排"
		},
		{
			"id": 2102,
			"type": 1,
			"school": 0,
			"icon": 306412,
			"describe": "【一点红砂锅】",
			"command": "/物品 一点红砂锅"
		},
		{
			"id": 2103,
			"type": 1,
			"school": 0,
			"icon": 306413,
			"describe": "【清蒸娃娃鱼】",
			"command": "/物品 清蒸娃娃鱼"
		},
		{
			"id": 2104,
			"type": 1,
			"school": 0,
			"icon": 306414,
			"describe": "【香菇鸡肉嫩鱼汤】",
			"command": "/物品 香菇鸡肉嫩鱼汤"
		},
		{
			"id": 2105,
			"type": 1,
			"school": 0,
			"icon": 306415,
			"describe": "【果木烤猪腿】",
			"command": "/物品 果木烤猪腿"
		},
		{
			"id": 2106,
			"type": 1,
			"school": 0,
			"icon": 40733,
			"describe": "【老参炖鸡汤】",
			"command": "/物品 老参炖鸡汤"
		},
		{
			"id": 2107,
			"type": 1,
			"school": 0,
			"icon": 306432,
			"describe": "【水晶鱼翅羹】",
			"command": "/物品 水晶鱼翅羹"
		},
		{
			"id": 2108,
			"type": 1,
			"school": 0,
			"icon": 306433,
			"describe": "【葱姜啤酒鸡】",
			"command": "/物品 葱姜啤酒鸡"
		},
		{
			"id": 2109,
			"type": 1,
			"school": 0,
			"icon": 306434,
			"describe": "【天麻猪脑汤】",
			"command": "/物品 天麻猪脑汤"
		},
		{
			"id": 2110,
			"type": 1,
			"school": 0,
			"icon": 306435,
			"describe": "【悲风原汁鲟鱼汤】",
			"command": "/物品 悲风原汁鲟鱼汤"
		},
		{
			"id": 2111,
			"type": 1,
			"school": 0,
			"icon": 40698,
			"describe": "【砥石鸡公煲】",
			"command": "/物品 砥石鸡公煲"
		},
		{
			"id": 2112,
			"type": 1,
			"school": 0,
			"icon": 40694,
			"describe": "【浓香大骨汤】",
			"command": "/物品 浓香大骨汤"
		},
		{
			"id": 2113,
			"type": 1,
			"school": 0,
			"icon": 306443,
			"describe": "【酒香麻辣猪肉煲】",
			"command": "/物品 酒香麻辣猪肉煲"
		},
		{
			"id": 2114,
			"type": 1,
			"school": 0,
			"icon": 306444,
			"describe": "【旗鱼三吃】",
			"command": "/物品 旗鱼三吃"
		},
		{
			"id": 2115,
			"type": 1,
			"school": 0,
			"icon": 306445,
			"describe": "【劲辣蜜汁羊腿】",
			"command": "/物品 劲辣蜜汁羊腿"
		},
		{
			"id": 2116,
			"type": 1,
			"school": 0,
			"icon": 306451,
			"describe": "【苏澜炒饭】",
			"command": "/物品 苏澜炒饭"
		},
		{
			"id": 2117,
			"type": 1,
			"school": 0,
			"icon": 40718,
			"describe": "【菌王汤】",
			"command": "/物品 菌王汤"
		},
		{
			"id": 2118,
			"type": 1,
			"school": 0,
			"icon": 306453,
			"describe": "【万家灯火】",
			"command": "/物品 万家灯火"
		},
		{
			"id": 2119,
			"type": 1,
			"school": 0,
			"icon": 306454,
			"describe": "【山之珍】",
			"command": "/物品 山之珍"
		},
		{
			"id": 2120,
			"type": 1,
			"school": 0,
			"icon": 306455,
			"describe": "【剁椒鱼头】",
			"command": "/物品 剁椒鱼头"
		},
		{
			"id": 2121,
			"type": 1,
			"school": 0,
			"icon": 306461,
			"describe": "【肥牛盖浇饭】",
			"command": "/物品 肥牛盖浇饭"
		},
		{
			"id": 2122,
			"type": 1,
			"school": 0,
			"icon": 306462,
			"describe": "【卤煮火烧】",
			"command": "/物品 卤煮火烧"
		},
		{
			"id": 2123,
			"type": 1,
			"school": 0,
			"icon": 306463,
			"describe": "【千层鱼肉酥】",
			"command": "/物品 千层鱼肉酥"
		},
		{
			"id": 2124,
			"type": 1,
			"school": 0,
			"icon": 306464,
			"describe": "【海之味】",
			"command": "/物品 海之味"
		},
		{
			"id": 2125,
			"type": 1,
			"school": 0,
			"icon": 306465,
			"describe": "【狂野腊肉】",
			"command": "/物品 狂野腊肉"
		},
		{
			"id": 2126,
			"type": 1,
			"school": 0,
			"icon": 306421,
			"describe": "【鳗鱼笋汤】",
			"command": "/物品 鳗鱼笋汤"
		},
		{
			"id": 2127,
			"type": 1,
			"school": 0,
			"icon": 306422,
			"describe": "【铁板鱿鱼】",
			"command": "/物品 铁板鱿鱼"
		},
		{
			"id": 2128,
			"type": 1,
			"school": 0,
			"icon": 306423,
			"describe": "【蒜香白肉】",
			"command": "/物品 蒜香白肉"
		},
		{
			"id": 2129,
			"type": 1,
			"school": 0,
			"icon": 306424,
			"describe": "【生炒鲶须】",
			"command": "/物品 生炒鲶须"
		},
		{
			"id": 2130,
			"type": 1,
			"school": 0,
			"icon": 306425,
			"describe": "【土豆炖牛肉】",
			"command": "/物品 土豆炖牛肉"
		},
		{
			"id": 2131,
			"type": 1,
			"school": 0,
			"icon": 40750,
			"describe": "【新酿灵龟酒】",
			"command": "/物品 新酿灵龟酒"
		},
		{
			"id": 2132,
			"type": 1,
			"school": 0,
			"icon": 40750,
			"describe": "【佳酿灵龟酒】",
			"command": "/物品 佳酿灵龟酒"
		},
		{
			"id": 2133,
			"type": 1,
			"school": 0,
			"icon": 40750,
			"describe": "【百年灵龟酒】",
			"command": "/物品 百年灵龟酒"
		},
		{
			"id": 2134,
			"type": 1,
			"school": 0,
			"icon": 40750,
			"describe": "【新酿金刚酒】",
			"command": "/物品 新酿金刚酒"
		},
		{
			"id": 2135,
			"type": 1,
			"school": 0,
			"icon": 40750,
			"describe": "【佳酿金刚酒】",
			"command": "/物品 佳酿金刚酒"
		},
		{
			"id": 2136,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【新酿虎骨酒】",
			"command": "/物品 新酿虎骨酒"
		},
		{
			"id": 2137,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【佳酿虎骨酒】",
			"command": "/物品 佳酿虎骨酒"
		},
		{
			"id": 2138,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【百年虎骨酒】",
			"command": "/物品 百年虎骨酒"
		},
		{
			"id": 2139,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【新酿铁骑酒】",
			"command": "/物品 新酿铁骑酒"
		},
		{
			"id": 2140,
			"type": 1,
			"school": 0,
			"icon": 40752,
			"describe": "【佳酿铁骑酒】",
			"command": "/物品 佳酿铁骑酒"
		},
		{
			"id": 2141,
			"type": 1,
			"school": 0,
			"icon": 40753,
			"describe": "【新酿西风列酒】",
			"command": "/物品 新酿西风列酒"
		},
		{
			"id": 2142,
			"type": 1,
			"school": 0,
			"icon": 40753,
			"describe": "【佳酿西风列酒】",
			"command": "/物品 佳酿西风列酒"
		},
		{
			"id": 2143,
			"type": 1,
			"school": 0,
			"icon": 40753,
			"describe": "【百年西风列酒】",
			"command": "/物品 百年西风列酒"
		},
		{
			"id": 2144,
			"type": 1,
			"school": 0,
			"icon": 40753,
			"describe": "【新酿金戈酒】",
			"command": "/物品 新酿金戈酒"
		},
		{
			"id": 2145,
			"type": 1,
			"school": 0,
			"icon": 40753,
			"describe": "【佳酿金戈酒】",
			"command": "/物品 佳酿金戈酒"
		},
		{
			"id": 2146,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【新酿虎啸酒】",
			"command": "/物品 新酿虎啸酒"
		},
		{
			"id": 2147,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【佳酿虎啸酒】",
			"command": "/物品 佳酿虎啸酒"
		},
		{
			"id": 2148,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【百年虎啸酒】",
			"command": "/物品 百年虎啸酒"
		},
		{
			"id": 2149,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【新酿龙吟酒】",
			"command": "/物品 新酿龙吟酒"
		},
		{
			"id": 2150,
			"type": 1,
			"school": 0,
			"icon": 40748,
			"describe": "【佳酿龙吟酒】",
			"command": "/物品 佳酿龙吟酒"
		},
		{
			"id": 2151,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【新酿破阵酒】",
			"command": "/物品 新酿破阵酒"
		},
		{
			"id": 2152,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【佳酿破阵酒】",
			"command": "/物品 佳酿破阵酒"
		},
		{
			"id": 2153,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【百年破阵酒】",
			"command": "/物品 百年破阵酒"
		},
		{
			"id": 2154,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【新酿铁靴酒】",
			"command": "/物品 新酿铁靴酒"
		},
		{
			"id": 2155,
			"type": 1,
			"school": 0,
			"icon": 40751,
			"describe": "【佳酿铁靴酒】",
			"command": "/物品 佳酿铁靴酒"
		},
		{
			"id": 2156,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【新酿霜雪明酒】",
			"command": "/物品 新酿霜雪明酒"
		},
		{
			"id": 2157,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【佳酿霜雪明酒】",
			"command": "/物品 佳酿霜雪明酒"
		},
		{
			"id": 2158,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【百年霜雪明酒】",
			"command": "/物品 百年霜雪明酒"
		},
		{
			"id": 2159,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【新酿流云破酒】",
			"command": "/物品 新酿流云破酒"
		},
		{
			"id": 2160,
			"type": 1,
			"school": 0,
			"icon": 40754,
			"describe": "【佳酿流云破酒】",
			"command": "/物品 佳酿流云破酒"
		},
		{
			"id": 2161,
			"type": 1,
			"school": 0,
			"icon": 40738,
			"describe": "【新酿无妄酒】",
			"command": "/物品 新酿无妄酒"
		},
		{
			"id": 2162,
			"type": 1,
			"school": 0,
			"icon": 40738,
			"describe": "【佳酿无妄酒】",
			"command": "/物品 佳酿无妄酒"
		},
		{
			"id": 2163,
			"type": 1,
			"school": 0,
			"icon": 40738,
			"describe": "【百年无妄酒】",
			"command": "/物品 百年无妄酒"
		},
		{
			"id": 2164,
			"type": 1,
			"school": 0,
			"icon": 40738,
			"describe": "【新酿无虚酒】",
			"command": "/物品 新酿无虚酒"
		},
		{
			"id": 2165,
			"type": 1,
			"school": 0,
			"icon": 40738,
			"describe": "【佳酿无虚酒】",
			"command": "/物品 佳酿无虚酒"
		},
		{
			"id": 3002,
			"type": 2,
			"school": 0,
			"icon": "1002",
			"describe": "【怒】",
			"command": "/动作 怒"
		},
		{
			"id": 3003,
			"type": 2,
			"school": 0,
			"icon": "1003",
			"describe": "【流汗】",
			"command": "/动作 流汗"
		},
		{
			"id": 3004,
			"type": 2,
			"school": 0,
			"icon": "1004",
			"describe": "【无语】",
			"command": "/动作 无语"
		},
		{
			"id": 3005,
			"type": 2,
			"school": 0,
			"icon": "1005",
			"describe": "【示爱】",
			"command": "/动作 示爱"
		},
		{
			"id": 3006,
			"type": 2,
			"school": 0,
			"icon": "1006",
			"describe": "【吃惊】",
			"command": "/动作 吃惊"
		},
		{
			"id": 3007,
			"type": 2,
			"school": 0,
			"icon": "1007",
			"describe": "【心碎】",
			"command": "/动作 心碎"
		},
		{
			"id": 3008,
			"type": 2,
			"school": 0,
			"icon": "general_1001",
			"describe": "【骑乘】",
			"command": "/动作 骑乘"
		},
		{
			"id": 3009,
			"type": 2,
			"school": 0,
			"icon": "general_2001",
			"describe": "【展翅】",
			"command": "/动作 展翅"
		},
		{
			"id": 4002,
			"type": 3,
			"school": 0,
			"icon": 37,
			"describe": "【附近频道】喊话",
			"command": "/喊话 附近 喊话内容"
		},
		{
			"id": 4005,
			"type": 3,
			"school": 0,
			"icon": 37,
			"describe": "【队伍频道】喊话",
			"command": "/喊话 队伍 喊话内容"
		},
		{
			"id": 4006,
			"type": 3,
			"school": 0,
			"icon": 37,
			"describe": "【团队频道】喊话",
			"command": "/喊话 团队 喊话内容"
		}
	];
	module.exports=skillData;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var common=__webpack_require__(2);
	common.init();
	var search={
		init:function(){
			$(".searchBtn").click(function(){
				var txt=$(".searchIpt").val();
				if(!txt.match(/^[0-9]*$/)){
					common.showCommonPop("请输入技能宏ID进行搜索查找");
					return;
				}
				$.getJSON("/skillmacros/getById.json?id="+txt,function(msg){
					if(msg.resCode!=0){
						// common.showCommonPop(msg.resReason);
						common.showCommonPop("缺少该ID的技能宏，请重新查找");
						return;
					}
					window.location.href="/skillmacros/detail?id="+txt;
				})
			})
		}
	}
	search.init();
	module.exports=search;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// detail.js